/*
 * Copyright (c)  2020 CalAmp Corp.  All Rights Reserved
 */
import {AxiosInstance, AxiosRequestConfig} from 'axios';
import isEmpty from 'lodash.isempty';
import isNil from 'lodash.isnil';
import isUndefined from 'lodash.isundefined';
import sortby from 'lodash.sortby';
import qs from 'qs';
import {
  AddExistingPidRequest,
  BulkTpmsSensorPairingRequest,
  BulkTpmsSensorPairingResponse,
  CMSDevice,
  DeleteInspectionImageParams,
  EmissionTester,
  HierLevel,
  LoadBusProfilesParams,
  LoadComplianceDashboardParams,
  LoadComplianceDashboardResult,
  LoadContinuousMonitoringParams,
  LoadContinuousMonitoringResult,
  LoadInspectionFormParams,
  LoadInspectionResultsParams,
  LoadInspectionTemplatesParams,
  LoadInspectionVehicleParams,
  LoadManufacturedDevicesParams,
  LoadProfileVehiclesParams,
  LoadProfileVehiclesResult,
  LoadTestHistoryParams,
  LoadTestHistoryResult,
  RemoveBusProfileRequest,
  ServiceURL,
  SubmitNSTOperationRequest,
  UploadInspectionImageParams,
  VehicleDiscoveryAggregationsResponse,
  VehicleDiscoverySearchParams,
  VehicleDiscoverySearchResult,
  VehicleMatchParams,
  VehicleProfileEntity,
  ViewInspectionImageParams
} from '@ion/core/src/types/services';
import {get} from '../environment/environment';
import {error} from '../logger/logger';
import {
  Account,
  AEMPConfig,
  AlertAction,
  AlertActionTemplate,
  AlertActionType,
  AlertNotification,
  AlertTrigger,
  AlertType,
  Application,
  ApplicationIds,
  Applications,
  Asset,
  Assets,
  AssetType,
  AvlEventUuid,
  BulkAssetsResponse,
  BulkDevicesResponse,
  BulkEntityOperation,
  BulkGroupsResponse,
  CarrierPartNumber,
  CarrierPartNumbers,
  ClonedPegBehavior,
  Contact,
  CreateJob,
  CTCEntity,
  CTCEntityResponseWrapper,
  Device,
  DeviceConfiguration,
  DeviceFile,
  DevicePartNumber,
  DevicePartNumbers,
  Devices,
  DeviceServices,
  DeviceType,
  DmUnit,
  DownloadJob,
  Entity,
  EntityStatus,
  ExtendedAttribute,
  GenericObject,
  Group,
  GroupMembers,
  HardwarePart,
  HardwarePartType,
  HVSRecord,
  IOProfile,
  IOProfiles,
  JobStatus,
  KeyfileBuilderInterface,
  Link,
  Links,
  MaintainDeviceFileRequest,
  ManufacturedDeviceDetails,
  ManufacturingCarrier,
  MessageEndpoint,
  ModBus,
  ModBusConfigs,
  ModBusParameter,
  ModBusParameters,
  Notification,
  Notifications,
  NotificationType,
  OperationTask,
  Operator,
  Operators,
  PasswordChange,
  Peg2ModuleProfile,
  Peg2ModuleProfileParams,
  PegAccumulator,
  PegBehavior,
  PegBehaviorIncludes,
  PegEvent,
  PegEvents,
  PegLabel,
  PegLabels,
  PegWizardAssemblyRequest,
  PegWizardMetadata,
  PegWizardPublishRequest,
  PegWizardScript,
  Permissions,
  Role,
  Roles,
  Route,
  Schedule,
  Schedules,
  ServiceProfile,
  Shipment,
  SSOConfiguration,
  Subscription,
  systemOfUnit,
  UploadUrlParams,
  User,
  Users,
  Vehicle
} from '../types/entities';
import {
  AccountsSearchIncludes,
  SearchTerm
} from '../types/general';
import {
  EnableFactorResponse,
  EnrollFactorResponse,
  LoginResult,
  MfaProvider,
  ResetMfaResponse,
  SubmitTotpResponse,
  TotpFactorType
} from '../types/mfa';
import {
  AccountSearchableProperties,
  AlertTypeFilter,
  AssetFilter,
  AuditParams,
  AuditResults,
  BulkOperationParams,
  BulkOperationResults,
  CreateOfflineCanRequestPayload,
  DeviceCommunicationSearchTypes,
  DeviceConnectionStateResult,
  DeviceSearchTypes,
  DVRSearchPayload,
  DVRUploadRequestPayload,
  GetDTCCodesParams,
  GetIONVisionDetailsParams,
  JobConflictParams,
  JobSearchEngineParams,
  LoadAccountsParams,
  LoadAccountsResponse,
  LoadAccountsResult,
  LoadAEMPConfigParams,
  LoadAEMPConfigResponse,
  LoadAEMPConfigResult,
  LoadAlertsNotificationParams,
  LoadAlertsNotificationResponse,
  LoadAlertsNotificationResult,
  LoadApplicationIdsParams,
  LoadApplicationsParams,
  LoadApplicationsResponse,
  LoadApplicationsResult,
  LoadAssetsParams,
  LoadAssetsResponse,
  LoadAssetsResult,
  LoadBulkEntitiesResult,
  LoadCrashBoxxEventsParams,
  LoadDeviceConfigsParams,
  LoadDeviceConfigsResponse,
  LoadDeviceConfigsResult,
  LoadDeviceFilesParams,
  LoadDeviceFilesResult,
  LoadDevicePartNumbersParams,
  LoadDevicesParams,
  LoadDevicesResponse,
  LoadDevicesResult,
  LoadDevicesStatusParams,
  LoadDevicesStatusResult,
  LoadDeviceTypesParams,
  LoadDeviceTypesResponse,
  LoadDeviceTypesResult,
  LoadDownloadJobsParams,
  LoadDownloadJobsResponse,
  LoadDownloadJobsResult,
  LoadEventsParams,
  LoadEventsResponse,
  LoadEventsResult,
  LoadGroupResponse,
  LoadGroupResult,
  LoadGroupsParams,
  LoadInventoryDevicesParams,
  LoadIOProfilesParams,
  LoadIOProfilesResponse,
  LoadIOProfilesResult,
  LoadjobStatusParams,
  LoadjobStatusResponse,
  LoadjobStatusResult,
  LoadModBusConfigParams,
  LoadModBusConfigResult,
  LoadModBusParams,
  LoadModBusResult,
  LoadNotificationsParams,
  LoadNotificationTypeParams,
  LoadNotificationTypeResponse,
  LoadNotificationTypeResult,
  LoadOEMValidateParams,
  LoadOEMValidationResult,
  LoadOfflineCanRequestsParams,
  LoadOperatorsParams,
  LoadOperatorsResponse,
  LoadOperatorsResult,
  LoadParams,
  LoadPegBehaviorsParams,
  LoadPegBehaviorsResponse,
  LoadPegBehaviorsResult,
  LoadPegLabelsParams,
  LoadPegLabelsResponse,
  LoadPegLabelsResult,
  LoadPlatformDeviceTypesResult,
  LoadProfileManagerParams,
  LoadProfileManagerResult,
  LoadRolesParams,
  LoadRolesResponse,
  LoadRolesResult,
  LoadRoutesParams,
  LoadRoutesResponse,
  LoadRoutesResult,
  LoadSaveValidationParams,
  LoadSchedulesParams,
  LoadSchedulesResponse,
  LoadSchedulesResult,
  LoadTripsParams,
  LoadUsersParams,
  LoadUsersResponse,
  LoadUsersResult,
  LoadValidationRulesParams,
  LoadValidationRulesResult,
  LoadVehicleManagerParams,
  LoadVehicleManagerResult,
  MAX_RESULTS,
  OfflineCanApiResponse,
  OfflineCanRequestResult,
  OperatorFilter,
  ProfileSearchRequest,
  PromotePidsParams,
  PromotePidsParamsToProductionResult,
  ReplayOfflineCanRequestPayload,
  SearchPegBehaviorParams,
  SearchProfilesByIdParams,
  SearchVisionLoadParams,
  Service,
  SubtaskResult,
  TagTripsParams,
  UpdateOfflineCanRequestPayload,
  UpdateOfflineCanRequestResult,
  VideoSearchPayload
} from '../types/services';
import {safeJSONStringify} from '../utils/JSONUtils';
import {getQueryString, removeUndefined} from '../utils/ObjectUtil';
import {
  aggregateResults,
  chunkRequests,
  client,
  config,
  constructSearchTerms,
  createAlertNotificationSearchTerms,
  createClient,
  createJobSearchQuery,
  createJobSearchV3Params,
  createLoadBulkEntitiesURL,
  createLoadDeviceFilesRequest,
  createLoadSubtasksURL,
  createLoadTaskStatusURL,
  createManufacturingURL,
  entityId,
  fromNestedParameterValues,
  getAggregationsFromSearchType,
  getBulkOperationName,
  getDateTimeForSearchType,
  getEntityResourceURI,
  getFilterValue,
  getNoCacheHeaders,
  getSearchAfter,
  MANUFACTURING_AUX_VALUES,
  mapDeviceSearchResults,
  MAX_LIMIT,
  mergeAccounts,
  normalizeDates,
  normalizeIONVisionSearchParams,
  PAGE_LIMIT,
  parse,
  parseAssetsBulkCollection,
  parseCollection,
  parseExtendedAttributes,
  parseLoginResult,
  partitionBulkUpdates,
  propertyResolver,
  readIntermediateToken,
  resetCredentials,
  resolveAppKey,
  resolveAssetTools,
  resolveIOnVisionEvents,
  resolveRole,
  setAccountExtendedAttributes,
  setHierLevel,
  setMappedCategorySubType,
  setRel,
  url,
  vehicleProfileEnumURL
} from './ConnectUtils';
import {getSessionToken, invalidateSessionToken, setSessionToken} from './CTCAuthToken';
import {assignSchedule} from './Maintenance';
import {UserContext} from './MicroServices';

export enum DtcEventType {
  Jpod2DTCReport = 'jpod2DTCReport',
  DtcEvents = 'dtcEvent'
};

/**
 * The `authenticate` function sends a POST request to the '/login' endpoint with
 * the provided user credentials. If successful, the session token returned in the
 * response will be set to the `setSessionToken` function for subsequent validations.
 *
 * If the optional (appKey) is provided, it will be used in the request headers and
 * the internal `Connect` configuration `'calamp-services-app'` header will be updated
 * to the given `appKey`. This allows for dynamic, or runtime overrides of the appKey
 * so as to allow for authenticating against a different application that that which
 * has been specified in the configuration passed to `setConnectConfig`.
 *
 * ```typescript
 *  import {authenticate, currentUser} from '@ion/core/src/services/Connect';
 *  ...
 *
 *  try {
 *    const token = await authenticate('efeminella', 'password123');
 *    info(`Authentication Successful. Token: ${token}`);
 *  } catch (err) {
 *    error('Authentication Failed:', err?.toString());
 *  }
 *    const auth = await authenticate(username, password);
 *    const user = await currentUser();
 *
 * @param   username The `username` against which this user is to be authenticated.
 * @param   password The `password` against which this user is to be authenticated.
 * @param   appKey   An optional application key which specifies the application
 *          that is to be authenticated with. If provided, the `'calamp-services-app'`
 *          header will be updated to the value of the given `appKey`. If not provided,
 *          the default `'calamp-services-app'` header from the Connect configuration
 *          will be used.
 * @returns A `Promise` which resolves to the authToken (JWT, or CTC short-token)
 *          returned in the response.
 * ```
 */
export const authenticate = async(username: string, password: string, appKey?: string): Promise<any> => {
  const defaultAppKey = config.headers['calamp-services-app'];
  const result = await client({
    url     : url('/login'),
    method  : 'post',
    headers : {
      'calamp-services-app' : appKey || defaultAppKey,
      'Content-Type'        : 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data : qs.stringify({
      useAuthToken : true,
      include      : 'accessToken',
      password,
      username
    })
  });
  if (appKey && appKey !== defaultAppKey) {
    config.headers['calamp-services-app'] = appKey;
  }
  const token = parse(result, 'authToken') as unknown as string;
  if (token) {
    setSessionToken(token);
  }
  return token;
};

/**
 * The getOpenIdConfiguration method retrieves CTC's openid configuration.
 *
 * ```typescript
 *    import {getOpenIdConfiguration} from '@ion/core/src/services/Connect';
 *
 *    const config = await getOpenIdConfiguration(username, password);
 *
 * ```
 */
export const getOpenIdConfiguration = async(): Promise<any> => {
  const result = await client({
    withCredentials : false,
    url             : url('/.well-known/openid-configuration', Service.Base),
    method          : 'get'
  });
  return result?.data;
};

/**
 * @function getOpenIdUserInfo
 *
 * The getOpenIdUserInfo method, retrieves OIDC user's info.
 *
 * ```typescript
 *    import {getOpenIdUserInfo} from '@ion/core/src/services/Connect';
 *
 *    const config = await getOpenIdUserInfo(authorization);
 *
 * ```
 */
export const getOpenIdUserInfo = async(userinfoUrl: string, authorization: string): Promise<any> => {
  const result = await client({
    url     : userinfoUrl,
    method  : 'get',
    headers : {
      authorization
    }
  });
  return result?.data;
};

/**
 * @function login
 *
 * Defines an alias to the authenticate method.
 *
 * @see authenticate
 *
 * ```typescript
 *    import {login} from '@ion/core/src/services/Connect';
 *
 *    const auth = await login(username, password);
 *
 * ```
 */
export const login = authenticate;

/**
 * @function authenticateMfa
 *
 * A Multi-Factor Authentication (MFA) aware variant of `authenticate`. It issues the
 * same `POST /login` request but returns a structured `LoginResult` describing whether
 * the user is authenticated, must enroll a factor, or must answer a Time-based
 * One-time Password (TOTP) challenge. Unlike `authenticate`, it does NOT set the
 * session token; the caller sets it only once a valid `authToken` exists.
 *
 * ```typescript
 *    import {authenticateMfa} from '@ion/core/src/services/Connect';
 *    ...
 *    const result = await authenticateMfa(username, password);
 * ```
 */
export const authenticateMfa = async(
  username: string,
  password: string,
  appKey?: string
): Promise<LoginResult> => {
  const defaultAppKey = config.headers['calamp-services-app'];
  const result = await client({
    url     : url('/login'),
    method  : 'post',
    headers : {
      'calamp-services-app' : appKey || defaultAppKey,
      'Content-Type'        : 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data : qs.stringify({
      useAuthToken : true,
      include      : 'accessToken',
      password,
      username
    })
  });
  if (appKey && appKey !== defaultAppKey) {
    config.headers['calamp-services-app'] = appKey;
  }
  return parseLoginResult(result);
};

const mfaHeaders = (intermediateToken: string): object => ({
  Authorization : `Bearer ${intermediateToken}`
});

/**
 * @function enrollFactor
 *
 * Starts TOTP enrollment for the given Okta user and provider, returning the Okta
 * factor metadata (including QR setup data). The intermediate token is sent as the
 * bearer; a rotated token, if returned, is included in the result.
 *
 * ```typescript
 *    import {enrollFactor} from '@ion/core/src/services/Connect';
 *    ...
 *    const {oktaFactor} = await enrollFactor(oktaUserId, factorType, provider, token);
 * ```
 */
/* eslint-disable max-params */
export const enrollFactor = async(
  oktaUserId: string,
  factorType: TotpFactorType,
  provider: MfaProvider,
  intermediateToken: string
): Promise<EnrollFactorResponse> => {
  const query  = qs.stringify({oktaUserId, factorType, provider});
  const result = await client({
    url     : url(`/mfa/enrollFactor?${query}`),
    method  : 'post',
    headers : mfaHeaders(intermediateToken)
  });
  const data = result?.data || {};
  return {
    ...data,
    // only ever rotate from the response; the previous token is single-use and
    // must never be silently reused when the rotated token is missing ...
    intermediateToken : readIntermediateToken(result) || data.intermediateToken || ''
  };
};

/**
 * @function enableFactor
 *
 * Activates a pending TOTP factor using the first generated passcode. Returns the
 * activation message and, if the backend completes login on activation, an
 * `authToken`. A rotated intermediate token, if returned, is included in the result.
 *
 * ```typescript
 *    import {enableFactor} from '@ion/core/src/services/Connect';
 *    ...
 *    const {authToken} = await enableFactor(oktaUserId, factorId, passCode, token);
 * ```
 */
export const enableFactor = async(
  oktaUserId: string,
  factorId: string,
  passCode: string,
  intermediateToken: string
): Promise<EnableFactorResponse> => {
  const result = await client({
    url     : url('/mfa/enableFactor'),
    method  : 'post',
    headers : mfaHeaders(intermediateToken),
    data    : {oktaUserId, factorId, passCode}
  });
  const data = result?.data || {};
  return {
    ...data,
    authToken         : data.authToken || (parse(result, 'authToken') as unknown as string),
    intermediateToken : readIntermediateToken(result) || data.intermediateToken || ''
  };
};

/**
 * @function submitTotp
 *
 * Verifies a returning user's TOTP passcode. On success the response carries an
 * `authToken`. An invalid passcode returns a `403` with a rotated
 * `X-Intermediate-Token` response header, which the caller reads and retries with;
 * a `401` indicates the intermediate token was already consumed or expired and is
 * terminal.
 *
 * ```typescript
 *    import {submitTotp} from '@ion/core/src/services/Connect';
 *    ...
 *    const {authToken} = await submitTotp(stateToken, factorId, passCode, token);
 * ```
 */
export const submitTotp = async(
  stateToken: string,
  factorId: string,
  passCode: string,
  intermediateToken: string
): Promise<SubmitTotpResponse> => {
  const result = await client({
    url     : url('/mfa/totp?include=accessToken'),
    method  : 'post',
    headers : mfaHeaders(intermediateToken),
    data    : {stateToken, factorId, passCode}
  });
  const data = result?.data || {};
  return {
    authToken         : data.authToken || (parse(result, 'authToken') as unknown as string),
    intermediateToken : readIntermediateToken(result) || data.intermediateToken || ''
  };
};
/* eslint-enable max-params */

/**
 * @function resetMfa
 *
 * Starts an email-based MFA reset ("set up a new device") for the given factor. The
 * backend sends a device reset email; the response may include a masked email hint.
 * No continuation state token or enrollment data is returned.
 *
 * ```typescript
 *    import {resetMfa} from '@ion/core/src/services/Connect';
 *    ...
 *    const {emailHint} = await resetMfa(oktaUserId, factorId, token);
 * ```
 */
export const resetMfa = async(
  oktaUserId: string,
  factorId: string,
  intermediateToken: string
): Promise<ResetMfaResponse> => {
  const result = await client({
    url     : url('/mfa/reset'),
    method  : 'post',
    headers : mfaHeaders(intermediateToken),
    data    : {oktaUserId, factorId}
  });
  const data = result?.data || {};
  return {
    message           : data.message,
    emailHint         : data.email_hint || data.emailHint,
    intermediateToken : readIntermediateToken(result) || data.intermediateToken || ''
  };
};

/**
 * @function logout
 *
 * The logout method, as the name suggests, provides access to signing out of
 * Connect services.
 *
 * ```typescript
 *    import {logout} from '@ion/core/src/services/Connect';
 *
 *    const auth = await logout();
 *    // reload application ...
 *
 * ```
 */
export const logout = async(api: AxiosInstance = client): Promise<any> => {
  invalidateSessionToken();
  const result = await api.get(url('/logout'));
  return result;
};

/**
 * The forgotPassword method, as the name suggests, send the reset password request to the CTC
 * server and get the reset password link in the user's associated mail.
 *
 * If the optional appKey is not provided, this API will fallback to using the following
 * entries: "auxAppKey", followed by "appKey", as defined in the application's environment
 * json document. Clients which do not implement an environment.json document must pass
 * the appKey explicitly.
 *
 * ```typescript
 *
 *  import {forgotPassword} from '@ion/core/src/services/Connect';
 *
 *  await forgotPassword(username);
 *
 * ```
 */
export const forgotPassword = async(username: string, appKey?: string): Promise<any> => {
  resetCredentials(false);
  const result = await client({
    url     : url(`/users/forgotpassword?username=${username}`),
    method  : 'get',
    headers : {
      'calamp-services-app' : resolveAppKey(appKey)
    }
  });
  resetCredentials(true);
  return result;
};

/**
 * Provides the CTC Reset Password Service which allows existing users to reset their CTC
 * password and subsequently receive a confirmation email formatted for the given appKey.
 * If the optional appKey is not provided, this API will fallback to using the following
 * entries: "auxAppKey", followed by "appKey", as defined in the application's environment
 * json document. Clients which do not implement an environment.json document must pass
 * the appKey explicitly.
 *
 * @param token the reset token to authenticate.
 * @param password the password value.
 */
export const resetPassword = async(token: string, password: string, appKey?: string): Promise<any> => {
  resetCredentials(false);
  const result = await client({
    url     : url(`/users/resetpassword?_=${new Date().getTime()}`),
    method  : 'post',
    headers : {
      'calamp-services-app' : resolveAppKey(appKey),
      'Content-Type'        : 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data : qs.stringify({
      token,
      password
    })
  });
  resetCredentials(true);
  return result;
};

/**
 * @function currentUser
 *
 * Retrieves the authenticated user entity from Connect (i.e. the logged in user).
 *
 * ```typescript
 *    import {authenticate, currentUser} from '@ion/core/src/services/Connect';
 *
 *    const auth = await authenticate(username, password);
 *    const user = await currentUser();
 */
export const currentUser = async(api: AxiosInstance = client, includeUserAccount: boolean = false): Promise<User> => {
  const response = await api.get(url(`/users/currentUser${includeUserAccount ? '?expand=account' : ''}`));
  return parse(response, 'user');
};

/**
 * @function getDevices
 *
 * Retrieves the devices for the given account id.
 *
 * ```typescript
 *    import {getDevices} from '@ion/core/src/services/Connect';
 *
 *    const devices = await getDevices(accountId);
 *
 * ```
 */
export const getDevices = async(accountId: number, hierLevel = '', filterOn: GenericObject = {}): Promise<Device[]> => {
  const response = await client.post(url('/devices/search'), JSON.stringify({
    search : {
      maxResults  : 999,
      hierLevel   : hierLevel,
      searchTerms : {
        account : accountId, ...filterOn
      }
    }
  }));
  return parseCollection(response, 'device');
};

/**
* The getAccountAncestors method retrieves a collection Ancestor accounts for current account id.
*
* @param accountId the id of the account from which the ancestors are to be retrieved.
*
*/
export const getAncestorsAccount = async(accountId: number): Promise<Account[]> => {
  const response = await client.get(`/accounts/${accountId}/ancestors`);
  return parseCollection(response, 'ancestor');
};

/**
 * @function getAsset
 *
 * Retrieves the full entity representation of the given asset from CTC services.
 *
 * ```typescript
 *    import {getAsset} from '@ion/core/src/services/Connect';
 *
 *    const asset = await getAsset(id);
 *
 * ```
 *
 * @param {number} The id of the asset to which is to be retrieved.
 */
export const getAsset = async(id: number, api: AxiosInstance = client): Promise<Asset> => {
  const response = await api.get(url(`/assets/${id}`));
  return parse(response, 'asset') as Asset;
};

/**
 * @function loadAssets
 *
 * Provides a paginated search implementation against CTC Asset Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadAssets} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 assets within the given account, sorted by assetType descending...
 *    const {assets, totalCount} = await loadAssets({
 *      sortOn    : `-${AssetSearchableProperty.assetType}` as AssetSort,
 *      accountId : 321
 *    });
 *
 *    // retrieve the first 100 assets within the entire account hierarchy whose name contains
 *    // 'asset', and sorting by ascending by name and descending by lastModifiedOn ...
 *    const {assets, totalCount} = await loadAssets({
 *      filterOn         : {
 *        [AssetSearchableProperty.name]: '*asset*'
 *      },
 *      sortOn         : [
 *        `+${AssetSearchableProperty.name}`,
 *        `-${AssetSearchableProperty.lastModifiedOn}`
 *      ] as AssetSort[]
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 100
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Asset entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {Array<string>} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Assets
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadAssetsResult>
 */
export const loadAssets = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false,
  includeAccountFilter = true,
  includeGroups = false
}: LoadAssetsParams): Promise<LoadAssetsResult> => {
  let groupParam = 'include=extensions,schedules';
  if (includeGroups) {
    groupParam = 'include=groups';
  }
  const uri = `/assets/search?v=${config.ctcVersion}&${groupParam},id&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const search = includeAccountFilter ? {account: accountId, ...filterOn} : {...filterOn};
  const response: LoadAssetsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : search
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    assets : results?.map(({asset}) => asset),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all assets for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all assets in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a assets.
 *
 * @param {LoadAssetsParams} params The parameters against which the assets are to be
 *        retrieved.
 */
export const loadAllAssets = async(params: LoadAssetsParams, isParallel = false): Promise<Asset[]> => {
  const assets = await loadAll(loadAssets, params, 'assets', isParallel);
  return assets;
};

/**
 * @function createAsset
 *
 * The createAsset function creates a new Asset Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createAsset} from '@ion/core/src/services/Connect';
 *
 *     const asset = await createAsset(item);
 *
 * ```
 *
 * @param   {Asset} asset The CTC Asset entity which is to be created.
 * @returns Promise<Asset> The newly created Asset entity.
 */
export const createAsset = async(asset: Asset): Promise<Asset> => {
  const results = await client.post(url('/assets'), JSON.stringify({asset}));
  return parse(results, 'asset') as Asset;
};

/**
 * The createAssetsSchedule function associates CTC Schedules with assets to create.
 *
 * ```typescript
 *
 *     import {createAssetsSchedule} from '@ion/core/src/services/Connect';
 *
 *     const updates = await createAssetsSchedule(asset, assetName, scheduleMap);
 *
 * ```
 *
 * @param   asset       The Asset entity for which the schedule is to be created.
 * @param   assetName   The current asset in interation.
 * @param   scheduleMap Schedule mapped with Asset entity,
 * @returns Promise<Schedule[]> The created asset schedules.
 */
export const createAssetsSchedule = async(
  asset: Asset,
  assetName?: string,
  scheduleMap?: GenericObject
): Promise<Schedule | null> => {
  const schedule = assetName ? scheduleMap?.[assetName] : undefined;
  if (schedule) {
    const results = await client.post(url(`/assets/${asset.id}/schedules`), JSON.stringify(
      [schedule]
    ));
    return parseCollection(results, 'schedules');
  }
};

/**
 * @function createAssets
 *
 * The createAssets function creates a collection of new Asset Entities within the
 * CTC Platform.
 *
 * ```typescript
 *
 *     import {createAssets} from '@ion/core/src/services/Connect';
 *
 *     const assets = await createAssets(items);
 *
 * ```
 *
 * @param   {Asset[]} assets The CTC Assets entities which are to be created.
 * @returns Promise<Asset[]> A collection of the newly created Asset entities.
 */
export const createAssets = async(assets: Asset[], scheduleMap?: GenericObject): Promise<BulkAssetsResponse> => {
  const mergedResponse = await assetBulkOperation({
    items : assets,
    api   : (chunk) => client.post(url('/assets/bulk'), JSON.stringify(chunk.map(asset => ({asset}))))
  });

  const {results, errors} = parseAssetsBulkCollection(mergedResponse) as BulkAssetsResponse;
  await simulatedBulkOperation({
    items      : results,
    api        : createAssetsSchedule,
    getOptions : (item: Asset) => item?.name,
    context    : scheduleMap
  });
  return {results, errors} as BulkAssetsResponse;
};

/**
 * @function updateAsset
 *
 * The updateAsset function update an existing Asset Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateAsset} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAsset(asset);
 *
 * ```
 *
 * @param   {Asset} asset The CTC Asset entity which is to be updated.
 * @returns Promise<Asset> The updated Asset entity.
 */
export const updateAsset = async(asset: Asset, api: AxiosInstance = client): Promise<Asset> => {
  const results = await api.put(url(`/assets/${asset.id}`), JSON.stringify({asset}));
  return parse(results, 'asset') as Asset;
};

/**
 * The updateAssetsSchedule function associates CTC Schedules with assets to update.
 *
 * ```typescript
 *
 *     import {updateAssetsSchedule} from '@ion/core/src/services/Connect';
 *
 *     const updates = await updateAssetsSchedule(asset, assetName, scheduleMap);
 *
 * ```
 *
 * @param   asset       The Asset entity for which the schedules is to be updated.
 * @param   assetName   The current asset in interation.
 * @param   scheduleMap Schedule mapped with Asset entity,
 * @returns Promise<Schedule[]> The updated asset schedules.
 */
export const updateAssetsSchedule = async(
  asset: Asset,
  assetName?: string,
  scheduleMap?: GenericObject
): Promise<Schedule | null> => {
  const schedule = assetName ? scheduleMap?.[assetName] : undefined;
  if (schedule) {
    const results = await client.put(url(`/assets/${asset.id}/schedules`), JSON.stringify(
      [schedule]
    ));
    return parseCollection(results, 'schedules');
  }
};

/**
 * @function updateAssets
 *
 * The updateAssets function updates a collection of existing Asset Entities within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateAssets} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAssets(assets);
 *
 * ```
 *
 * @param   {Asset[]} assets The CTC Assets entities which are to be updated.
 * @returns Promise<Asset[]> A collection of the updated Asset entities.
 */
export const updateAssets = async(assets: Asset[], scheduleMap?: GenericObject): Promise<BulkAssetsResponse> => {
  const mergedResponse = await assetBulkOperation({
    items : assets,
    api   : (chunk) => client.put(url('/assets/bulk'), JSON.stringify(chunk.map(asset => ({asset}))))
  });

  const {results, errors} = parseAssetsBulkCollection(mergedResponse, 'asset', assets) as BulkAssetsResponse;
  await simulatedBulkOperation({
    items      : results,
    api        : updateAssetsSchedule,
    getOptions : (item: Asset) => item?.name,
    context    : scheduleMap
  });
  return {results, errors} as BulkAssetsResponse;
};

/**
 * @function deleteAssetDevices
 *
 * The deleteAssetDevices function deletes existing Devices associated with Asset
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAssetDevices} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAssetDevices(assets);
 *
 * ```
 *
 * @param   {Asset[]} assets The CTC Assets array which are to be deleted.
 * @returns Promise<Asset> The deleted Assets entity or null if not found.
 */
export const deleteAssetDevices = async(
  assets: Asset[]): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: assets, api: disassociateDevices});
};

/**
 * @function updateAssetSchedules
 *
 * The updateAssetSchedules function updates a collection of Assets.
 *
 * ```typescript
 *
 *     import {updateAssetSchedules} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAssetSchedules(assets);
 *
 * ```
 *
 * @param   {asset} assets The CTC Assets entities which are to be updated.
 * @returns Promise<Asset[]> A collection of the updated Asset entities.
 */
export const updateAssetSchedules = async(
  assets: Asset[]): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({
    items : assets,
    api   : consolidatedAssetUpdate
  });
};

/**
 *
 * The updateBulkAssetSchedules function updates a collection of
 * existing Schedules associated with Assets.
 *
 */
export const updateBulkAssetSchedules = async(
  assets: Asset[], scheduleMap?: GenericObject): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({
    items      : assets,
    api        : updateAssetSchedule,
    getOptions : (item: Asset) => item?.name,
    context    : scheduleMap
  });
};

/**
 *
 * The updateBulkAssetMaintenanceSchedules function updates a collection of
 * existing Maintenance Schedules associated with Assets.
 *
 */
export const updateBulkAssetMaintenanceSchedules = async(
  assets: Asset[], maintenanceScheduleMap?: GenericObject): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({
    items      : assets,
    api        : assignSchedule,
    getOptions : (item: Asset) => item?.maintenanceSchedule,
    context    : maintenanceScheduleMap
  });
};

/**
 * @function consolidatedAssetUpdate
 *
 * Provides a consolidation of all CTC operations which are required when updating an
 * Asset. This function allows for using a single transaction where multiple dependent
 * underlying transactions are required.
 *
 * Currently, due to CTC constraints, the process for editing an Asset is as follows:
 *
 *
 * ------------------------------------------------------------------------------------
 *  Pre-Verification Phase:
 * ------------------------------------------------------------------------------------
 *
 * 1.) The Asset augmented properties; non-CTC entity properties which are intended to
 *     provide indicators as to the asset's previous state; specifically, the following
 *     properties:
 *
 *     - previousAccount: A reference to the Assets previous account (only necessary if
 *       the account has changed).
 *
 *     - hadDevice: A boolean which, when true, indicates that the Asset had a device
 *       associated with it  (only necessary an existing device is associated).
 *
 *     - removePreviousDevice: A boolean which, when true, indicates that the Asset is
 *       to have it's previous device disassociated from it (only necessary an existing
 *       should be removed from the Asset).
 *
 * 2.) Determine if the Asset Account has changed.
 *
 * 3.) Determine if the Asset is to have a Device Associated with it.
 *
 * 4.) Determine if the Asset's account is to be reset; essentially, if the asset is
 *     to have a Device associated with it, and the Account has changed, we commit all
 *     updates to the Asset first, then update the Device to it's new account, which
 *     in turn will automatically move the Asset.
 *
 *
 * ------------------------------------------------------------------------------------
 *  Asset Update Process:
 * ------------------------------------------------------------------------------------
 *
 * 1.) If the Account has changed:
 *
 *  1.1.) If a Device is to be associated with the Asset.
 *
 *    1.1.1.) The Asset's account is set to it's previous account.
 *
 *    1.1.2.) Determine if the Asset's current Device associations are to be removed,
 *            and if so, remove them.
 *
 *    1.1.3.) Update the local Asset's version based on the result of the previous
 *            operation (see above step).
 *
 *    1.1.4.) Update the Asset in CTC against it's previous Account (not it's new account),
 *            and update the local asset reference to the newly created asset.
 *
 *    1.1.5.) If the account does not need to be reset, retrieve the Device that is to be
 *            associated with the Asset.
 *
 *    1.1.5.) If the account is not need to be reset, update the retrieved Device to the
 *            new Account, effectively moving both the Device and the Asset along with it.
 *
 *
 *  2.1.) If a Device was previously associated with the Asset.
 *
 *    2.1.1.) The Device will be disassociated from the Asset.
 *
 *    2.1.2.) The Updated Asset will be retrieved (as it's version will be updated
 *            as a result of the previous step (device be disassociation).
 *
 *    2.1.2.) The Edited Asset is updated, setting it's version to the retrieved Asset
 *            version from the previous step (asset retrieval).
 *
 * 2.) If the Account has not changed, the Asset is simply updated.
 *
 *
 * @param    {Asset} asset The Asset entity which is to be updated.
 * @returns  Promise<Asset> The updated Asset entity.
 */
export const consolidatedAssetUpdate = async(asset: Asset): Promise<Asset> => {
  const {previousAccount, hadDevice, removePreviousDevice, account, devices, operator} = asset;
  const accountChanged      = previousAccount?.href !== account.href;
  const associatedDeviceCount = devices?.length || 0;
  const deviceAssociated    = associatedDeviceCount > 0;
  const resetAccount        = asset.updateAccount;
  // the branches below unpair the Device from the Asset before re-pairing it,
  // even when the Asset's account isn't changing - the CTC Platform drops the
  // Asset's paired Operator as soon as it has no Device, so the Operator must
  // be protected (unpaired here, re-paired once the Device is back) whenever
  // that happens, not only when the Asset itself is changing accounts ...
  const deviceReassociationNeeded = (
    (deviceAssociated && (entityId(devices?.[0]) !== entityId(account?.href))) || hadDevice
  );
  const operatorMoveNeeded = !!operator && (accountChanged || deviceReassociationNeeded);

  // tracks how far the paired Driver (Operator) move got, so a failure anywhere
  // below (including the Asset's own move) can unwind exactly what succeeded ...
  let unpairedOperator: Operator = null;
  let movedOperator: Operator = null;
  // the Device branch's own account move can still fail (e.g. moving the
  // Device's account) after the Asset's account PUT already committed - once
  // that happens, reverting the Operator back to its old account would strand
  // it there while the Asset sits in the new one, so the catch below only
  // undoes the Operator move while the Asset itself never actually moved ...
  let assetAccountMoved = false;
  // the Device is unpaired from the Asset before being (re)paired below - if
  // nothing past that point succeeds, the Asset is left with no Device, which
  // also means an Operator can't be re-paired to it (the CTC Platform
  // requires an Asset-with-Device for that), so the Device must be restored
  // first on failure ...
  let deviceUnpaired = false;

  try {
    // the Asset's own version is bumped server-side by either pre-step below
    // (dropping its schedule, or unpairing its operator), so the version this
    // function was called with can go stale before the Asset's own PUT runs -
    // whichever pre-step ran last, this is refreshed to the version it left
    // the Asset at ...
    let currentVersion = asset.version;
    if (accountChanged && asset.schedule) {
      await deleteAssetSchedule(asset);
      currentVersion = (await getAsset(asset.id))?.version;
    }
    if (operatorMoveNeeded) {
      await updateOperatorAssignments(asset.id);
      currentVersion = (await getAsset(asset.id))?.version;
      unpairedOperator = await getOperator(entityId(operator));
      // only the Operator's own account needs moving when the Asset's account
      // is actually changing - when this is purely a Device (re)association,
      // the Operator just needs to be re-paired where it already is ...
      movedOperator = accountChanged ? await updateOperator(
        {...unpairedOperator, account: setRel(account, 'account')}, unpairedOperator.schedules
      ) : unpairedOperator;
    }
    const workingAsset = {...asset, version: currentVersion};

    let result: Asset;
    if (accountChanged || deviceAssociated) {
      if (deviceAssociated && (entityId(devices[0]) !== entityId(account?.href))) {
        let updatedAsset = (!accountChanged ? {...workingAsset, account: previousAccount} : workingAsset) as Asset;
        const deviceResult = await (deviceAssociated ? (associatedDeviceCount > 1) ? deleteAssetDevices([updatedAsset])
          : removeAssetDevice(updatedAsset) : Promise.resolve(updatedAsset));
        deviceUnpaired = true;
        // the Device(s) must move to the new account before the Asset's own
        // account PUT runs below - if a Device move fails (e.g. the ICN role
        // error from ION-7555), the Asset must not have moved either ...
        if (!resetAccount) {
          const assetDevices = await fetchAllDevices(devices);
          const modifiedDevices = assetDevices.map(device => {
            return {...device, account: account};
          });
          if (associatedDeviceCount > 1) {
            await bulkUpdateDevices(modifiedDevices);
          } else {
            await updateDevice({...modifiedDevices[0], account});
          }
        }
        if (associatedDeviceCount === 1) {
          updatedAsset = await updateAsset({...updatedAsset, version: deviceResult.version});
          assetAccountMoved = accountChanged;
        }
        if (associatedDeviceCount > 1) {
          const updated = await getAsset(asset.id);
          updatedAsset = await updateAsset({...updatedAsset, version: updated.version});
          assetAccountMoved = accountChanged;
        }
        result = updatedAsset;
      } else if (hadDevice) {
        await disassociateDevices(workingAsset);
        const refreshedAsset = await getAsset(asset.id);
        result = await updateAsset({...workingAsset, version: refreshedAsset?.version});
        assetAccountMoved = accountChanged;
      } else {
        result = await updateAsset(workingAsset);
        assetAccountMoved = accountChanged;
      }
    } else {
      result = await updateAsset(workingAsset);
      assetAccountMoved = accountChanged;
    }

    if (movedOperator) {
      await updateOperatorAssignments(result.id, movedOperator);
      // result was captured before the re-pair above, so it still reflects
      // the Asset with no Driver paired - refetch so callers (and the grid)
      // see the Driver association immediately, without needing a manual
      // refresh ...
      result = await getAsset(result.id);
    }
    return result;
  } catch (err) {
    if (deviceUnpaired && !assetAccountMoved) {
      try {
        // the Asset's own PUT (which would have re-paired the Device via its
        // unchanged `devices` link) never ran - restore the pairing directly
        // so the Asset isn't left without its Device, and so the Operator
        // re-pair below has an Asset-with-Device to re-pair to ...
        await createAssetDevices(asset.id, devices);
      } catch (deviceRevertErr) {
        error(deviceRevertErr);
      }
    }
    if (assetAccountMoved) {
      if (movedOperator) {
        try {
          await updateOperatorAssignments(asset.id, movedOperator);
        } catch (pairErr) {
          error(pairErr);
        }
      }
    } else if (movedOperator) {
      try {
        // the Operator's account only needs reverting if it was actually
        // moved - a pure Device (re)association never moved it in the first
        // place, so it only needs re-pairing where it already is ...
        const revertedOperator = accountChanged ? await updateOperator(
          {...movedOperator, account: setRel(unpairedOperator.account, 'account')}, movedOperator.schedules
        ) : movedOperator;
        await updateOperatorAssignments(asset.id, revertedOperator);
      } catch (revertErr) {
        error(revertErr);
      }
    } else if (unpairedOperator) {
      try {
        await updateOperatorAssignments(asset.id, unpairedOperator);
      } catch (revertErr) {
        error(revertErr);
      }
    }
    throw err;
  }
};

async function fetchAllDevices(devices: Link[]) {
  const promises = devices.map((device) =>
    getDevice(entityId(device)).then((res) => res[0])
  );

  const results = await Promise.all(promises);
  return results;
}

/**
 * @function manageAssetSchedules
 *
 * The manageAssetSchedules function associates CTC Schedules with an asset.
 *
 * ```typescript
 *
 *     import {manageAssetSchedules} from '@ion/core/src/services/Connect';
 *
 *     const updates = await manageAssetSchedules(schedules);
 *
 * ```
 *
 * @param   {Asset[]} asset The Asset entity which the schedules are to be added.
 * @returns Promise<Schedule[]> A collection of the asset schedules.
 */
export const manageAssetSchedules = async(asset: Asset, schedules: Link[]): Promise<Schedule[]> => {
  const results = await client.post(url(`/assets/${asset.id}/schedules`), JSON.stringify(
    schedules
  ));
  return parseCollection(results, 'schedules') as Schedule[];
};

/**
 * @function updateAssetSchedule
 *
 * The updateAssetSchedule function associates CTC Schedules with an asset to Update.
 *
 * ```typescript
 *
 *     import {updateAssetSchedule} from '@ion/core/src/services/Connect';
 *
 *     const updates = await updateAssetSchedule(schedules);
 *
 * ```
 *
 * @param   {Asset} asset The Asset entity which the schedules are to be Updated.
 * @returns Promise<Schedule[]> A collection of the asset schedules.
 */
export const updateAssetSchedule = async(asset: Asset): Promise<Schedule | null> => {
  const {previousAccount, schedule, schedules, account} = asset;
  const accountChanged = previousAccount?.href !== account.href;
  const deleteSchedule = !schedule && schedules;
  if (schedule?.href) {
    const results = await client.put(url(`/assets/${asset.id}/schedules`), JSON.stringify(
      [schedule]
    ));
    return parseCollection(results, 'schedules');
  } else if ((accountChanged && !schedules) || deleteSchedule) {
    return deleteAssetSchedule(asset);
  }
};

/**
 * The deleteAssetSchedule function deletes CTC Schedules with an asset to delete.
 *
 * ```typescript
 *
 *  import {deleteAssetSchedule} from '@ion/core/src/services/Connect';
 *
 *  const deleted = await deleteAssetSchedule(asset);
 *
 * ```
 *
 * @param asset The Asset entity which the schedules are to be deleted.
 * @returns A collection of the asset schedules.
 */
export const deleteAssetSchedule = async(asset: Asset): Promise<Schedule | null> => {
  const results = await client.delete(url(`/assets/${asset.id}/schedules`));
  return parseCollection(results, 'schedules');
};

/**
 * @function audit
 *
 * The audit function provides a unified implementation unto the CTC Audit API which allows
 * for auditing a specific entity and returning a collection of consolidated results including
 * the name of the users who have committed each change (if includeUser is true).
 *
 * ```typescript
 *
 *     import {audit} from '@ion/core/src/services/Connect';
 *
 *     const changes = await audit({id: asset.id, entity: Entity.asset, pageId: 1});
 *     // retrieve the audit history for an asset ...
 *
 * ```
 *
 */
export const audit = async({
  id,
  entity,
  pageId = 1,
  pageSize = 20,
  customFilter = null,
  includeEntity = false,
  includeUser = false,
  enableDateFilter = false
}: AuditParams): Promise<AuditResults> => {
  const resource = getEntityResourceURI(entity);
  const uri      = `/${resource}/${id}`;
  const paging   = `pg=${pageId}&pgsize=${pageSize}`;
  const filter   = enableDateFilter ? `&from=${customFilter?.startDate}&to=${customFilter?.endDate}` : '';
  const endpoint = `${uri}?${paging}${filter}&withEntity=${includeEntity}`;
  const response = await client.get(url(endpoint, Service.Audit));
  const {auditRecords, links, totalCount} = response.data;
  return {
    results : auditRecords,
    totalCount,
    links
  };
};

/**
 * @function deleteAsset
 *
 * The deleteAsset function deletes an existing Asset Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAsset} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAsset(asset);
 *
 * ```
 *
 * @param   {Asset} asset The CTC Asset entity which is to be deleted.
 * @returns Promise<Asset> The deleted Asset entity.
 */
export const deleteAsset = async(asset: Asset): Promise<Asset> => {
  const results = await client.delete(url(`/assets/${asset.id}`));
  return parse(results, 'asset') as Asset;
};

/**
 * @function deleteAssets
 *
 * The deleteAssets function deletes a collection of existing Asset Entities from
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAssets} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAssets(assets);
 *
 * ```
 *
 * @param   {Asset[]} assets The CTC Assets entities which are to be deleted.
 * @returns Promise<Asset[]> A collection of the deleted Asset entities.
 */
export const deleteAssets = async(assets: Asset[], pageSize = 20): Promise<Asset[]> => {
  const results = await client.delete(url(`/assets/bulk?pgsize=${pageSize}`), {
    data : JSON.stringify({
      search : {
        searchTerms : {
          id : assets.map(({id}) => id).toString()
        }
      }
    }),
    headers : {
      ...config.headers
    }
  });
  return parseCollection(results, 'asset') as Asset[];
};

/**
 * @function loadDeviceTypes
 *
 * Provides a paginated search implementation against CTC Devices types Services which supports
 * optional sorting and hierarchical support.
 *
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {Array<string>} sortOn The field on which the results are to be sorted.
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all devices
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadDeviceTypesResult>
 */
export const loadDeviceTypes = async({
  pageId = 1,
  pageSize = 20,
  sortOn,
  includeSubGroups = false
}: LoadDeviceTypesParams): Promise<LoadDeviceTypesResult> => {
  const endpoint = `/devicetypes/?v=2.1&pg=${pageId}&pgsize=${pageSize}&sort=${sortOn}`;
  const response: LoadDeviceTypesResponse = await client.get(url(setHierLevel(endpoint, includeSubGroups)));
  const {results, totalCount} = response.data?.response;
  return {
    items : results.map((data) => data?.deviceType),
    totalCount
  };
};

/**
 * @function loadDeviceType
 *
 * Provides a paginated search implementation against CTC Devices type Services which supports
 * optional filtering and sorting support.
 *
 * * ```typescript
 *
 *    import {loadDeviceType} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 device type ...
 *    const {devicetype, totalCount} = await loadDeviceType({
 *      filterOn         : {
 *        [DeviceTypeSearchableProperty.name]: '*mb*'
 *      }
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {Array<string>} sortOn The field on which the results are to be sorted.
 *          which the searchTerms request is to be based.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @returns Promise<LoadDeviceTypesResult>
 */
export const loadDeviceType = async({
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {}
}: LoadDeviceTypesParams): Promise<LoadDeviceTypesResult> => {
  const response = await client.post(url(`/devicetypes/search?v=2.1&pg=${pageId}&pgsize=${pageSize}&sort=${sortOn}`), JSON.stringify({
    search : {
      maxResults  : 1000,
      searchTerms : {...filterOn}
    }
  }));
  const {results, totalCount} = response.data?.response || {};
  return {
    items : results?.map((data) => data?.deviceType),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all devicetypes for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devicetypes in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devicetypes.
 *
 * @param {LoadDeviceTypesParams} params The parameters against which the devicetypes are
 *        to be retrieved.
 */
export const loadAllDeviceTypes = async(params: LoadDeviceTypesParams): Promise<CTCEntity[]> => {
  const deviceTypes = await loadAll(
    !isEmpty(params?.filterOn) ? loadDeviceType : loadDeviceTypes,
    params,
    'items');
  return deviceTypes;
};

/**
 *
 * Provides a paginated search implementation against CTC Devices files Services which supports
 * optional sorting and hierarchical support.
 *
 * @param   {number} accountId To fetch device file based on the current selected account.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {Array<string>} sortOn The field on which the results are to be sorted.
 *          which the searchTerms request is to be based.
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadDeviceFilesResult>
 */
export const loadDeviceFiles = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  status,
  filterOn = {},
  isResults = false,
  includeSubGroups = false,
  includeAccountFilter = true,
  includeOnlyThisAccount = false,
  suppressNullVersions = false
}: LoadDeviceFilesParams): Promise<LoadDeviceFilesResult> => {
  const {endpoint, search} = createLoadDeviceFilesRequest({
    pageId,
    sortOn,
    status,
    filterOn,
    pageSize,
    accountId,
    isResults,
    includeSubGroups,
    suppressNullVersions,
    includeAccountFilter,
    includeOnlyThisAccount
  });
  const response = await client.post(endpoint, JSON.stringify({
    search
  }));
  const {results, totalCount} = response?.data?.response;
  return {
    items    : results?.map((data) => data?.filemeta),
    nextPage : results?.length === pageSize ? pageId + 1 : undefined,
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all devicetypes for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devicetypes in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devicetypes.
 *
 * @param {LoadDeviceFilesParams} params The parameters against which the devicetypes are
 *        to be retrieved.
 */
export const loadAllDeviceFiles = async(params: LoadDeviceFilesParams): Promise<CTCEntity[]> => {
  const deviceFiles = await loadAll(loadDeviceFiles, params, 'items', true);
  return deviceFiles;
};

/**
 * Retrieves the (estimated) number of devices using the file with the provided ID from DM.
 *
 * @param fileId the ID of the file to get the count of devices for
 */
export const getDeviceCountForFile = async(fileId: string): Promise<number> => {
  const response = await client.get(url(`/fileHistory/current/externalfileid/${fileId}/device/count`, Service.PULS));
  return parse(response) as unknown as number;
};

/**
 *
 * The createDeviceFile function creates a new device file.
 *
 * ```typescript
 *
 *     import {createDeviceFile} from '@ion/core/src/services/Connect';
 *
 *     const created = await createDeviceFile(devicefile);
 *
 * ```
 *
 * @returns  {Promise<unknown>} The newly created Device File Typesentity.
 */
export const createDeviceFile = async(devicefile: unknown): Promise<unknown[]> => {
  const results = await client.post(url('/files', Service.PulsBaseUrl), JSON.stringify(devicefile));
  return parse(results, 'filemeta') as any[];
};

/**
 *
 * The updateDeviceFile function update a new device file.
 *
 * ```typescript
 *
 *     import {updateDeviceFile} from '@ion/core/src/services/Connect';
 *
 *     const edited = await updateDeviceFile(devicefile);
 *
 * ```
 *
 * @returns  {Promise<DeviceFile>} The newly created Device File Typesentity.
 */
export const updateDeviceFile = async(
  devicefile: MaintainDeviceFileRequest,
  includeAutojobsFlag: boolean = false
): Promise<DeviceFile[]> => {
  const endpoint = includeAutojobsFlag ? `/files/${devicefile.id}?features=autojobs` : `/files/${devicefile.id}`;
  const results = await client.put(url(`${endpoint}`, Service.PulsBaseUrl), {filemeta: {...devicefile}});
  return parseCollection(results, 'filemeta') as DeviceFile[];
};

/**
 *
 * The getFile function update a new device file.
 *
 * ```typescript
 *
 *     import {getFile} from '@ion/core/src/services/Connect';
 *
 *     const edited = await updateDeviceFile(devicefile);
 *
 * ```
 *
 * @returns  {Promise<unknown>} Get Device File Typesentity.
 */
export const getFile = async(id: number): Promise<unknown[]> => {
  const results = await client.get(url(`/files/${id}`, Service.PulsBaseUrl));
  return parseCollection(results, 'filemeta') as any[];
};

/**
 *
 * The getDownloadURL function downloads the requested file.
 *
 * ```typescript
 *
 *     import {getDownloadURL} from '@ion/core/src/services/Connect';
 *
 *     return await getDownloadURL(id, type);
 *
 * ```
 */
export const getDownloadURL = async(
  id: number,
  type: string = 'releaseNotes' || 'file' || 'csv'
): Promise<unknown[]> => {
  const results = await client.get(url(`/files/${id}/${type}URL`, Service.PulsBaseUrl));
  return parseCollection(results, '');
};

/**
 *
 * The getReleaseNote function downloads release notes.
 *
 * ```typescript
 *
 *     import {getReleaseNote} from '@ion/core/src/services/Connect';
 *
 *     return await getReleaseNote(id);
 *
 * ```
 */
export const getReleaseNote = async(id: number): Promise<unknown[]> => {
  return await getDownloadURL(id, 'releaseNotes');
};

/**
 *
 * The getFileUrl function downloads XML/file.
 *
 * ```typescript
 *
 *     import {getFileUrl} from '@ion/core/src/services/Connect';
 *
 *     return await getFileUrl(id);
 *
 * ```
 */
export const getFileUrl = async(id: number): Promise<unknown[]> => {
  return await getDownloadURL(id, 'file');
};

/**
 *
 * The getCSVUrl function downloads CSV file.
 *
 * ```typescript
 *
 *     import {getCSVUrl} from '@ion/core/src/services/Connect';
 *
 *     return await getCSVUrl(id);
 *
 * ```
 */
export const getCSVUrl = async(id: number): Promise<unknown[]> => {
  return await getDownloadURL(id, 'csv');
};

/**
 * @function deleteDeviceFile
 *
 * The deleteDeviceFile function deletes an existing Device File Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteDeviceFile} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteDeviceFile(file);
 *
 * ```
 *
 * @param   {DeviceFile} devicefile The CTC Device File entity which is to be deleted.
 * @returns Promise<DeviceFile> The deleted Device File entity or null if not found.
 */
export const deleteDeviceFile = async({id}: DeviceFile): Promise<DeviceFile | null> => {
  const results = await client.delete(url(`/files/${id}`));
  return parse(results, 'filemeta') as DeviceFile;
};

/**
 *
 * Provides a select dropdown and autocomplete implementation against DM device file meta data
 *  which supports search and single selection of item from the dropdown.
 *
 * @returns Promise<LoadLookupResult>
 */
export const getlookupData = async(path): Promise<any> => {
  const uri = `/${path}`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  const results = response?.data;
  return results;
};

/**
 *
 * Provides a select dropdown and autocomplete implementation against chose subaccounts
 *  which supports search and single selection of item from the dropdown.
 *
 * @returns Promise<any>
 */
export const getAccountsByFileId = async(fileId: string): Promise<Account[]> => {
  const uri = `/files/${fileId}/accounts`;
  const response = await client.get(url(uri));
  const results = response?.data?.response;
  return results;
};

/**
 * Provides a select dropdown  and autocomplete implementation against CTC Devices types Services
 * which supports search and single selection of item from the dropdown.
 * 
 * @param includeCategorySubTypes – if true, maps and returns category-subtype pairs instead of raw results
 *
 * @returns Promise<LoadDeviceTypesResult>
 */
export const getPlatformDeviceTypes = async(includeCategorySubTypes = false):
Promise<LoadPlatformDeviceTypesResult> => {
  const uri      = '/platform/deviceTypes';
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  const results  = response?.data;
  if (includeCategorySubTypes) {
    return setMappedCategorySubType(results);
  }
  return results;
};

/**
 *
 * Provides a select dropdown  and autocomplete implementation against CTC Devices types Services
 *  which supports search and single selection of item from the dropdown.
 *
 * @returns Promise<LoadDeviceTypesResult>
 */
export const getDeviceTypes = async(): Promise<LoadDeviceTypesResult> => {
  const response: LoadDeviceTypesResponse = await client.get(url('/devicetypes/'));
  const {results, totalCount} = response.data?.response;
  return {
    items : results.map(({deviceType}) => deviceType),
    totalCount
  };
};

/**
 * Creates a Device Type entity in Connect services.
 *
 * ```typescript
 *
 *    import {createDeviceType} from '@ion/core/src/services/Connect';
 *
 *    const created = createDeviceType(deviceType);
 *
 * ```
 */
export const createDeviceType = async(deviceType: DeviceType): Promise<DeviceType> => {
  const response = await client.post(url('/devicetypes'), JSON.stringify({deviceType}));
  return parse(response, 'deviceType') as DeviceType;
};

/**
 * @function disassociateDevices
 *
 * Disassociates a Device from an asset with the given id from the CTC Platform.
 *
 * ```typescript
 *    import {disassociateDevices} from '@ion/core/src/services/Connect';
 *
 *    const removed = await disassociateDevices(asset.id);
 *
 * ```
 *
 * @param {Asset} The Asset for which the device associations are to be removed.
 */
export const disassociateDevices = async(asset: Asset): Promise<Device> => {
  const id = asset.id || entityId(asset);
  const results = await client.delete(url(`/assets/${id}/devices`));
  return parseCollection(results, 'device');
};

/**
 * @function getDevice
 *
 * Retrieves the full entity representation of the given Device from CTC services.
 * This function also allows for retrieving an Asset's devices when the assetDevices
 * argument is set to true, in which case rather than a single device retrieval, all
 * Devices associated with the given asset id will be retrieved.
 *
 * ```typescript
 *
 *    import {getDevice} from '@ion/core/src/services/Connect';
 *
 *    // retrieve device by id ...
 *    const device: Device = await getDevice(id);
 *
 *    // retrieve device by ESN id ...
 *    const device: Device[] = await getDevice(id, false, true);
 *
 *    // retrieve asset devices by asset id ...
 *    const devices: Device[] = await getDevice(id, true);
 *
 * ```
 *
 * @param {number} id Either a Device id or Asset id for which a device or devices
 *        are to be retrieved.
 * @param {boolean} assetDevices When true, the request will be made to retrieve
 *        an Asset's Devices, otherwise, when false (default), the device will
 *        be retrieved via it's id.
 * @param {boolean} fetchByESN Determines if the id passed is a device id or esn which
 *        will determine which endpoint will be used to retrieve the device data
 */
export const getDevice = async(id: number, assetDevices = false, fetchByESN = false): Promise<Device[]> => {
  if (!assetDevices) {
    const uri = fetchByESN ? '/devices/esn' : '/devices';
    const response = await client.get(url(`${uri}/${id}`));
    return parseCollection(response, 'device');
  }
  // we cant get assetDevices by ESN so both cannot be true
  if (assetDevices && !fetchByESN) {
    return await getAssetDevices(id);
  }
  return null;
};

/**
 * Retrieves the MQTT connection state for the given ESN query string from the DM gateway.
 * CONNECTED maps to connected; any other state maps to disconnected.
 */
export const getDeviceConnectionState = async(
  esns: string
): Promise<OfflineCanApiResponse<DeviceConnectionStateResult>> => {
  try {
    const response = await client({
      url     : url(`/ve-scout/devices/connection?esn=${esns}`, Service.PulsBaseUrl),
      method  : 'GET',
      headers : {
        Authorization : `Bearer ${getSessionToken()}`
      }
    });
    return response.data;
  } catch (err) {
    return err;
  }
};

/**
 * The `getDeviceExtendedAttributesById` method retrieves the extended attributes
 * for the given device id, returning the extended attributes response.
 * 
 * ```typeScript
 * 
 * import {getDeviceExtendedAttributesById} from '@ion/core/src/services/Connect';
 * 
 * const deviceExtAttribs = await getDeviceExtendedAttributesById(device.id, appKey);   
 * 
 * ```
 * 
 * @param   {number} id The id of the Device for which the extended attributes
 *          are to be retrieved.
 * @param   {string} appKey The application key specifies the application that is
 *          to be authenticated with.
 * @returns {Promise<ExtendedAttribute>} The extended attributes of the device.
 */
export const getDeviceExtendedAttributesById = async(id: number, appKey: string): Promise<ExtendedAttribute> => {
  const response = await client.get(url(`/devices/${id}/extendedattributes/?appKey=${appKey}`));
  if (response) {
    const results = parseCollection(response, 'extendedAttribute');
    if (results?.length) {
      const extendedAttribute = results[0];
      extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
      return extendedAttribute;
    }
  }
};

/**
 * The `saveDeviceExtendedAttributes` method saves the extended attributes for
 * the given device id, returning the extended attributes response with the
 * value property of the saved extended attributes parsed to an object.
 *
 * ```typescript
 *
 *   import {saveDeviceExtendedAttributes} from '@ion/core/src/services/Connect';
 *   ...
 *
 *   const saved = await saveDeviceExtendedAttributes(device.id, value);
 *
 * ```
 *
 * @param   id     The id of the Device for which the extended attributes are
 *                 to be saved.
 * @param   value  The value to be saved for the extendedAttribute value
 *                 property. Note, this object will automatically be converted
 *                 to a string via JSON.stringify.
 * @param   method The HTTP method to be used for the request; `post` creates
 *                 the initial record, `put` updates an existing one.
 * @returns        The saved extended attribute, with its `value` parsed to an
 *                 object.
 */
export const saveDeviceExtendedAttributes = async(
  id: number,
  value: any,
  method = 'put'
): Promise<ExtendedAttribute> => {
  const response = await client[method](url(`/devices/${id}/extendedattributes`), JSON.stringify({
    value : JSON.stringify(value)
  }));
  const results = parseCollection(response, 'extendedAttribute');
  if (results?.length) {
    const extendedAttribute = results[0];
    extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
    return extendedAttribute;
  }
};

/**
 * Updates an existing Device entity within the given environment.
 *
 * ```typescript
 *
 *    import {updateDevice} from '@ion/core/src/services/Connect';
 *
 *    const updated = await updateDevice(device);
 *
 * ```
 *
 * @param {Device|Link} device The device which is to be updated.
 */
export const updateDevice = async(device: Device, usePulse = false): Promise<Device> => {
  const id: number    = device.id || entityId(device);
  const sufix: string = usePulse ? '?include=groups' : '';
  const response = await client.put(url(
    `/devices/${id}${sufix}`,
    Service[!usePulse ? 'Connect' : 'PulsBaseUrl']
  ), JSON.stringify({device})
  );
  return parse(response, 'device');
};

/**
 * The updateBulkDevices function updates a collection of existing device Entities within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateBulkDevices} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateBulkDevices(devices);
 *
 * ```
 *
 * @param   {Device[]} devices The CTC Assets entities which are to be updated.
 * @returns Promise<Device[]> A collection of the updated Device entities.
 */
export const updateBulkDevices = async(devices: Device[]): Promise<BulkDevicesResponse> => {
  const responses = await client.put(url('/devices/bulk'), JSON.stringify(
    devices?.map(device => ({device}))
  ));
  const {results, errors} = parseAssetsBulkCollection(responses, 'device');
  return {results, errors} as BulkDevicesResponse;
};

/**
 * Replace an existing Device entity within the given environment.
 *
 * ```typescript
 *
 *    import {replaceDevice} from '@ion/core/src/services/Connect';
 *
 *    const updated = await replaceDevice(device);
 *
 * ```
 *
 * @param {Device|Link} device The device which is to be updated.
 */
export const replaceDevice = async(identifier: string, device: Device, identifierType = 'ESN'): Promise<Device> => {
  const response = await client.post(url(`/devices/${identifier}/replacement?idType=${identifierType}`, Service.PulsBaseUrl), JSON.stringify({device}));
  return parse(response, 'device');
};

export const sendSCICommand = async(deviceCommandReq): Promise<GenericObject> => {
  const deviceCommandUrl = url('/devicecommands/device/devicecommands?v=2.0&include=deviceSettings');
  const response = await client.post(deviceCommandUrl, JSON.stringify({deviceCommandReq}));
  const errors = response?.data?.response?.errors;
  if (errors?.length > 0) {
    throw {errorText: errors[0]};
  }
  return parse(response, 'deviceCommandReq');
};

/**
 * @function sendStarterCommand
 *
 * The sendStarterCommand function enables the vehicle engine status.
 *
 * ```typescript
 *
 *     import {sendStarterCommand} from '@ion/core/src/services/Connect';
 *
 *     const response = await sendStarterCommand(deviceId);
 *
 * ```
 *
 * @param   {deviceId} deviceId of the CTC Device entity which is to be deleted.
 */
export const sendStarterCommand = async(deviceId, enableVehicle=true): Promise<GenericObject> => {
  const paramValue = enableVehicle ? '0xFFFFFFFF00000000' : '0xFFFFFFFF80000000';
  const response = await client.post(url(`/devicecommands/device/${deviceId}/parameterconfig/1052/2/${paramValue}?v=2.0`));
  return parse(response, 'deviceCommandReq');
};

/**
 * @function deleteDevice
 *
 * The deleteDevice function deletes an existing Device Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteDevice} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteDevice(device);
 *
 * ```
 *
 * @param   {Device} device The CTC Device entity which is to be deleted.
 * @returns Promise<Device> The deleted Device entity or null if not found.
 */
export const deleteDevice = async(device: Device): Promise<Device | null> => {
  const results = await client.delete(url(`/devices/${device.id}`));
  return parse(results, 'device') as Device;
};

/**
 * The deleteDevices function deletes existing Devices (Devices Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteDevices} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteDevices(devices);
 *
 * ```
 *
 * @param   {Devices} devices The CTC Devices entity which are to be deleted.
 * @returns Promise<Devices> The deleted Devices entity or null if not found.
 */
export const deleteDevices = async(devices: Devices): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: devices, api: deleteDevice});
};

/**
 * Retrieves Device Configurations from the Connect service.
 *
 * ```typescript
 *
 *    import {loadDeviceConfigurations} from '@ion/core/src/services/Connect';
 *    const options = {
 *      accountId : 2,
 *      sortOn    : '+name'
 *    };
 *    const deviceConfigs = await loadDeviceConfigurations(options);
 *
 * ```
 */
export const loadDeviceConfigurations = async({
  accountId,
  sortOn,
  filterOn = {},
  pageId = 1,
  pageSize = 20
}: LoadDeviceConfigsParams): Promise<LoadDeviceConfigsResult> => {
  const uri = `/deviceconfigurations/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, false));
  const response: LoadDeviceConfigsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : MAX_RESULTS,
      sort        : sortOn,
      searchTerms : {
        account : accountId,
        ...filterOn
      }
    }
  }));
  const {totalCount, _links} = response.data?.response;
  return {
    deviceConfigurations : parseCollection(response, 'deviceConfiguration'),
    totalCount,
    _links
  };
};

/**
 * Deletes the Device Configuration from Connect services.
 *
 * ```typescript
 *
 *  import {deleteDeviceConfig} from '@ion/core/src/services/Connect';
 *
 *  const deletedDeviceConfig = await deleteDeviceConfig(deviceConfigToDelete);
 *
 * ```
 */
export const deleteDeviceConfiguration = async(
  deviceConfiguration: DeviceConfiguration
): Promise<DeviceConfiguration> => {
  const results = await client.delete(
    url(`/deviceconfigurations/${deviceConfiguration.id}?v=${config.ctcVersion}`)
  );
  return parse(results, 'deviceConfiguration') as DeviceConfiguration;
};

/**
 * Creates a Device Configuration in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createDeviceConfiguration} from '@ion/core/src/services/Connect';
 *  const createdDeviceConfig = await createDeviceConfiguration(deviceConfigToCreate);
 *
 * ```
 */
export const createDeviceConfiguration = async(
  deviceConfiguration: DeviceConfiguration
): Promise<DeviceConfiguration> => {
  const results = await client.post(
    url('/deviceconfigurations'),
    JSON.stringify({deviceConfiguration})
  );
  return parse(results, 'deviceConfiguration') as DeviceConfiguration;
};

/**
 * Gets the given Device Configuration with the provided details.
 *
 * ```typescript
 *
 *    import {getDeviceConfiguration} from '@ion/core/src/services/Connect';
 *    const getDeviceConfiguration = await getDeviceConfiguration(deviceConfigID);
 *
 * ```
 */
export const getDeviceConfiguration = async(configId: number): Promise<DeviceConfiguration> => {
  const response = await client.get(url(`/deviceconfigurations/${configId}`));
  return parse(response, 'deviceConfiguration') as DeviceConfiguration;
};

/**
 * Updates the given Device Configuration with the provided details.
 *
 * ```typescript
 *
 *    import {updateDeviceConfiguration} from '@ion/core/src/services/Connect';
 *    const updatedDeviceConfig = await updateDeviceConfiguration(deviceConfigToUpdate);
 *
 * ```
 */
export const updateDeviceConfiguration = async(
  deviceConfiguration: DeviceConfiguration
): Promise<DeviceConfiguration> => {
  const results = await client.put(
    url(`/deviceconfigurations/${deviceConfiguration.id}`),
    JSON.stringify({deviceConfiguration})
  );
  return parse(results, 'deviceConfiguration') as DeviceConfiguration;
};

/**
 * @function createAssetDevices
 *
 * Updates Device associations for the given asset by id.
 *
 * ```typescript
 *    import {createAssetDevices} from '@ion/core/src/services/Connect';
 *
 *    const updated = await createAssetDevices(asset.id, devices);
 *
 * ```
 *
 * @param {number} The id of the asset to which the devices are to be associated.
 * @param {Link[]} An array of devices to associate to with the asset.
 */
export const createAssetDevices = async(assetId: number, devices: Link[]): Promise<Link[]> => {
  const results = await client.post(url(`/assets/${assetId}/devices`), JSON.stringify({devices}));
  return parseCollection(results, 'device');
};

/**
 * @function removeAssetDevice
 *
 * When an Asset is moved to another account, and assigned a new Device, the previous
 * Device must first by unassigned prior to updating the Asset to the newly assigned
 * Device. This function manages disassociating the existing  Device from the Asset,
 * retrieves the updated Asset, and returns it's latest version.
 *
 * ```typescript
 *    import {removeAssetDevice} from '@ion/core/src/services/Connect';
 *
 *    const updated = await removeAssetDevice(asset.id, devices);
 *
 * ```
 *
 * @param {Asset} The Asset for which devices are to be disassociated.
 */
export const removeAssetDevice = async(asset: Asset): Promise<Asset> => {
  await disassociateDevices(asset);
  const updated = await getAsset(asset.id);
  return updated;
};

/**
 * @function getApplicationRole
 *
 * Retrieves the full entity representation of the User's Role from CTC
 * for the given appKey.
 *
 * ```typescript
 *    import {getApplicationRole} from '@ion/core/src/services/Connect';
 *
 *    const role = await getApplicationRole(user.roles, get('appKey'));
 *
 * ```
 */
export const getApplicationRole = async(user: User, appKey: string, restrict: boolean = false): Promise<any> => {
  const searchTerms = {
    application : appKey
  };

  if (restrict) {
    const roleIds = user?.roles?.map(({href}) => entityId(href));
    searchTerms.id = `${roleIds}`;
  }

  const results = await client.post(url('/roles/search'), JSON.stringify({
    search : {
      maxResults : 10000,
      searchTerms
    }
  }));
  const roles = parseCollection(results, 'role');
  return resolveRole(user, roles);
};

/**
 * @function getSubAccounts
 *
 * Retrieves all sub-accounts for the given account. To retrieve the entire account
 * hierarchy, set the includeHierarchy argument to true.
 *
 * ```typescript
 *    import {getSubAccounts} from '@ion/core/src/services/Connect';
 *
 *    const accounts = await getSubAccounts(account.id);
 *
 * ```
 */
export const getSubAccounts = async(accountId: number, includeHierarchy = false): Promise<any> => {
  const uri = `/accounts/${accountId}/subaccounts${includeHierarchy ? '?v=2.1&hierLevel=All' : ''}`;
  const response = await client.get(url(uri));
  return parseCollection(response, 'subaccount');
};

/**
 * @function getAccountAncestorFeatures
 *
 * Retrieves feature settings from the given account's ancestor hierarchy.
 *
 * ```typescript
 *    import {getAccountAncestorFeatures} from '@ion/core/src/services/Connect';
 *
 *    const ancestorFeatures = await getAccountAncestorFeatures(account.id);
 *
 * ```
 *
 * @param accountId The id of the account from which ancestor feature settings are to be retrieved.
 *
 * @returns A collection of ancestor feature setting objects.
 */
export const getAccountAncestorFeatures = async(accountId: number): Promise<GenericObject[]> => {
  const response = await client.get(url(`/accounts/${accountId}/ancestors/features`));
  return parseCollection(response, '') || [];
};

/**
 * Retrieves feature settings for the given account. When the account does not
 * have direct feature settings and ancestor lookup is enabled, this falls back
 * to the account ancestor feature settings.
 *
 * ```typescript
 * 
 *  import {getAccountFeatures} from '@ion/core/src/services/Connect';
 *
 *  const accountFeatures = await getAccountFeatures(account.id);
 *
 * ```
 *
 * @param accountId          The id of the account from which feature settings are to be retrieved.
 * @param fetchFromAncestors Indicates whether ancestor feature settings should be fetched
 *                           when account features are missing.
 *
 * @returns A collection of account feature setting objects.
 */
export const getAccountFeatures = async(accountId: number, fetchFromAncestors = true) => {
  const response = await client.get(url(`/accounts/${accountId}`));
  const features = parseCollection(response, 'account')?.[0]?.features;

  if (!features && fetchFromAncestors) {
    return await getAccountAncestorFeatures(accountId);
  }
  return [{features}];
};

/**
 * @function getAccounts
 *
 * Returns the full representation of all accounts within the given parent account
 * hierarchy.
 *
 * ```typescript
 *    import {getAccounts} from '@ion/core/src/services/Connect';
 *
 *    const accounts = await getAccounts(account.id);
 *
 * ```
 */
export const getAccounts = async(accountId: number): Promise<any> => {
  const response = await client.post(url('/accounts/search'), JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : {
        parent : accountId
      }
    }
  }));
  return parseCollection(response, 'account');
};

/**
 * Performs an Account search based on the provided AccountSearchableProperties and
 * maxResults (defaults to 100).
 *
 * ```typescript
 *    import {searchAccounts} from '@ion/core/src/services/Connect';
 *
 *    const accounts = await searchAccounts({name: '*.ion'}, 10);
 *
 * ```
 */
export const searchAccounts = async(
  searchTerms: AccountSearchableProperties,
  includes?: string[]
): Promise<any> => {
  const includeValues = [];
  includes.forEach((include) => {
    const validIncludeAttribute = Object.keys(AccountsSearchIncludes).find(
      (item) => include === AccountsSearchIncludes[item]
    );
    if (validIncludeAttribute) {
      includeValues.push(validIncludeAttribute);
    }
  });
  const includeValue = includeValues.toString();
  const uri = `/accounts/search${includeValue ? `?include=${includeValue}` : ''}`;
  const response = await client.post(url(uri), JSON.stringify({
    search : {
      searchTerms : normalizeDates(searchTerms),
      maxResults  : 10000
    }
  }));
  return parseCollection(response, 'account');
};

/**
 * Performs an Asset search based on the provided AssetSearchableProperty and
 * maxResults (defaults to 100).
 *
 * ```typescript
 *    import {searchAssets} from '@ion/core/src/services/Connect';
 *
 *    const assets = await searchAssets({name: '*.ion'}, 10);
 *
 * ```
 */
export const searchAssets = async(
  searchTerms: AssetFilter,
  maxResults = 100
): Promise<any> => {
  const response = await client.post(url('/assets/search'), JSON.stringify({
    search : {
      searchTerms : normalizeDates(searchTerms),
      maxResults
    }
  }));
  return parseCollection(response, 'asset');
};

/**
 * Performs an Driver (CTC Operator) search based on the provided OperatorSearchableProperty
 * and maxResults (defaults to 100).
 *
 * ```typescript
 *    import {searchDrivers} from '@ion/core/src/services/Connect';
 *
 *    const drivers = await searchDrivers({firstName: '*.ion'}, 10);
 *
 * ```
 */
export const searchDrivers = async(
  searchTerms: OperatorFilter,
  maxResults = 100,
  includes: string[] = []
): Promise<any> => {
  const response = await client.post(url(`/operators/search?include=${includes}`), JSON.stringify({
    search : {
      searchTerms : normalizeDates(searchTerms),
      maxResults
    }
  }));
  return parseCollection(response, 'operator');
};

/**
 * @function getAssetByDeviceId
 *
 * Retrieves the asset associated with the given device id.
 *
 * ```typescript
 *    import {getAssetByDeviceId} from '@ion/core/src/services/Connect';
 *
 *    const asset = await getAssetByDeviceId(device.id);
 *
 * ```
 */
export const getAssetByDeviceId = async(deviceId: number): Promise<Asset[]> => {
  const response = await client.get(url(`/devices/${deviceId}/asset`));
  return parseCollection(response, 'asset');
};

/**
 * @function getAssetDevices
 *
 * Retrieves the devices associated with the given asset id.
 *
 * ```typescript
 *    import {getAssetDevices} from '@ion/core/src/services/Connect';
 *
 *    const devices = await getAssetDevices(account.id);
 *
 * ```
 */
export const getAssetDevices = async(assetId: number): Promise<any> => {
  const response = await client.get(url(`/assets/${assetId}/devices`));
  return parseCollection(response, 'device');
};

/**
 * @function getAssociatedAssets
 *
 * Retrieves all assets which have devices with iOn Tag feature and associated with the given asset.
 *
 * ```typescript
 *    import {getAssociatedAssets} from '@ion/core/src/services/Connect';
 *
 *    const tools = await getAssociatedAssets(asset);
 *
 * ```
 */
export const getAssociatedAssets = async(asset: Asset,
  includeVisibility = false,
  includeIONTags = true): Promise<Asset[]> => {
  const assetId = asset.id || asset.assetId;
  const response = await client.get(url(`/assets/${assetId}/assets`));
  let assets = parseCollection(response, 'asset');
  if (includeIONTags && assets?.length) {
    const assetsWithIonTag = [];
    for (const asset of assets) {
      const devices = await getAssetDevices(asset.id || asset.assetId);
      devices[0]?.architecture === 'SCI' && assetsWithIonTag.push(asset);
    }
    assets = assetsWithIonTag;
  }
  const hasTools = assets.filter(({assetType}: {assetType: AssetType}) => assetType === AssetType.Tool);
  if (includeVisibility && hasTools.length) {
    const {deviceEsn, devices} = asset;
    const esn = deviceEsn ?? devices[0]?.esn;
    let report;
    if (!esn) {
      const devices = await getAssetDevices(assetId);
      const deviceId = devices?.length ? entityId(devices[0]) : null;
      if (deviceId) {
        report = await getDeviceReport({deviceId});
      }
    } else {
      report = await getDeviceReport({deviceId: esn, useEsn: true});
    }
    return resolveAssetTools(report, assets);
  }
  return assets;
};

/**
 * Replaces the set of assets currently associated with the asset, with the supplied
 * set of assets.
 */
export const updateAssetToolAssociations = async(asset: Asset) => {
  const results = await client.put(url(`/assets/${asset.assetId}/assets`),
    JSON.stringify(asset.assets));
  return parseCollection(results, 'asset');
};

/**
 * Deletes the set of assets currently associated with the asset.
 */
export const deleteAssetToolAssociations = async(assetId: number) => {
  const results = await client.delete(url(`/assets/${assetId}/assets`));
  return parseCollection(results, 'asset');
};

/**
 *
 * Retrieves a report of the current status for a given device id or device esn.
 *
 * ```typescript
 *    import {getDeviceReport} from '@ion/core/src/services/Connect';
 *
 *    const tools = await getDeviceReport(asset);
 *
 * ```
 */
export const getDeviceReport = async({
  deviceId,
  useEsn = false,
  msgType = 'LMU_GATEWAY',
  timeRange = 3,
  maxResults = 1,
  customDateRange = null
}): Promise<any> => {
  const field = !useEsn ? 'deviceId' : 'deviceEsn';
  const result = await client.post(url('/events/search', Service.Results), JSON.stringify({
    search : {
      maxResults,
      sort        : ['-eventTime'],
      searchTerms : {
        [field]   : deviceId,
        eventTime : customDateRange || `[NOW-${timeRange}DAYS TO NOW]`,
        msgType   : msgType
      }
    }
  }));
  return result?.data?.response;
};

/**
 * Retrieves the asset events within a specified time range for a given device ESN.
 *
 * ```typescript
 *
 * import { getAssetEventsByTimeRange } from '@ion/core/src/services/Connect';
 *
 * The following would retrieve the asset's events for the last 72 hours for the specified device ESN
 * up to 1000 events.
 *
 * const deviceEvents = await getAssetEventsByTimeRange(deviceEsn, 3);
 *
 * ```
 */
export const getAssetEventsByTimeRange = async({
  deviceEsn,
  timeRange = 1,
  maxResults = 1000
}): Promise<any> => {
  const result = await client.post(url('/events/search?v=2.0', Service.Results), JSON.stringify({
    search : {
      maxResults,
      sort        : ['-eventTime'],
      searchTerms : {
        deviceEsn : deviceEsn,
        eventTime : `[NOW-${timeRange}DAYS TO NOW]`
      }
    }
  }));
  return result?.data?.response;
};

/**
 *
 * Retrieves an array of the DTC codes to display fault data in diagnostics.
 *
 * ```typescript
 *    import {getDTCCodes} from '@ion/core/src/services/Connect';
 *
 *    const codes = await getDTCCodes(id);
 *
 * ```
 */
export const getDTCCodes = async({
  device,
  pg = 1,
  pgsize = 10,
  idType = 'DeviceId',
  useDTC2Report = false
}: GetDTCCodesParams): Promise<any> => {
  const result = await client.get(url(`/events/device/${device?.deviceId}/${useDTC2Report ? 'dtc2Report' : 'dtc'}/latest?idType=${idType}&v=2.1&pg=${pg}&pgsize=${pgsize}&_=${Number(device?.deviceEsn)}`, Service.Results));
  return parseCollection(result, useDTC2Report ? DtcEventType.Jpod2DTCReport : DtcEventType.DtcEvents);
};

/**
 *
 * Retrieves an array of the Device lastcommunication to display Device Info.
 *
 * ```typescript
 *    import {getDeviceLatest} from '@ion/core/src/services/Connect';
 *
 *    const codes = await getDeviceLatest(id);
 *
 * ```
 */
export const getDeviceLatest = async(deviceId): Promise<any> => {
  const result = await client.get(url(`/events/LOCO_MESSAGE/latest?d={id:${deviceId}}&numEvents=1&v=2.0&pg=1&pgsize=1`, Service.Results));
  return result?.data?.response;
};

/**
 * Retrieves an array of the Device passwords for a given devices
 *
 * ```typescript
 *
 *    import {loadDevicePasswords} from '@ion/core/src/services/Connect';
 *
 *    const passwords = await loadDevicePasswords(devices);
 *
 * ```
 */
export const loadDevicePasswords = async(deviceIds: string[] | number[], identifierType = 'esn'): Promise<any> => {
  const response = await client.post(url('/devices/passwords/all', Service.ApiBaseUrl),
    JSON.stringify({[identifierType]: deviceIds.join(',')})
  );
  const {results, errors} = response.data?.response;
  return {
    items      : results?.map(({devicePassword}) => devicePassword),
    totalCount : results?.length,
    errors
  };
};

/**
 * Retrieves an array of the Device passwords for a given devices
 *
 * ```typescript
, *
 *    import {enableDeviceServices} from '@ion/core/src/services/Connect';
 *
 *    const services = await enableDeviceServices(devices);
 *
 * ```
 */
export const updateDeviceServices = async({
  accountId,
  taskNickName,
  serviceName,
  serviceStatus,
  devices
}: DeviceServices): Promise<any> => {
  const response = await client.post(url('/devices/features', Service.ApiBaseUrl),
    JSON.stringify({
      features : {[serviceName]: serviceStatus},
      devices,
      taskNickName,
      accountId
    })
  );
  const {results, errors} = response.data?.response;
  return {
    items      : results?.map(({task}) => task) || [],
    totalCount : results?.length ?? 0,
    errors
  };
};

/**
 *
 * Retrieves an array of the Device Events to display events Info.
 *
 * ```typescript
 *    import {getEvents} from '@ion/core/src/services/Connect';
 *
 *    const codes = await getEvents(id);
 *
 * ```
 */
export const getEvents = async(deviceId): Promise<any> => {
  const result = await client.get(url(`/events/device/${deviceId}/latest?idType=DeviceId&v=2.0&pg=1&pgsize=10`, Service.Results));
  return result?.data?.response;
};

/**
 * 
 * Retrieves an array of the Avl Events to display Avl Info.
 * 
 *```typescript
 *    import {getAvlEventsByUuid} from '@ion/core/src/services/Connect';
 *
 *    const avlEvents = await getAvlEventsByUuid(params);
 *
 * ```
 */
export const getAvlEventsByUuid = async({
  deviceId,
  startUuid,
  endUuid,
  pageId = 1,
  pgsize = 100,
  idType = 'DeviceId'
}: AvlEventUuid): Promise<any> => {
  const {data} = await client.get(
    url(`/events/device/${deviceId}/avl/uuid?idType=${idType}&startUUID=${startUuid}&endUUID=${endUuid}&v=2.0&pg=${pageId}&pgsize=${pgsize}`, Service.Results)
  );
  return data?.response?.results;
};

/**
 * Provides a paginated search implementation against CTC Event History Result Services
 * which supports optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadEventHistory} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 events within the given device ...
 *    const, {events, totalCount} = await loadEventHistory({
 *      deviceId        : 321,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} deviceId The id of the device from which to retrieve Event History.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @returns Promise<LoadAEMPConfigResult>
 */
export const loadEventHistory = async({
  deviceId,
  eventTime,
  sortOn,
  pageId = 1,
  pageSize = 20,
  filterOn = {},
  msgType = ''
}: LoadEventsParams): Promise<LoadEventsResult> => {
  const uri = `/events/search?v=2.0&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, false), Service.Results);
  const search = {
    deviceId  : deviceId,
    eventTime : eventTime
  };
  if (msgType) {
    search.msgType = msgType;
  }
  const response: LoadEventsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : 1000,
      sort        : sortOn,
      searchTerms : search
    }
  }));
  const {results, totalElements, _links} = response.data?.response;
  return {
    events     : results,
    totalCount : totalElements,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all Events for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all Events in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a Events.
 *
 * @param {LoadEventsParams} params The parameters against which the Events are
 *        to be retrieved.
 */
export const loadAllEventHistory = async(params: LoadEventsParams): Promise<any> => {
  const events = await loadAll(loadEventHistory, params, 'events');
  return events;
};

/**
 * Resolves a collection of HVS Records to their  corresponding iOn Vision Events.
 *
 * Given a device id, a start date, and an end date, retrieves the iOn Vision Video
 * events for the given device within the specified time range, and return the list
 * of HVSRecords with their corresponding iOnVisionEvent properties set to the Video
 * Events for those HVS records (if any).
 *
 * ```typescript
 *
 *    import {getiOnVisionDetails} from '@ion/core/src/services/Connect';
 *
 *    const records = await getiOnVisionDetails(deviceId, start, end, hvs);
 *
 * ```
 */
export const getiOnVisionDetails = async({
  deviceEsn,
  start,
  end,
  records,
  maxResults = 100
}: GetIONVisionDetailsParams): Promise<(HVSRecord[])> => {
  const request = {
    search : {
      searchTerms : {
        deviceId     : parseInt(deviceEsn),
        avlEventTime : undefined
      },
      maxResults
    }
  };
  if (start && end) {
    request.search.searchTerms.avlEventTime = `[${start.toISOString()} TO ${end.toISOString()}]`;
  }
  const uri = `${url('/events/search', Service.iOnVision)}?sort=-avlEventTime`;
  const result = await client.post(uri, JSON.stringify(request));
  const events = parseCollection(result, 'videoEvent');
  if (records?.length) {
    return resolveIOnVisionEvents(events, records);
  }
  return events;
};

/**
 * Provides the API into the iOn Vision Video Events Search Endpoint. This function
 * can be invoked with any of the searchable properties supported by the endpoint,
 * which are defined in IONVisionSearchParams type.
 *
 * ```typescript
 *
 *    import {searchiOnVision} from '@ion/core/src/services/Connect';
 *
 *    const records = await searchiOnVision({
 *      createdOn?: Date;
 *      appmsgEventTime?: Date;
 *      avlEventTime?: Date;
 *      groups?: string[];
 *      accountId?: number[];
 *      deviceId?: string;
 *      avlEventUuid?: string;
 *      appMessageUuid?: string;
 *      id?: number
 *    });
 *
 * ```
 */
export const searchiOnVision = async({
  searchTerms,
  sortOn,
  maxResults = 1000,
  pageId = null,
  pageSize = null
}: SearchVisionLoadParams): Promise<HVSRecord[]> => {
  const uri = !pageSize ? '/events/search' : `/events/search?pg=${pageId}&pgsize=${pageSize}`;
  const result = await client.post(url(uri, Service.iOnVision), JSON.stringify({
    search : {
      searchTerms : normalizeIONVisionSearchParams(searchTerms),
      sort        : sortOn,
      maxResults
    }
  }));
  return parseCollection(result, 'videoEvent');
};

/**
 *
 * Provides the API to request a DVR upload for a given device.
 *
 * ```typescript
 *
 *   import {registerDVRUploadRequest} from '@ion/core/src/services/Connect';
 *
 *  const result = await registerDVRUploadRequest({
 *   serialNumber: '1234567890',
 *   startTimeUTC: '2021-01-01T00:00:00.000Z',
 *   endTimeUTC: '2021-01-01T00:00:00.000Z',
 *   ...params
 * });
 *
 * ```
 */
export const registerDVRUploadRequest = async(payload: DVRUploadRequestPayload, api: AxiosInstance = client) => {
  const result = await api.post(url('/api/videos/dvr/request', Service.Base), JSON.stringify(payload));
  return result;
};

/**
 *
 * Provides the API to search DVR for a given set of parameters.
 *
 * The function takes in an object containing searchable properties:
 * - `createdOn`: Array of dates in the format yyyy-MM-dd'T'HH:mm:ss.SSSZ.
 * - `groups`: Array of group identifiers.
 * - `accountId`: Array of long account IDs.
 * - `avlEventUuid`: Array of UUIDs related to AVL events.
 * - `appMessageUuid`: Array of UUIDs related to application messages.
 * - `avlEventTime`: Array of dates in the format yyyy-MM-dd'T'HH:mm:ss.SSSZ related to AVL events.
 * - `id`: Array of long IDs.
 * - `appmsgEventTime`: Array of dates in the format yyyy-MM-dd'T'HH:mm:ss.SSSZ related to application messages.
 * - `deviceId`: Array of device identifiers in string format.
 *
 * ```typescript
 *
 *   import {searchDVR} from '@ion/core/src/services/Connect';
 *
 *   const result = await searchDVR({
 *     createdOn: ['2021-01-01T00:00:00.000Z'],
 *     groups: ['group1', 'group2'],
 *     accountId: [123, 456],
 *     // ...other params
 *   });
 *
 * ```
 *
 * @param payload The object containing the searchable properties for DVR.
 * @param api Optionally, you can provide a custom AxiosInstance for the request.
 * @returns The result of the API request.
 *
 */
export const searchDVR = async({
  pageId,
  pageSize,
  ...payload
}: DVRSearchPayload, api: AxiosInstance = client) => {
  const result = await api.post(
    url(`/api/videos/dvr/search?pg=${pageId}&pgsize=${pageSize}`, Service.Base),
    JSON.stringify(payload)
  );
  const {results, totalCount, _links} = result.data?.response || {};
  return {
    dvrRequests : results?.map(({dvrRequest}) => dvrRequest) || [],
    totalCount,
    _links
  };
};

/**
 *
 * Retrieves paginated vision events for a given set of search paramters.
 *
 * ```typescript
 *
 *  import {searchVideoEvents} from '@ion/core/src/services/Connect';
 *
 *  const events = await searchVideoEvents(payload);
 *
 * ```
 */
export const searchVideoEvents = async({
  pageId,
  pageSize,
  ...payload
}: VideoSearchPayload) => {
  const response = await client.post(
    url(`/api/videos/events/search?pg=${pageId}&pgsize=${pageSize}`, Service.Base),
    JSON.stringify(payload)
  );
  const {results, totalCount, _links} = response.data?.response || {};
  return {
    videoEvents : results?.map(({videoEvent}) => videoEvent) || [],
    totalCount,
    _links
  };
};

/**
 *
 * Discard video events for a given ID.
 *
 * ```typescript
 *
 *  import {discardVideoEvents} from '@ion/core/src/services/Connect';
 *
 *  const response = await discardVideoEvents(id);
 *
 * ```
 */
export const discardVideoEvents = async(videoEventId: number) => {
  const result = await client.post(
    url(`/api/videos/events/${videoEventId}/discard`, Service.Base));
  const {response} = result.data || {};
  return {
    response
  };
};

/**
 *
 * Provides a paginated search implementation against CTC Notification Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadNotifications} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 notifications within the given account ...
 *    const {notifications, totalCount} = await loadNotifications({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Notification entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Notifications
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadNotificationsResult>
 */
export const loadNotifications = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadAlertsNotificationParams): Promise<LoadAlertsNotificationResult> => {
  const uri = `/alerts/search?v=${config.ctcVersion}&include=extensions&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadAlertsNotificationResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    notifications : results?.map(({alertConfiguration}) => alertConfiguration),
    totalCount,
    _links
  };
};

/**
 *
 * Provides a paginated search implementation against CTC Notification Type Services which supports
 * optional sorting, filtering support.
 *
 * ```typescript
 *
 *    import {loadNotificationType} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 notifications within the given account ...
 *    const {notificationType, totalCount} = await loadNotificationType({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Notification Types entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Notifications Types
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadNotificationsTypeResult>
 */
export const loadNotificationType = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  filterOn = {},
  sortOn,
  includeSubGroups = false,
  systemDefined= false,
  deleted = false
}: LoadNotificationTypeParams): Promise<LoadNotificationTypeResult> => {
  const uri = `/alerts/types/search?systemDefined=${systemDefined}&v=${config.ctcVersion}&deleted=${deleted}&pg=${pageId}&pgsize=${pageSize}&sort=${sortOn}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadNotificationTypeResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : 1000,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    notificationType : results?.map(({alertType}) => alertType),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all Notification Types for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all Notification Types in a single pseudo async call. Generally
 * this function is only to be used for performing exports of Notification Types.
 *
 * @param {LoadNotificationTypeParams} params The parameters against which the Notification
 *        Types are to be retrieved.
 */
export const loadAllNotificationType = async(params: LoadNotificationTypeParams): Promise<NotificationType[]> => {
  const notificationType = await loadAll(loadNotificationType, params, 'notificationType');
  return notificationType;
};

/**
 *
 * The getTriggerAttributes method will fetch all the alertTriggerAtrributes
 *
 * ```typescript
 *    import {getTriggerAttributes} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getTriggerAttributes();
 *
 * ```
 */
export const getTriggerAttributes = async(): Promise<any> => {
  const result = await client.get(url('/alerts/types/triggers/triggerattributes'));
  return parseCollection(result, 'alertTriggerAttribute') as NotificationType;
};

/**
 *
 * The getTriggerTypes method will fetch all the Trigger Types
 *
 * ```typescript
 *    import {getTriggerTypes} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getTriggerTypes();
 *
 * ```
 */
export const getTriggerTypes = async(id, triggerId): Promise<any> => {
  const result = await client.get(url(`/alerts/types/${id}/triggers/${triggerId}`));
  return parseCollection(result, 'alertTrigger') as NotificationType;
};

/**
 *
 * The getActiontemplates method will fetch all the Actiontemplates
 *
 * ```typescript
 *    import {getActiontemplates} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getActiontemplates();
 *
 * ```
 */
export const getActiontemplates = async(deleted = false): Promise<NotificationType> => {
  const result = await client.get(url(`/alerts/types/actiontemplates?deleted=${deleted}`));
  return parseCollection(result, 'alertActionTemplate') as NotificationType;
};

/**
 *
 * The getSingleNotificationType method will fetch the single Trigger Types
 *
 * ```typescript
 *    import {getSingleNotificationType} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getSingleNotificationType();
 *
 * ```
 */
export const getSingleNotificationType = async(id: number): Promise<NotificationType> => {
  const results = await client.get(url(`/alerts/types/${id}`));
  return parse(results, 'alertType') as NotificationType;
};

/**
 * Retrieves a single Notification Type by name.
 *
 * ```typescript
 *
 *   import {getNotificationTypeByName} from '@ion/core/src/services/Connect';
 *   ...
 *
 *   const type = await getNotificationTypeByName('MQTT_CHECKIN_ALERT_TYPE_MODE_ESN_VIN');
 *
 * ```
 *
 * @param   name The Notification Type name to retrieve.
 * @returns A Promise containing the requested Notification Type.
 */
export const getNotificationTypeByName = async(name: string): Promise<NotificationType> => {
  const results = await client.get(url(`/alerts/types/name/${name}`));
  const types = parseCollection(results, 'alertType') as NotificationType[];
  if (types?.length) {
    return types[0];
  }
  return parse(results, 'alertType') as NotificationType;
};

/**
 *
 * The createNotificationType function creates a new Notification types within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createNotificationType} from '@ion/core/src/services/Connect';
 *
 *     const created = await createNotificationType(notification);
 *
 * ```
 *
 * @param    {NotificationType} notification The CTC Notification Types entity which is to be created.
 * @returns  {Promise<Notification>} The newly created Notification Typesentity.
 */
export const createNotificationType = async(notification: NotificationType,
  context?: UserContext): Promise<NotificationType> => {
  const alertType: NotificationType = notification;
  const results = await client.post(url('/alerts/types'), JSON.stringify({alertType}));
  return parseCollection(results, 'alertType') as NotificationType;
};

/**
 *
 * The updateNotificationType function updates an existing Notification Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateNotificationType} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateNotificationType(notification);
 *
 * ```
 *
 * @param    {NotificationType} notification The CTC NotificationType entity which is to be updated.
 * @returns  {Promise<NotificationType>} The updated NotificationType entity.
 */
export const updateNotificationType = async(notification: Notification,
  context?: UserContext): Promise<Notification> => {
  const alertType: Notification = notification;
  const results = await client.put(url(`/alerts/types/${notification.id}`), JSON.stringify({alertType}));
  return parseCollection(results, 'alertType') as Notification;
};

/**
 *
 * The updateTriggerNotificationType function will trigger alerts for the existing notifications
 *  within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateTriggerNotificationType} from '@ion/core/src/services/Connect';
 *
 *     const created = await updateTriggerNotificationType(notification);
 *
 * ```
 *
 * @param    {Notification} NotificationType The CTC Notification Types entity which is to be created.
 * @returns  {Promise<Notification>} The newly created Notification Types entity.
 */
export const updateTriggerNotificationType = async(notification: NotificationType,
  context?: UserContext): Promise<NotificationType> => {
  const alertTrigger: NotificationType = notification;
  const results = await client.put(url(`/alerts/types/triggers/${notification.id}`), JSON.stringify({alertTrigger}));
  return parseCollection(results, 'alertTrigger') as NotificationType;
};

/**
 *
 * The triggerNotificationType function will trigger alerts for the newly created notifications
 *  within the CTC Platform.
 *
 * ```typescript
 *
 *     import {triggerNotificationType} from '@ion/core/src/services/Connect';
 *
 *     const created = await triggerNotificationType(notification);
 *
 * ```
 *
 * @param    {Notification} NotificationType The CTC Notification Types entity which is to be created.
 * @returns  {Promise<Notification>} The newly created Notification Types entity.
 */
export const triggerNotificationType = async(notificationType: NotificationType,
  context?: UserContext): Promise<NotificationType> => {
  const alertTrigger: NotificationType = notificationType;
  const results = await client.post(url('/alerts/types/triggers'), JSON.stringify({alertTrigger}));
  return parseCollection(results, 'alertTrigger') as NotificationType;
};

/**
 * The deleteNotificationType function deletes an existing Notification types
 *  (AlertConfiguration Entity) * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteNotificationType} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteNotificationType(notification);
 *
 * ```
 *
 * @param   {NotificationType} notificationType The CTC Notification type entity which is to be deleted.
 * @returns Promise<NotificationType> The deleted Notification types entity or null if not found.
 */
export const deleteNotificationType = async(id: number): Promise<NotificationType | null> => {
  const results = await client.delete(url(`/alerts/types/${id}`));
  return parse(results, 'alertType') as NotificationType;
};

/**
 * The deleteNotificationTypeTriggers function deletes an existing Notification types
 *  (AlertConfiguration Entity) * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteNotificationTypeTriggers} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteNotificationTypeTriggers(notification);
 *
 * ```
 *
 * @param   {NotificationType} notificationType The CTC Notification type entity which is to be deleted.
 * @returns Promise<NotificationType> The deleted Notification types entity or null if not found.
 */
export const deleteNotificationTypeTriggers = async(id: number): Promise<NotificationType | null> => {
  const results = await client.delete(url(`/alerts/types/triggers/${id}`));
  return parse(results, 'alertType') as NotificationType;
};

/**
 * Provides a convenience API which allows for retrieving all Notifications for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all Notifications in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a Notifications.
 *
 * @param {LoadNotificationsParams} params The parameters against which the Notifications are
 *        to be retrieved.
 */
export const loadAllNotifications = async(params: LoadNotificationsParams): Promise<Notification[]> => {
  const notifications = await loadAll(loadNotifications, params, 'notifications');
  return notifications;
};

/**
 * @function createNotification
 *
 * The createNotification function creates a new Notification Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createNotification} from '@ion/core/src/services/Connect';
 *
 *     const created = await createNotification(notification);
 *
 * ```
 *
 * @param    {Notification} notification The CTC Notification entity which is to be created.
 * @returns  {Promise<Notification>} The newly created Notification entity.
 */
export const createNotification = async(notification: Notification): Promise<Notification> => {
  const alertConfiguration: Notification = notification;
  const results = await client.post(url('/alerts'), JSON.stringify({alertConfiguration}));
  return parse(results, 'alertConfiguration') as Notification;
};

/**
 * @function getNotification
 *
 * The getNotification function retrieves an existing Notification Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getNotification} from '@ion/core/src/services/Connect';
 *
 *     const notification = await getNotification(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Notification entity which is to be retrieved.
 * @returns  {Promise<Notification>} The retrieved Notification entity.
 */
export const getNotification = async(id: number): Promise<Notification> => {
  const results = await client.get(url(`/alerts/${id}`));
  return parse(results, 'alertConfiguration') as Notification;
};

/**
 * @function updateNotification
 *
 * The updateNotification function updates an existing Notification Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateNotification} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateNotification(notification);
 *
 * ```
 *
 * @param    {Notification} notification The CTC Notification entity which is to be updated.
 * @returns  {Promise<Notification>} The updated Notification entity.
 */
export const updateNotification = async(notification: Notification): Promise<Notification> => {
  const alertConfiguration: Notification = notification;
  const results = await client.put(url(`/alerts/${notification.id}`), JSON.stringify({alertConfiguration}));
  return parse(results, 'alertConfiguration') as Notification;
};

/**
 * @function updateNotifications
 *
 * The updateNotifications function updates existing Notifications Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateNotifications} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateNotifications(notifications);
 *
 * ```
 *
 * @param    {Notifications} notifications The CTC Notifications entity which are to be updated.
 * @returns  {Promise<Notifications>} The updated Notifications entity.
 */
export const updateNotifications = async(
  notifications: Notifications): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: notifications, api: updateNotification});
};

/**
 * @function deleteNotification
 *
 * The deleteNotification function deletes an existing Notification (AlertConfiguration Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteNotification} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteNotification(notification);
 *
 * ```
 *
 * @param   {Notification} notification The CTC Notification entity which is to be deleted.
 * @returns Promise<Notification> The deleted Notification entity or null if not found.
 */
export const deleteNotification = async(notification: Notification): Promise<Notification | null> => {
  const results = await client.delete(url(`/alerts/${notification.id}`));
  return parse(results, 'alertConfiguration') as Notification;
};

/**
 * @function deleteNotifications
 *
 * The deleteNotifications function deletes existing Notifications (AlertConfigurations Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteNotifications} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteNotifications(notifications);
 *
 * ```
 *
 * @param   {Notifications} notifications The CTC Notifications entity which are to be deleted.
 * @returns Promise<Notifications> The deleted Notifications entity or null if not found.
 */
export const deleteNotifications = async(
  notifications: Notifications): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: notifications, api: deleteNotification});
};

/**
 * Provides a convenience alias to the underling CTC notification system; that is,
 * Alert Configurations.
 */
export const loadAlertConfigurations = loadNotifications;

/**
 * Provides a convenience alias to the underling CTC notification system; that is,
 * Alert Configurations.
 */
export const createAlertConfigurations = createNotification;

/**
 * Provides a convenience alias to the underling CTC notification system; that is,
 * Alert Configurations.
 */
export const getAlertConfigurations = getNotification;

/**
 * Provides a convenience alias to the underling CTC notification system; that is,
 * Alert Configurations.
 */
export const updateAlertConfigurations = updateNotification;

/**
 * Provides a convenience alias to the underling CTC notification system; that is,
 * Alert Configurations.
 */
export const deleteAlertConfigurations = deleteNotification;

/**
 * @function createAlertAction
 *
 * The createAlertAction method creates a new Alert Action based on the provided
 * arguments.
 *
 * ```typescript
 *
 *     import {createAlertAction} from '@ion/core/src/services/Connect';
 *
 *     const created = await createAlertAction(action);
 *
 * ```
 *
 * @param    action The Alert Action to be created.
 * @param    provideDefaults When true, indicates that the description and action
 *           template are to be nullified and / or set to an empty string. Defaults to false.
 * @returns  The newly created AlertAction entity.
 */
export const createAlertAction = async(
  action: AlertAction, provideDefaults = false
): Promise<AlertAction> => {
  const results = await client.post(url('/alerts/types/actions'), JSON.stringify({
    alertAction : (provideDefaults ? {
      ...action,
      description         : '',
      alertActionTemplate : null
    } : action)
  }));
  return parse(results, 'alertAction') as AlertAction;
};

/**
 * @function getAlertAction
 *
 * The getAlertAction function retrieves an existing AlertAction Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getAlertAction} from '@ion/core/src/services/Connect';
 *
 *     const action = await getAlertAction(id);
 *
 * ```
 *
 * @param    {number} id The id of the AlertAction entity which is to be retrieved.
 * @returns  {Promise<AlertAction>} The retrieved AlertAction entity.
 */
export const getAlertAction = async(id: number): Promise<AlertAction> => {
  const results = await client.get(url(`/alerts/types/actions/${id}`));
  return parse(results, 'alertAction') as AlertAction;
};

/**
 * @deprecated
 * @function getAlertActionTemplate
 *
 * The getAlertActionTemplate function retrieves an existing AlertActionTemplate Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getAlertActionTemplate} from '@ion/core/src/services/Connect';
 *
 *     const template = await getAlertActionTemplate(name);
 *
 * ```
 *
 * @param    {string} name The name of the AlertAction entity which is to be retrieved.
 * @returns  {Promise<AlertActionTemplate>} The retrieved AlertActionTemplate entity.
 */
export const getAlertActionTemplate = async(name: string): Promise<AlertActionTemplate> => {
  const results = await client.get(url(`/alerts/types/actiontemplates/name/${name}`));
  return parse(results, 'alertActionTemplate') as AlertActionTemplate;
};

/**
 * @function getAlertActionTemplates
 *
 * The getAlertActionTemplates function retrieves a list of AlertActionTemplate Entities from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getAlertActionTemplates} from '@ion/core/src/services/Connect';
 *
 *     const templates = await getAlertActionTemplates(name);
 *
 * ```
 *
 * @param    {string} name The name of the AlertAction entity which is to be retrieved.
 * @returns  {Promise<AlertActionTemplate[]>} The retrieved AlertActionTemplate entities.
 */
export const getAlertActionTemplates = async(name: string): Promise<AlertActionTemplate[]> => {
  const results = await client.get(url(`/alerts/types/actiontemplates/name/${name}`));
  return parseCollection(results, 'alertActionTemplate') as AlertActionTemplate[];
};

/**
 * Retrieves the full entity representation for the given Alert Action Links.
 *
 * ```typescript
 *
 *  import {loadAlertActions} from '@ion/core/src/services/Connect';
 *
 *  const actions = await loadAlertActions(configuration?.alertActionLinks);
 *
 * ```
 */
export const loadAlertActions = async(actions: Link[], excludeDeleted = true): Promise<AlertAction[]> => {
  const items = excludeDeleted ? actions.filter(
    ({status}: Link) => status !== EntityStatus.Deleted
  ) : actions;
  return Promise.all(items.map(async(action: Link) => {
    return await getAlertAction(entityId(action));
  })) as Promise<AlertAction[]>;
};

/**
 * @function updateAlertAction
 *
 * The updateAlertAction function updates an existing AlertAction Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateAlertAction} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAlertAction(action);
 *
 * ```
 *
 * @param    {AlertAction} action The AlertAction entity which is to be updated.
 * @param    {boolean} provideDefaults When true, indicates that the description and action
 *           template are to be nullified and / or set to an empty string. Defaults to false.
 * @returns  {Promise<AlertAction>} The updated AlertAction entity.
 */
export const updateAlertAction = async(
  action: AlertAction, provideDefaults = false
): Promise<AlertAction> => {
  const results = await client.put(url(`/alerts/types/actions/${action.id}`), JSON.stringify({
    alertAction : (provideDefaults ? {
      ...action,
      description         : '',
      alertActionTemplate : null
    } : action)
  }));
  return parse(results, 'alertAction') as AlertAction;
};

/**
 * @function deleteAlertAction
 *
 * The deleteAlertAction function deletes an existing AlertAction from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAlertAction} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAlertAction(action);
 *
 * ```
 *
 * @param   {AlertAction} action The CTC AlertAction entity which is to be deleted.
 * @returns Promise<AlertAction> The deleted AlertAction entity or null if not found.
 */
export const deleteAlertAction = async(action: AlertAction): Promise<AlertAction | null> => {
  const results = await client.delete(url(`/alerts/types/actions/${action.id}`));
  return parse(results, 'alertAction') as AlertAction;
};

/**
 * @function getAlertTypes
 *
 * The getAlertTypes function retrieves AlertType Entities from the CTC Platform
 * which match the given search criteria.
 *
 * ```typescript
 *
 *     import {getAlertTypes} from '@ion/core/src/services/Connect';
 *
 *     // retrieve all iOn specific alert types ...
 *     const alertType: AlertType[] = await getAlertTypes({name: 'iOn*'});
 *
 * ```
 *
 * @param    {AlertTypeFilter} searchTerms Map of valid alert type searchable properties.
 * @returns  {Promise<AlertType[]>} The retrieved AlertType collection.
 */
export const getAlertTypes = async(searchTerms: AlertTypeFilter, maxResults = 999): Promise<AlertType[]> => {
  const results = await client.post(url('/alerts/types/search'), JSON.stringify({
    search : {
      maxResults,
      searchTerms
    }
  }));
  return parseCollection(results, 'alertType') as AlertType[];
};

/**
 * The getNotificationTypes function retrieves AlertType Entities from the CTC Platform
 * which match the given search criteria.
 *
 * ```typescript
 *
 *     import {getNotificationTypes} from '@ion/core/src/services/Connect';
 *
 *     // retrieve all iOn specific alert types ...
 *     const alertType: AlertType[] = await getNotificationTypes();
 *
 * ```
 *
 *  @param   {boolean} systemDefined When true, results will include systemDefined records.
 *  @param   {boolean} deleted When true, results will include deleted records.
 * @returns  {Promise<AlertType[]>} The retrieved AlertType collection.
 */
export const getNotificationTypes = async(systemDefined = false, deleted = false): Promise<AlertType[]> => {
  const results = await client.get(url(`/alerts/types?systemDefined=${systemDefined}&deleted=${deleted}`));
  return parseCollection(results, 'alertType') as AlertType[];
};

/**
 * @function getAlertTypeTriggers
 *
 * The getAlertTypeTriggers function retrieves all Alert Type Triggers for the given
 * Alert Type Id.
 *
 * ```typescript
 *
 *     import {getAlertTypeTriggers} from '@ion/core/src/services/Connect';
 *
 *     const triggers: AlertTrigger[] = await getAlertTypeTriggers(alertTypeId);
 *
 * ```
 *
 * @param   {number} alertTypeId The id of the Alert Type for which the AlertTriggers
 *          are to be retrieved.
 * @returns {Promise<AlertTrigger[]>} Array of AlertTrigger instances for the alert type.
 */
export const getAlertTypeTriggers = async(alertTypeId: number): Promise<AlertTrigger[]> => {
  const results = await client.get(url(`/alerts/types/${alertTypeId}/triggers`));
  const parsedResults = parseCollection(results, 'alertTrigger') as AlertTrigger[];
  return sortby(parsedResults, 'name');
};

/**
 * @function getAlertActionTypes
 *
 * The getAlertActionTypes function retrieves all Alert Action Types defined in CTC.
 *
 * ```typescript
 *
 *     import {getAlertActionTypes} from '@ion/core/src/services/Connect';
 *
 *     const actionTypes: AlertActionType[] = await getAlertActionTypes();
 *
 * ```
 *
 * @returns {Promise<AlertActionType[]>} Array of AlertActionType instances.
 */
export const getAlertActionTypes = async(): Promise<AlertActionType[]> => {
  const response = await client.get(url('/alerts/actions/alertactiontypes'));
  const results = response?.data?.response?.[0].result as GenericObject;
  return results?.alertActionTypeResponse?.alertActionTypes as AlertActionType[];
};

/**
 * Provides a paginated search implementation against CTC AEMPConfig Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadAEMPConfigs} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 10 aempconfigs within the given account ...
 *    const {aempconfigs, totalCount} = await loadAEMPConfigs({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 10
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve AEMPConfig entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all AEMPConfigs
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadAEMPConfigResult>
 */
export const loadAEMPConfigs = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadAEMPConfigParams): Promise<LoadAEMPConfigResult> => {
  const uri = `/aemppollerconfigurator/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, false));
  const response: LoadAEMPConfigResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : 1000,
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    aempconfigs : results?.map(({aempPollerConfigurator}) => aempPollerConfigurator),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all aempconfigs for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all aempconfigs in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a aempconfigs.
 *
 * @param {LoadAEMPConfigParams} params The parameters against which the aempconfigs are
 *        to be retrieved.
 */
export const loadAllAEMPConfigs = async(params: LoadAEMPConfigParams): Promise<AEMPConfig[]> => {
  const aempconfigs = await loadAll(loadAEMPConfigs, params, 'aempconfigs');
  return aempconfigs;
};
/**
 * The createAEMPConfig function creates a new AEMPConfig Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createAEMPConfig} from '@ion/core/src/services/Connect';
 *
 *     const created = await createAEMPConfig(aempConfig);
 *
 * ```
 *
 * @param    {AEMPConfig} aempPollerConfigurator The CTC AEMPConfig entity which is to be created.
 * @returns  {Promise<AEMPConfig>} The newly created AEMPConfig entity.
 */
export const createAEMPConfig = async(aempPollerConfigurator: AEMPConfig): Promise<AEMPConfig> => {
  const results = await client.post(url('/aemppollerconfigurator'), JSON.stringify({aempPollerConfigurator}));
  return parse(results, 'aempPollerConfigurator') as AEMPConfig;
};

/**
 * The getAEMPConfig function retrieves an existing AEMPConfig Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getAEMPConfig} from '@ion/core/src/services/Connect';
 *
 *     const aempconfig = await getAEMPConfig(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC AEMPConfig entity which is to be retrieved.
 * @returns  {Promise<AEMPConfig>} The retrieved AEMPConfig entity.
 */
export const getAEMPConfig = async(id: number): Promise<AEMPConfig> => {
  const results = await client.get(url(`/aemppollerconfigurator/${id}`));
  return parse(results, 'aempPollerConfigurator') as AEMPConfig;
};

/**
 * The updateAEMPConfig function updates an existing AEMPConfig Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateAEMPConfig} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAEMPConfig(aempConfig);
 *
 * ```
 *
 * @param    {AEMPConfig} aempPollerConfigurator The CTC AEMPConfig entity which is to be updated.
 * @returns  {Promise<AEMPConfig>} The updated AEMPConfig entity.
 */
export const updateAEMPConfig = async(aempPollerConfigurator: AEMPConfig): Promise<AEMPConfig> => {
  const results = await client.put(url(`/aemppollerconfigurator/${aempPollerConfigurator.id}`), JSON.stringify({aempPollerConfigurator}));
  return parse(results, 'aempPollerConfigurator') as AEMPConfig;
};

/**
 * The deleteAEMPConfig function deletes an existing AEMPConfig Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAEMPConfig} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAEMPConfig(aempconfig);
 *
 * ```
 *
 * @param   {AEMPConfig} aempPollerConfigurator The CTC AEMPConfig entity which is to be deleted.
 * @returns Promise<AEMPConfig> The deleted AEMPConfig entity or null if not found.
 */
export const deleteAEMPConfig = async(aempPollerConfigurator: AEMPConfig): Promise<AEMPConfig | null> => {
  const results = await client.delete(url(`/aemppollerconfigurator/${aempPollerConfigurator.id}`));
  return parse(results, 'aempPollerConfigurator') as AEMPConfig;
};

/**
 * @function loadRoles
 *
 * Provides a paginated search implementation against CTC Role Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadRoles} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 roles within the given account ...
 *    const {roles, totalCount} = await loadRoles({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Role entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Roles
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadRolesResult>
 */
export const loadRoles = async({
  accountId,
  applicationKeys,
  application = get('appKey'),
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeAppKey = false,
  includeSubGroups = false,
  isExtensions = true
}: LoadRolesParams): Promise<LoadRolesResult> => {
  const extension = isExtensions ? '&include=extensions' : '';
  const uri       = `/roles/search?v=${config.ctcVersion}${extension}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint  = url(setHierLevel(uri, includeSubGroups));
  const hasAppKey = (includeAppKey && !includeSubGroups) || !includeAppKey;

  const response: LoadRolesResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {
        account : accountId,
        ...(hasAppKey && {
          application : applicationKeys || application
        }),
        ...filterOn
      }
    }
  }));

  const {results, totalCount, _links} = response.data?.response;

  return {
    roles : results?.map(({role}) => role),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all roles for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all roles in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a roles.
 *
 * @param {LoadRolesParams} params The parameters against which the roles are to be
 *        retrieved.
 */
export const loadAllRoles = async(params: LoadRolesParams, isParallel = false): Promise<Role[]> => {
  const roles = await loadAll(loadRoles, params, 'roles', isParallel);
  return roles;
};

/**
 * @function getAccountRoles
 *
 * Retrieves all roles for the given account across all applications.
 * Paginates automatically and returns the full result set.
 *
 * ```typescript
 *    import {getAccountRoles} from '@ion/core/src/services/Connect';
 *
 *    const roles = await getAccountRoles(accountId);
 *
 * ```
 */
export const getAccountRoles = async(
  accountId: number,
  includeSubGroups: boolean = false,
  application?: string,
  isParallel = false
// eslint-disable-next-line max-params
): Promise<Role[]> => {
  return await loadAllRoles(
    {accountId, includeSubGroups, application, pageId: 1, pageSize: 100},
    isParallel
  );
};

/**
 * @function getApplicationRoles
 *
 * Retrieves the roles for the given application key.
 *
 * ```typescript
 *    import {getApplicationRoles} from '@ion/core/src/services/Connect';
 *
 *    const roles = await getApplicationRoles(appKey);
 *
 * ```
 */
export const getApplicationRoles = (appKey: string, accountId?: number): Promise<Role[]> => {
  return getAccountRoles(accountId, false, appKey);
};

export const getAccountRolesNested = async(accountId: number, isParallel = false): Promise<Role[]> => {
  return await getAccountRoles(accountId, true, undefined, isParallel);
};

/**
 * @function getRoles
 *
 * Retrieves the roles for the given account id and application key.
 *
 * ```typescript
 *    import {getRoles} from '@ion/core/src/services/Connect';
 *
 *    const roles = await getRoles(accountId, appKey);
 *
 * ```
 */
export const getRoles = async(accountId: number, appKey: string): Promise<Role[]> => {
  const response = await client.post(url('/roles/search'), JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : {
        application : appKey,
        account     : accountId
      }
    }
  }));
  return parseCollection(response, 'role');
};

/**
 *
 * The getUserRoles method, as the name suggests, allows the user to get
 * a list of Roles based on account number.
 *
 *    import {getUserRoles} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getUserRoles(accountId);
 *
 *
 */
export const getUserRoles = async(id): Promise<Role[]> => {
  const result = await client.get(url(`/accounts/${id}/roles`));
  return parseCollection(result, 'role');
};

/**
 * @function createRole
 *
 * The createRole function creates a new Role Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createRole} from '@ion/core/src/services/Connect';
 *
 *     const created = await createRole(role);
 *
 * ```
 *
 * @param    {Role} role The CTC Role entity which is to be created.
 * @returns  {Promise<Role>} The newly created Role entity.
 */
export const createRole = async(role: Role): Promise<Role> => {
  const results = await client.post(url('/roles'), JSON.stringify({role}));
  return parse(results, 'role') as Role;
};

/**
 * @function getRole
 *
 * The getRole function updates retrieved an existing Role Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getRole} from '@ion/core/src/services/Connect';
 *
 *     const role = await getRole(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Role entity which is to be retrieved.
 * @returns  {Promise<Role>} The updated Role entity.
 */
export const getRole = async(id: number): Promise<Role> => {
  const results = await client.get(url(`/roles/${id}`));
  return parse(results, 'role') as Role;
};

/**
 * @function updateRole
 *
 * The updateRole function updates an existing Role Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateRole} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateRole(role);
 *
 * ```
 *
 * @param    {Role} role The CTC Role entity which is to be updated.
 * @returns  {Promise<Role>} The updated Role entity.
 */
export const updateRole = async(role: Role): Promise<Role> => {
  const results = await client.put(url(`/roles/${role.id}`), JSON.stringify({role}));
  return parse(results, 'role') as Role;
};

/**
 * @function deleteRole
 *
 * The deleteRole function deletes an existing Role Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteRole} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteRole(role);
 *
 * ```
 *
 * @param   {Role} role The CTC Role entity which is to be deleted.
 * @returns Promise<Role> The deleted Role entity or null if not found.
 */
export const deleteRole = async(role: Role): Promise<Role | null> => {
  const results = await client.delete(url(`/roles/${role.id}`));
  return parse(results, 'role') as Role;
};

/**
 * Searches for report information of devices based on the given search type and accountId.
 *
 * ```typescript
 *
 * import {searchDevices} from '@ion/core/src/services/Connect';
 *
 * const devicesInformation = await searchDevices(DeviceSearchTypes.DEVICE_MODEL, accountId);
 *
 * ```
 */
export const searchDevices = async(
  deviceSearchType: DeviceSearchTypes,
  accountId: number,
  hierLevel = false,
  queryString = 'id:*',
  query = null
) => { // eslint-disable-line max-params
  // We only need the aggregations, and if this is 0 it will default to 10. Therefore it needs to be 1.
  const pageSize = 1;
  const uri = `/devices/smartsearch?v=${config.ctcVersion}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, hierLevel), Service.PULS);
  const devicesSearch = {
    search : {
      accountId
    }
  };
  if (query) {
    devicesSearch.search.query = {
      ...query?.query,
      aggregations : getAggregationsFromSearchType(deviceSearchType, true)
    };
  } else {
    devicesSearch.search.queryString = queryString;
    devicesSearch.search.aggregations = getAggregationsFromSearchType(deviceSearchType);
  }
  const response = await client.post(endpoint, {...devicesSearch});
  return response;
};

/**
 * Retrieves device communication based on the provided search type (time period).
 *
 * ```typescript
 * import {searchDeviceCommunication} from '@ion/core/src/services/Connect';
 *
 * const lastSevenDays = await searchDeviceCommunication(DeviceCommunicationsSearchTypes.LAST_7_DAYS, accountId);
 *
 * ```
 */
export const searchDeviceCommunication = async(
  searchType: DeviceCommunicationSearchTypes,
  accountId: number,
  hierLevel = false
) => {
  // We only need the aggregations, and if this is 0 it will default to 10. Therefore it needs to be 1.
  const pageSize = 1;
  const uri = `/devices/smartsearch?v=${config.ctcVersion}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, hierLevel), Service.PULS);
  const response = await client.post(endpoint, {
    search : {
      accountId   : accountId,
      queryString : `extensions.idReportTimestamp: <${getDateTimeForSearchType(searchType)}`
    }
  });
  return response;
};

/**
 * The deleteRoles function deletes existing Users (AlertConfigurations Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteRoles} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteRoles(notifications);
 *
 * ```
 *
 * @param   The CTC Users entity which are to be deleted.
 * @returns Promise<Users> The deleted Users entity or null if not found.
 */
export const destroyRoles = async(roles: Roles): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: roles, api: deleteRole});
};

/**
 * @function loadDevices
 *
 * Provides a paginated search implementation against CTC Device Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadDevices} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 devices within the given account ...
 *    const {devices, totalCount} = await loadDevices({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Device entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Devices
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadDevicesResult>
 */
export const loadDevices = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  withLocation = false,
  includeSubGroups = false,
  includeAccountFilter = true
}: LoadDevicesParams): Promise<LoadDevicesResult> => {
  const uri = `/devices/search?v=${config.ctcVersion}&include=extensions&pg=${pageId}&pgsize=${pageSize}&withLocation=${withLocation}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const search = includeAccountFilter ? {account: accountId, ...filterOn} : {...filterOn};
  const response: LoadDevicesResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : search
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    devices : results?.map(({device}) => device),
    totalCount,
    _links
  };
};

/**
 * Loads devices' details from the PULS API gateway url.
 * Used primarily for loading dashboard device details for the drilldown drawer.
 */
export const loadPulsDevicesBySmartSearch = async({
  accountId,
  sortOn,
  queryString,
  pageId = 1,
  pageSize = 20,
  withLocation = false,
  withIdReport = false,
  includeSubGroups = false,
  includeAccountFilter = true,
  omitExtensions = false
}: LoadDevicesParams): Promise<LoadDevicesResult> => {
  let uri = `/devices/smartsearch?v=${config.ctcVersion}&withIdReport=${withIdReport}&pg=${pageId}&pgsize=${pageSize}&withLocation=${withLocation}&expand=deviceConfiguration&sort=${sortOn}`;
  uri = uri + (omitExtensions ? '' : '&include=extensions');
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.PULS);
  const search = includeAccountFilter ? {accountId, queryString} : {queryString};
  const response: LoadDevicesResponse = await client.post(endpoint, {search});
  const {results, totalCount, _links} = response.data?.response;
  return {
    devices : results?.map(({device}) => device),
    totalCount,
    _links
  };
};

/**
 *
 * Provides a paginated search implementation against CTC Device Smart Search Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadDevicesBySmartSearch} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 devices within the given account ...
 *    const {devices, totalCount} = await loadDevicesBySmartSearch({
 *      accountId,
 *      pageId           : page,
 *      pageSize         : pageSize,
 *      sortOn           : sort,
 *      queryString      : queryString
 *    });
 *
 *    // retrieve devices with each one's extended attribute document ...
 *    const {devices} = await loadDevicesBySmartSearch({
 *      accountId,
 *      queryString               : `esn:(${esn})`,
 *      includeExtendedAttributes : true
 *    });
 *
 * ```
 *
 */
export const loadDevicesBySmartSearch = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  queryString,
  customQuery,
  lastData,
  paging,
  usePulse = false,
  withLocation = false,
  withIdReport = false,
  includeGroups = false,
  includeDeviceSettings = false,
  includeExtendedAttributes = false,
  includeSubGroups = false,
  includeAccountFilter = true,
  includeSortParams = false,
  includeParams = false,
  hasPendingFileHistory = false
}: LoadDevicesParams): Promise<LoadDevicesResult> => {
  const sort       = (includeSortParams && includeParams) ? '' : `&sort=${sortOn ?? 'name'}`;
  let pagination   = paging?.getPaging(pageId, pageSize);
  if (isNil(paging)) {
    pagination = `&pg=${pageId}&pgsize=${pageSize}`;
  }

  let uri = `/devices/smartsearch?v=${config.ctcVersion}${pagination}&withLocation=${withLocation}${sort}&getFileStatus=true`;
  uri     = uri + (includeGroups ? ('&' + getQueryString({
    pendingFileHistory : hasPendingFileHistory,
    withIdReport       : withIdReport,
    expand             : 'deviceConfiguration'
  })) : '');
  uri     = uri + (includeDeviceSettings ? ('&' + getQueryString({
    include : 'deviceSettings'
  })): '');
  uri     = uri + (includeExtendedAttributes ? '&include=extensions,extAttribs' : '');

  const endpoint = url(setHierLevel(uri, includeSubGroups), Service[!usePulse ? 'Connect' : 'PulsBaseUrl']);
  const payload  = {};

  payload[customQuery ? 'query': 'queryString'] = customQuery || queryString;

  const searchTerms = includeAccountFilter ? (includeSortParams && includeParams)
    ? sortOn : {accountId, ...payload} : {...payload};

  const response: LoadDevicesResponse = await client.post(endpoint, JSON.stringify({
    search : searchTerms
  }));
  const {results, totalCount, _links} = response.data?.response;
  paging?.setLinks(_links);
  return {
    devices : results?.map(({device}) => device),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all devices for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devices in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devices.
 *
 * @param {LoadDevicesParams} params The parameters against which the devices are to be
 *        retrieved.
 */
export const loadAllDevices = async(params: LoadDevicesParams): Promise<Device[]> => {
  const devices = await loadAll(loadDevices, params, 'devices');
  return devices;
};

/**
 * A convenience function for retrieving all devices across pages. This is similar to @see loadAllDevices but
 * calls the devices smartsearch instead of the normal search with the given params.
 *
 * ```typescript
 *  import {loadAllDevicesUsingSmartSearch} from '@ion/core/src/services/Connect';
 *
 *  const smartSearchDevices = loadAllDevicesUsingSmartSearch({
 *    accountId: '2',
 *    pageId: 1,
 *    pageSize: 100,
 *    sortOn: ['name'],
 *    queryString: 'id:*'
 *  })
 * ```
 */
export const loadAllDevicesUsingSmartSearch = async(
  params: LoadDevicesParams, isParallel = false
): Promise<Devices> => {
  const devices = await loadAll(loadDevicesBySmartSearch, params, Entity.devices, isParallel);
  return devices;
};

/**
 * The createDevice function creates a new Device Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createDevice} from '@ion/core/src/services/Connect';
 *
 *     const created = await createDevice(aempConfig);
 *
 * ```
 *
 * @param    {Device} device The CTC Device entity which is to be created.
 * @returns  {Promise<Device>} The newly created Device entity.
 */
export const createDevice = async(device: Device, usePulse = false): Promise<Device> => {
  const results = await client.post(url(
    '/devices',
    Service[!usePulse ? 'Connect' : 'PulsBaseUrl']
  ), JSON.stringify({device})
  );
  return parse(results, 'device') as Device;
};

/**
 * The Email Export Large Entities function sends an email with export link.
 *
 * ```typescript
 *
 *     import {emailExportLargeEntities} from '@ion/core/src/services/Connect';
 *
 *     const response = await emailExportLargeEntities(queryString);
 *
 * ```
 *
 * @param    {Object} query The CTC Device entity which is to be created.
 */
export const emailExportLargeEntities = async(query: Object) => {
  try {
    const results = await client.post(url('/entities/export?v=2', Service.ApiBaseUrl), query);
    return results;
  } catch (err) {
    return err;
  }
};

/**
 * The Task Email Export Large Entities function sends an email with export link.
 *
 * ```typescript
 *
 *     import {taskEmailExportLargeEntities} from '@ion/core/src/services/Connect';
 *
 *     const response = await taskEmailExportLargeEntities(queryString);
 *
 * ```
 */
export const taskEmailExportLargeEntities = async(taskId: string, query: Object) => {
  const results = await client.post(url(`/tasks/${taskId}/export`, Service.ApiBaseUrl), query);
  return parse(results, 'task') as OperationTask;
};

/**
 * Load Device Service status from the Crashboxx gateway url.
 *
 * ```typescript
 *
 *     import {getServiceStatus} from '@ion/core/src/services/Connect';
 *
 *     const response = await getServiceStatus(deviceId);
 *
 * ```
 *
 * @param    {string} esn The esn of the CTC Device entity which is to be retrieved.
 * @returns  {Promise<any>} The retrieved device service status.
 */
export const getServiceStatus = async(esn: string): Promise<any> => {
  const results = await client.post(url(
    '/vas/summary/search', Service.Crashboxx), JSON.stringify({
    search : {
      searchTerms : {
        deviceId : esn
      }
    }
  })
  );
  return results.data?.response;
};

/**
 * Load device details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getDeviceByPuls} from '@ion/core/src/services/Connect';
 *
 *     const response = await getDeviceByPuls(deviceId);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Device entity which is to be retrieved.
 * @returns  {Promise<Device>} The retrieved Device entity.
 */
export const getDeviceByPuls = async(id: number, architecture = null, includeExtensions = true): Promise<Device> => {
  let groupParam = 'include=groups&';
  if (architecture) {
    groupParam = 'include=groups,deviceSettings&';
  }
  const extensionParam = includeExtensions ? 'include=extensions,extAttribs' : '';
  const uri = `/devices/${id}?${groupParam}${extensionParam}&expand=deviceConfiguration&withIdReport=true&withLocation=true`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return parse(response, 'device') as Device;
};

/**
 * Load Device Shipping details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getDeviceShippingInfoByPuls} from '@ion/core/src/services/Connect';
 *
 *     const response = await getDeviceShippingInfoByPuls(identifier);
 *
 * ```
 *
 * @param    {string} identifier The identifier (ESN, Serial Number, etc) of the CTC Device which shipping info
 *                               should be retrieved for.
 * @returns  {Promise<any>} The retrieved Device shipping entity.
 */
export const getDeviceShippingInfoByPuls = async(identifier: string): Promise<any> => {
  const uri = `/devices/${identifier}/shippinginfo`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Load Device Manufacturing details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getDeviceManufacturingInfoByPuls} from '@ion/core/src/services/Connect';
 *
 *     const response = await getDeviceManufacturingInfoByPuls(deviceId);
 *
 * ```
 *
 * @param    {string} identifier The identifier (ESN, Serial Number, etc) of the CTC Device entity which
 *                               is to be retrieved.
 * @returns  {Promise<any>} The retrieved Device  Manufacturing entity.
 */
export const getDeviceManufacturingInfoByPuls = async(identifier: string, isCMF = false): Promise<any> => {
  try {
    const uri       = `/devices/${isCMF ? 'cmf/' : ''}${identifier}/manufacturinginfo?v=2`;
    const response  = await client.get(url(uri, Service.PulsBaseUrl));
    const results   = response?.data?.response?.results?.[0] || {};
    return results;
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 * Load Health Event details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getHealthEvent} from '@ion/core/src/services/Connect';
 *
 *     const response = await getESNChangeEvents(deviceId);
 *
 * ```
 *
 * @param    {string} esn The esn of the CTC Device entity which is to be retrieved.
 * @returns  {Promise<any>} The retrieved Device  Manufacturing entity.
 */
export const getESNChangeEvents = async({esn}: any, type=null): Promise<any> => {
  const query = !isNil(type) ?`?eventTypeId=${type}` : '';
  const uri   = `/changeEvent/esn/${esn}${query}`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  const {results, totalCount, _links} = response.data?.response || {};
  return {healthEvents: response.data || []};
};

/**
 * Load Current File History details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getCurrentFileHistory} from '@ion/core/src/services/Connect';
 *
 *     const response = await getCurrentFileHistory(identifier);
 *
 * ```
 *
 * @param    {string} identifier The identifier (ESN, Serial Number, etc) of the CTC Device entity which
 *                               is to be retrieved.
 * @returns  {Promise<any>} The retrieved File history entity.
 */
export const getCurrentFileHistory = async(identifier: string): Promise<any> => {
  const uri = `/devices/${identifier}/filehistory/pending`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Load Current File History details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getFileHistoryCurrent} from '@ion/core/src/services/Connect';
 *
 *     const response = await getFileHistoryCurrent(identifier);
 *
 * ```
 *
 * @param    {string} identifier The identifier (ESN, Serial Number, etc) of the CTC Device entity which
 *                               is to be retrieved.
 * @returns  {Promise<any>} The retrieved File history entity.
 */
export const getFileHistoryCurrent = async(identifier: string): Promise<any> => {
  const uri = `/devices/${identifier}/filehistory/current`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Load File History details from the PULS API gateway url.
 *
 * ```typescript
 *
 *     import {getFileHistory} from '@ion/core/src/services/Connect';
 *
 *     const response = await getFileHistory(identifier);
 *
 * ```
 *
 * @param    {string} identifier The identifier (ESN, Serial Number, etc) of the CTC Device entity which
 *                               is to be retrieved.
 * @returns  {Promise<any>} The retrieved File history entity.
 */
export const getFileHistory = async(identifier: Object): Promise<any> => {
  const uri = `/devices/${identifier}/filehistory?page=1&size=10000`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Creates one or more offline CAN requests for a given ESN.
 *
 * @param payload object containing `esn` and `canRequests`.
 */
export const createOfflineCanRequest = async(
  payload: CreateOfflineCanRequestPayload
): Promise<OfflineCanApiResponse<OfflineCanRequestResult>> => {
  const uri = '/ve-scout/offlinemode/can-request';
  const response = await client.post(url(uri, Service.PulsBaseUrl), JSON.stringify(payload));
  return response?.data;
};

/**
 * Retrieves offline CAN requests using optional query filters
 * (e.g. `esn`, `status`, `createdOn[gte]`, `createdOn[lte]`).
 *
 * @param query optional query filter object.
 */
export const loadOfflineCanRequests = async(
  query: LoadOfflineCanRequestsParams = {}
): Promise<OfflineCanApiResponse<OfflineCanRequestResult>> => {
  const normalizedQuery = removeUndefined({
    pg               : query?.pg,
    pgsize           : query?.pgSize,
    esn              : query?.esn,
    createdBy        : query?.createdBy,
    RequestId        : query?.requestId,
    status           : query?.status,
    'createdOn[gte]' : query?.['createdOn[gte]'],
    'createdOn[lte]' : query?.['createdOn[lte]'],
    sort             : query?.sort,
    order            : query?.order
  });
  const queryString = qs.stringify(normalizedQuery, {skipNulls: true});
  const uri = `/ve-scout/offlinemode/can-request${queryString ? `?${queryString}` : ''}`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Retrieves an offline CAN request by request id.
 *
 * @param requestId the offline CAN request id.
 */
export const getOfflineCanRequest = async(
  requestId: string
): Promise<OfflineCanApiResponse<OfflineCanRequestResult>> => {
  const uri = `/ve-scout/offlinemode/can-request/${requestId}`;
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  return response?.data;
};

/**
 * Replays one or more final-state offline CAN requests for a given ESN.
 *
 * @param payload object containing `esn` and up to 15 `requestIds`.
 */
export const replayOfflineCanRequest = async(
  payload: ReplayOfflineCanRequestPayload
): Promise<OfflineCanApiResponse<OfflineCanRequestResult>> => {
  const uri = '/ve-scout/offlinemode/can-request/replay';
  const response = await client.post(url(uri, Service.PulsBaseUrl), JSON.stringify(payload));
  return response?.data;
};

/**
 * Updates an offline CAN request status by request id (e.g. CANCEL / RETRY).
 *
 * ```typescript
 * import {updateOfflineCanRequest} from '@ion/core/src/services/Connect';
 * ...
 *
 * const result = await updateOfflineCanRequest('req-1', {
 *   status : OfflineCanRequestAction.Cancel
 * });
 * ```
 *
 * @param requestId the offline CAN request id for the update route.
 * @param payload object containing the target `status` action.
 */
export const updateOfflineCanRequest = async(
  requestId: string,
  payload: UpdateOfflineCanRequestPayload
): Promise<OfflineCanApiResponse<UpdateOfflineCanRequestResult>> => {
  const uri = `/ve-scout/offlinemode/can-request/${requestId}`;
  const response = await client.put(url(uri, Service.PulsBaseUrl), JSON.stringify(payload));
  return response?.data;
};

/**
 * This getDeviceConfigurations function retrieves the DeviceConfigurations
 * within the give Account by account id.
 *
 * ```typescript
 *    import {getDeviceConfigurations} from '@ion/core/src/services/Connect';
 *
 *    const deviceConfigurations = await getDeviceConfigurations(accountId);
 *
 * ```
 *
 * @param  {number} accountId The id of the account for which the DeviceConfigurations
 * are to be retrieved
 */
export const getDeviceConfigurations = async(accountId: number, hierarchy = false): Promise<DeviceConfiguration[]> => {
  const response = await client.get(url(`/accounts/${accountId}/deviceconfigurations/?hierarchy=${hierarchy}`));
  return parseCollection(response, 'deviceConfiguration') as DeviceConfiguration[];
};

/**
 * @function loadAccounts
 *
 * Provides a paginated search implementation against CTC Account Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadAccounts} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 groups within the given account ...
 *    const {groups, totalCount} = await loadAccounts({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Account entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Accounts
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadAccountsResult>
 */
export const loadAccounts = async({
  parentAccountId,
  subAccountIds,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  groupSearchKey = 'id',
  includeSubGroups = false,
  includeGlobalSearch = false
}: LoadAccountsParams): Promise<LoadAccountsResult> => {
  const uri            = `/accounts/search?v=${config.ctcVersion}&include=extensions,extAttribs&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint       = url(setHierLevel(uri, includeSubGroups));
  const getSubAccounts = includeSubGroups && subAccountIds;
  const search = !includeGlobalSearch ? {
    [!includeSubGroups ? 'parent' : groupSearchKey] : (!getSubAccounts ? parentAccountId : subAccountIds),
    ...filterOn
  } : {...filterOn};
  const response: LoadAccountsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : search
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    accounts : results?.map(({account}) => account),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all accounts for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all accounts in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a accounts.
 *
 * @param {LoadAccountsParams} params The parameters against which the accounts are to be
 *        retrieved.
 */
export const loadAllAccounts = async(params: LoadAccountsParams): Promise<Account[]> => {
  const accounts = await loadAll(loadAccounts, params, 'accounts');
  return accounts;
};

/**
 * @function createAccount
 *
 * The createAccount function creates a new Account Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createAccount} from '@ion/core/src/services/Connect';
 *
 *     const created = await createAccount(account);
 *
 * ```
 *
 * @param    {Account} account The CTC Account entity which is to be created.
 * @returns  {Promise<Account>} The newly created Account entity.
 */
export const createAccount = async(account: Account): Promise<Account> => {
  const results = await client.post(url('/accounts'), JSON.stringify({account}));
  return parse(results, 'account') as Account;
};

/**
 * The createEnterpriseAccount function creates a new Account, roles and users within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {createEnterpriseAccount} from '@ion/core/src/services/Connect';
 *
 *     const created = await createEnterpriseAccount(account);
 *
 * ```
 *
 * @param    {Account} account The CTC Account entity which is to be created.
 * @returns  {Promise<Account>} The newly created Account entity.
 */
export const createEnterpriseAccount = async(account: Account): Promise<any> => {
  const results = await client.post(
    url('/salesforce/v1/subaccounts', Service.ApiBaseUrl),
    safeJSONStringify({
      account,
      apiAccess : account.apiAccess,
      users     : account.users
    })
  );
  const response = results.data?.response;
  return {
    results : parse(results, 'account') as Account,
    errors  : response?.errors
  };
};

/**
 * @function getAccount
 *
 * The getAccount function retrieves an existing Account Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getAccount} from '@ion/core/src/services/Connect';
 *
 *     const account = await getAccount(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Account entity which is to be retrieved.
 * @returns  {Promise<Account>} The retrieved Account entity.
 */
export const getAccount = async(id: number, api: AxiosInstance = client): Promise<Account> => {
  const results = await api.get(url(`/accounts/${id}`));
  return parse(results, 'account') as Account;
};

/**
 * @function updateAccount
 *
 * The updateAccount function updates an existing Account Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateAccount} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateAccount(account);
 *
 * ```
 *
 * @param    {Account} account The CTC Account entity which is to be updated.
 * @returns  {Promise<Account>} The updated Account entity.
 */
export const updateAccount = async(account: Account): Promise<Account> => {
  const results = await client.put(url(`/accounts/${account.id}`), JSON.stringify({account}));
  return parse(results, 'account') as Account;
};

/**
 * @function deleteAccount
 *
 * The deleteAccount function deletes an existing Account Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAccount} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAccount(account);
 *
 * ```
 *
 * @param   {Account} account The CTC Account entity which is to be deleted.
 * @returns Promise<Account> The deleted Account entity or null if not found.
 */
export const deleteAccount = async(account: Account): Promise<Account | null> => {
  const results = await client.delete(url(`/accounts/${account.id}`));
  return parse(results, 'account') as Account;
};

/**
 * @function loadUsers
 *
 * Provides a paginated search implementation against CTC User Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadUsers} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 users within the given account ...
 *    const {users, totalCount} = await loadUsers({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve User entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Users
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadUsersResult>
 */
export const loadUsers = async({
  accountId,
  sortOn,
  name,
  pageId = 1,
  pageSize = 20,
  maxResults = 100,
  filterOn = {},
  includeSubGroups = false,
  includeGlobalSearch = false
}: LoadUsersParams): Promise<LoadUsersResult> => {
  let search;

  const uri      = `/users/search?v=${config.ctcVersion}&include=extensions,extAttribs&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));

  if (!isNil(name)) {
    search = {account: accountId, 'role.name': `*${name}*`, ...filterOn};
  } else {
    search = !includeGlobalSearch ? {account: accountId, ...filterOn} : {...filterOn};
  }

  const response: LoadUsersResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : search,
      maxResults
    }
  }));

  const {results, totalCount, _links} = response.data?.response;

  return {
    users : results?.map(({user}) => user),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all users for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all users in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a users.
 *
 * @param {LoadUsersParams} params The parameters against which the users are to be
 *        retrieved.
 */
export const loadAllUsers = async(params: LoadUsersParams): Promise<User[]> => {
  const users = await loadAll(loadUsers, params, 'users');
  return users;
};

/**
 * @function createUser
 *
 * The createUser function creates a new User Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createUser} from '@ion/core/src/services/Connect';
 *
 *     const created = await createUser(user);
 *
 * ```
 *
 * @param    {User} user The CTC User entity which is to be created.
 * @returns  {Promise<User>} The newly created User entity.
 */
export const createUser = async(user: User, api: AxiosInstance = client): Promise<User> => {
  const results = await api.post(url('/users'), JSON.stringify({user}));
  return parse(results, 'user') as User;
};

/**
 * @function getUser
 *
 * The getUser function retrieves an existing User Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getUser} from '@ion/core/src/services/Connect';
 *
 *     const user = await getUser(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC User entity which is to be retrieved.
 * @returns  {Promise<User>} The retrieved User entity.
 */
export const getUser = async(id: number, api: AxiosInstance = client): Promise<User> => {
  const results = await api.get(url(`/users/${id}`));
  return parse(results, 'user') as User;
};

/**
 * Retrieves the operator assigned to the provided user.
 *
 * @param {number} id The user id whose assigned operator is to be retrieved.
 * @returns {Promise<Operator>} The assigned operator entity.
 */
export const getUserOperator = async(id: number): Promise<Operator> => {
  const results = await client.get(url(`/users/${id}/operator`));
  return parse(results, 'operator') as Operator;
};

/**
 * @function updateUser
 *
 * The updateUser function updates an existing User Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateUser} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateUser(user);
 *
 * ```
 *
 * @param    {User} user The CTC User entity which is to be updated.
 * @returns  {Promise<User>} The updated User entity.
 */
export const updateUser = async(user: User, api: AxiosInstance = client): Promise<User> => {
  const results = await api.put(url(`/users/${user.id}`), JSON.stringify({user}));
  return parse(results, 'user') as User;
};

/**
 *
 * The bulkUpdateUsers function updates an existing Users Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {bulkUpdateUsers} from '@ion/core/src/services/Connect';
 *
 *     const {results} = await bulkUpdateUsers(users);
 *
 * ```
 */
export const bulkUpdateUsers = async(users: Users): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: users, api: updateUser});
};

/**
 * The changeUserPassword function allows user to change his password within the CTC Platform.
 *
 * ```typescript
 *
 *    import {changeUserPassword} from '@ion/core/src/services/Connect';
 *
 *    const created = changeUserPassword(id, {password: value});
 *
 * ```
 */
export const changeUserPassword = async(id: number, passwordChange: PasswordChange,
  notify: boolean = false): Promise<User> => {
  const response = await client.put(url(`/users/${id}/password?notify=${notify}&include=false`), safeJSONStringify({passwordChange}));
  return parse(response, 'user') as User;
};

/**
 * @function deleteUser
 *
 * The deleteUser function deletes an existing User Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteUser} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteUser(user);
 *
 * ```
 *
 * @param   {User} user The CTC User entity which is to be deleted.
 * @returns Promise<User> The deleted User entity or null if not found.
 */
export const deleteUser = async(user: User, api: AxiosInstance = client): Promise<User | null> => {
  const results = await api.delete(url(`/users/${user.id}`));
  return parse(results, 'user') as User;
};

/**
 * @function deleteUsers
 *
 * The deleteUsers function deletes existing Users (AlertConfigurations Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteUsers} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteUsers(notifications);
 *
 * ```
 *
 * @param   {Users}        The CTC Users entity which are to be deleted.
 * @returns Promise<Users> The deleted Users entity or null if not found.
 */
export const deleteUsers = async(
  users: Users): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: users, api: deleteUser});
};

/**
 * @function loadSchedules
 *
 * Provides a paginated search implementation against CTC Schedule Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadSchedules} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 schedules within the given account ...
 *    const {schedules, totalCount} = await loadSchedules({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Schedule entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Schedules
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadSchedulesResult>
 */
export const loadSchedules = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadSchedulesParams): Promise<LoadSchedulesResult> => {
  const uri = `/schedules/search?v=${config.ctcVersion}&include=extensions&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadSchedulesResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    schedules : results?.map(({schedule}) => schedule),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all schedules for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all schedules in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a schedules.
 *
 * @param {LoadSchedulesParams} params The parameters against which the schedules are to be
 *        retrieved.
 */
export const loadAllSchedules = async(params: LoadSchedulesParams): Promise<Schedule[]> => {
  const schedules = await loadAll(loadSchedules, params, 'schedules');
  return schedules;
};

/**
 * @function createSchedule
 *
 * The createSchedule function creates a new Schedule Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createSchedule} from '@ion/core/src/services/Connect';
 *
 *     const created = await createSchedule(schedule);
 *
 * ```
 *
 * @param    {Schedule} schedule The CTC Schedule entity which is to be created.
 * @returns  {Promise<Schedule>} The newly created Schedule entity.
 */
export const createSchedule = async(schedule: Schedule): Promise<Schedule> => {
  const results = await client.post(url('/schedules'), JSON.stringify({schedule}));
  return parse(results, 'schedule') as Schedule;
};

/**
 * @function getSchedule
 *
 * The getSchedule function retrieves an existing Schedule Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getSchedule} from '@ion/core/src/services/Connect';
 *
 *     const schedule = await getSchedule(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Schedule entity which is to be retrieved.
 * @returns  {Promise<Schedule>} The retrieved Schedule entity.
 */
export const getSchedule = async(id: number): Promise<Schedule> => {
  const results = await client.get(url(`/schedules/${id}`));
  return parse(results, 'schedule') as Schedule;
};

/**
 * @function updateSchedule
 *
 * The updateSchedule function updates an existing Schedule Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateSchedule} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateSchedule(schedule);
 *
 * ```
 *
 * @param    {Schedule} schedule The CTC Schedule entity which is to be updated.
 * @returns  {Promise<Schedule>} The updated Schedule entity.
 */
export const updateSchedule = async(schedule: Schedule): Promise<Schedule> => {
  const results = await client.put(url(`/schedules/${schedule.id}`), JSON.stringify({schedule}));
  return parse(results, 'schedule') as Schedule;
};

/**
 * @function updateSchedules
 *
 * The updateSchedules function updates existing Schedules Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateSchedules} from '@ion/core/src/services/Connect';
 *
 *     const {results, errors} = await updateSchedules(schedules);
 *
 * ```
 *
 * @param    {Schedules} schedules The CTC Schedules entity which are to be updated.
 * @returns  {Promise<Schedules>} The updated Schedules entity.
 */
export const updateSchedules = async(
  schedules: Schedules): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: schedules, api: updateSchedule});
};

/**
 * @function deleteSchedule
 *
 * The deleteUser function deletes an existing Schedule Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteUser} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteSchedule(user);
 *
 * ```
 *
 * @param   {Schedule} schedule The CTC Schedule entity which is to be deleted.
 * @returns Promise<Schedule> The deleted Schedule entity or null if not found.
 */
export const deleteSchedule = async(schedule: Schedule): Promise<Schedule | null> => {
  const results = await client.delete(url(`/schedules/${schedule.id}`));
  return parse(results, 'schedule') as Schedule;
};

/**
 * @function deleteSchedules
 *
 * The deleteSchedules function deletes existing Schedule (Schedules Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteSchedules} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteSchedules(schedules);
 *
 * ```
 *
 * @param   {Schedules} schedules The CTC Schedules entity which are to be deleted.
 * @returns Promise<Schedules> The deleted Schedules entity or null if not found.
 */
export const deleteSchedules = async(
  schedules: Schedules): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: schedules, api: deleteSchedule});
};

/**
 * @function loadIOProfiles
 *
 * Provides a paginated search implementation against CTC IOProfile Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadIOProfiles} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 ioprofiles within the given account ...
 *    const {ioprofiles, totalCount} = await loadIOProfiles({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve IOProfile entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all IOProfiles
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadIOProfilesResult>
 */
export const loadIOProfiles = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadIOProfilesParams): Promise<LoadIOProfilesResult> => {
  const uri = `/ioprofiles/search?v=${config.ctcVersion}&include=extensions&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadIOProfilesResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    ioprofiles : results?.map(({ioProfile}) => ioProfile),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all ioprofiles for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all ioprofiles in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a ioprofiles.
 *
 * @param {LoadIOProfilesParams} params The parameters against which the ioprofiles are
 *        to be retrieved.
 */
export const loadAllIOProfiles = async(params: LoadIOProfilesParams): Promise<IOProfile[]> => {
  const ioprofiles = await loadAll(loadIOProfiles, params, 'ioprofiles');
  return ioprofiles;
};

/**
 * @function createIOProfile
 *
 * The createIOProfile function creates a new IOProfile Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createIOProfile} from '@ion/core/src/services/Connect';
 *
 *     const created = await createIOProfile(ioprofile);
 *
 * ```
 *
 * @param    {IOProfile} ioProfile The CTC IOProfile entity which is to be created.
 * @returns  {Promise<IOProfile>} The newly created IOProfile entity.
 */
export const createIOProfile = async(ioProfile: IOProfile): Promise<IOProfile> => {
  const results = await client.post(url('/ioprofiles'), JSON.stringify({ioProfile}));
  return parse(results, 'ioProfile') as IOProfile;
};

/**
 * @function getIOProfile
 *
 * The getIOProfile function retrieves an existing IOProfile Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getIOProfile} from '@ion/core/src/services/Connect';
 *
 *     const ioprofile = await getIOProfile(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC IOProfile entity which is to be retrieved.
 * @returns  {Promise<IOProfile>} The retrieved IOProfile entity.
 */
export const getIOProfile = async(id: number): Promise<IOProfile> => {
  const results = await client.get(url(`/ioprofiles/${id}`));
  return parse(results, 'ioProfile') as IOProfile;
};

/**
 * @function updateIOProfile
 *
 * The updateIOProfile function updates an existing IOProfile Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateIOProfile} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateIOProfile(ioprofile);
 *
 * ```
 *
 * @param    {IOProfile} ioProfile The CTC IOProfile entity which is to be updated.
 * @returns  {Promise<IOProfile>} The updated IOProfile entity.
 */
export const updateIOProfile = async(ioProfile: IOProfile): Promise<IOProfile> => {
  const results = await client.put(url(`/ioprofiles/${ioProfile.id}`), JSON.stringify({ioProfile}));
  return parse(results, 'ioProfile') as IOProfile;
};

/**
 * @function deleteIOProfile
 *
 * The deleteIOProfile function deletes an existing IOProfile Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteIOProfile} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteIOProfile(ioprofile);
 *
 * ```
 *
 * @param   {IOProfile} ioProfile The CTC IOProfile entity which is to be deleted.
 * @returns Promise<IOProfile> The deleted IOProfile entity or null if not found.
 */
export const deleteIOProfile = async(ioProfile: IOProfile): Promise<IOProfile | null> => {
  const results = await client.delete(url(`/ioprofiles/${ioProfile.id}`));
  return parse(results, 'ioProfile') as IOProfile;
};

/**
 * @function loadOperators
 *
 * Provides a paginated search implementation against CTC Operator Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadOperators} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 drivers within the given account ...
 *    const {drivers, totalCount} = await loadOperators({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Operator entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Operators
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadOperatorsResult>
 */
export const loadOperators = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadOperatorsParams): Promise<LoadOperatorsResult> => {
  const uri = `/operators/search?v=${config.ctcVersion}&include=schedules,extAttribs&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadOperatorsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : 1000,
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    operators : results?.map(({operator}) => operator),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all operators for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all operators in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devices.
 *
 * @param {LoadOperatorsParams} params The parameters against which the operators are to
 *        be retrieved.
 */
export const loadAllOperators = async(params: LoadOperatorsParams): Promise<Operator[]> => {
  return await loadAll(loadOperators, params, 'operators');
};

/**
 * The createOperator function creates a new Operator Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createOperator} from '@ion/core/src/services/Connect';
 *
 *     const created = await createOperator(operator);
 *
 * ```
 *
 * @param    operator The CTC Operator entity which is to be created.
 * @param    schedules Optional list of schedules to be assigned to the operator.
 * @returns  The newly created Operator entity.
 */
export const createOperator = async(operator: Operator, schedules?: Link[]): Promise<Operator> => {
  const results = await client.post(url('/operators'), JSON.stringify({operator}));
  let entity = parse(results, 'operator') as Operator;
  if (schedules?.length) {
    entity = await createOperatorSchedules(entity, schedules);
  }
  return entity;
};

/**
 * The createOperators function creates Operators Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createOperators} from '@ion/core/src/services/Connect';
 *
 *     const created = await createOperators(operators);
 *
 * ```
 *
 * @param   operators The CTC Operators entity which are to be created.
 * @returns The created Operators entity.
 */
export const createOperators = async(
  operators: Operators): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({
    items      : operators,
    api        : createOperator,
    getOptions : (item: Operator) => item.schedules
  });
};

/**
 * @function getOperator
 *
 * The getOperator function retrieves an existing Operator Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getOperator} from '@ion/core/src/services/Connect';
 *
 *     const operator = await getOperator(id);
 *
 * ```
 *
 * @param    {number} id The id of the CTC Operator entity which is to be retrieved.
 * @returns  {Promise<Operator>} The retrieved Operator entity.
 */
export const getOperator = async(id: number): Promise<Operator> => {
  const results = await client.get(url(`/operators/${id}`));
  return parse(results, 'operator') as Operator;
};

/**
 * @function updateOperator
 *
 * The updateOperator function updates an existing Operator Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateOperator} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateOperator(operator);
 *
 * ```
 *
 * @param    operator The CTC Operator entity which is to be updated.
 * @param    schedules Optional list of schedules to be assigned to the operator.
 * @returns  The updated Operator entity.
 */
export const updateOperator = async(operator: Operator, schedules?: Link[] | []): Promise<Operator> => {
  const results = await client.put(url(`/operators/${operator.id}`), JSON.stringify({operator}));
  let entity = parse(results, 'operator') as Operator;
  if (schedules?.length) {
    entity = await updateOperatorSchedules(entity, schedules);
  } else {
    entity = await deleteOperatorSchedules(entity);
  }
  return entity;
};

/**
 * The updateOperators function updates existing Operators Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateOperators} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateOperators(operators);
 *
 * ```
 *
 * @param   operators The CTC Operators entity which are to be updated.
 * @returns The updated Operators entity.
 */
export const updateOperators = async(
  operators: Operators): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({
    items      : operators,
    api        : updateOperator,
    getOptions : (item: Operator) => item.schedules
  });
};

/**
 * @function deleteOperator
 *
 * The deleteOperator function deletes an existing Operator (Driver) Entity from the
 * CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteOperator} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteOperator(driver);
 *
 * ```
 *
 * @param   {Operator} operator The CTC Operator entity which is to be deleted.
 * @returns Promise<Operator> The deleted Operator entity or null if not found.
 */
export const deleteOperator = async(operator: Operator): Promise<Operator | null> => {
  const results = await client.delete(url(`/operators/${operator.id}`));
  return parse(results, 'operator') as Operator;
};

/**
 * @function deleteOperators
 *
 * The deleteOperators function deletes existing Drivers (AlertConfigurations Entity)
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteOperators} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteOperators(drivers);
 *
 * ```
 *
 * @param   {Drivers}        The CTC Drivers entity which are to be deleted.
 * @returns Promise<Drivers> The deleted Drivers entity or null if not found.
 */
export const deleteOperators = async(
  drivers: Operators): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: drivers, api: deleteOperator});
};

/**
 * @function getOperatorSchedules
 *
 * The getOperatorSchedules function retrieves an existing Operator Entities Schedules
 * from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getOperatorSchedules} from '@ion/core/src/services/Connect';
 *
 *     const schedules: Schedule[] = await getOperatorSchedules(operator);
 *
 * ```
 *
 * @param    {Operator} operator The operator entity for which schedules are to be retrieved.
 * @returns  {Promise<Schedule[]>} A collection of Schedules assigned to the given operator.
 */
export const getOperatorSchedules = async(operator: Operator): Promise<Schedule[]> => {
  const results = await client.get(url(`/operators/${operator.id}/schedules`));
  return parseCollection(results, 'schedule') as Schedule[];
};

/**
 * @function createOperatorSchedules
 *
 * The createOperatorSchedules function assigns Schedules to an Operator in the CTC
 * Platform.
 *
 * ```typescript
 *
 *     import {createOperatorSchedules} from '@ion/core/src/services/Connect';
 *
 *     const created: Operator = await createOperatorSchedules(operator, schedules);
 *
 * ```
 *
 * @param    {Operator} operator The operator entity for which schedules are to be assigned.
 * @param    {Link[]}   schedules The list of schedules to be assigned to the operator.
 * @returns  {Promise<Operator>} The updated Operator entity from the platform.
 */
export const createOperatorSchedules = async(operator: Operator, schedules: Link[]): Promise<Operator> => {
  const results = await client.post(url(`/operators/${operator.id}/schedules`), JSON.stringify(schedules));
  return parse(results, 'operator') as Operator;
};

/**
 * @function updateOperatorSchedules
 *
 * The updateOperatorSchedules function assigns Schedules to an Operator in the CTC
 * Platform.
 *
 * ```typescript
 *
 *     import {updateOperatorSchedules} from '@ion/core/src/services/Connect';
 *
 *     const updated: Operator = await updateOperatorSchedules(operator, schedules);
 *
 * ```
 *
 * @param    {Operator} operator The operator entity for which schedules are to be assigned.
 * @param    {Link[]}   schedules The list of schedules to be assigned to the operator.
 * @returns  {Promise<Operator>} The updated Operator entity from the platform.
 */
export const updateOperatorSchedules = async(operator: Operator, schedules: Link[]): Promise<Operator> => {
  const results = await client[schedules.length?'put':'delete'](url(`/operators/${operator.id}/schedules`), JSON.stringify(schedules));
  return parse(results, 'operator') as Operator;
};

/**
 * @function deleteOperatorSchedules
 *
 * The deleteOperatorSchedules function deletes Schedules from an Operator in the CTC
 * Platform.
 *
 * ```typescript
 *
 *     import {deleteOperatorSchedules} from '@ion/core/src/services/Connect';
 *
 *     const deleted: Operator = await deleteOperatorSchedules(operator);
 *
 * ```
 *
 * @param    {Operator} operator The operator entity for which schedules are to be assigned.
 * @returns  {Promise<Operator>} The updated Operator entity from the platform.
 */
export const deleteOperatorSchedules = async(operator: Operator): Promise<Operator> => {
  const results = await client.delete(url(`/operators/${operator.id}/schedules`));
  return parse(results, 'operator') as Operator;
};

/**
 * @function updateOperatorAssignments
 *
 * The updateOperatorAssignment function manages assigning or unassigning a Operator to an Asset
 * within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateOperatorAssignments} from '@ion/core/src/services/Connect';
 *
 *     // remove operator assignments ...
 *     const removed: Operator = await updateOperatorAssignments(asset.id);
 *
 *     // add a operator assignment ...
 *     const added: Operator = await updateOperatorAssignments(asset.id, operator);
 *
 * ```
 *
 * @param    {number} assetId The id of the asset to which Operator assignments are to be added,
 *           or removed.
 * @param    {Operator} operator An optional Operator to be assigned. If present, the assignment
 *           will be made, otherwise, all Operator assignments will be removed.
 * @returns  {Promise<Operator>} The updated Operator assignment entity from the platform.
 */
export const updateOperatorAssignments = async(assetId: number, operator?: Operator): Promise<Operator> => {
  let results;
  if (operator) {
    const entity = {...operator._self, rel: 'operator'};
    results = await client.put(url(`/assets/${assetId}/operators`), JSON.stringify({operator: [entity]}));
  } else {
    results = await client.delete(url(`/assets/${assetId}/operators`));
  }
  return parse(results, 'operator') as Operator;
};

/**
 * @function createRoute
 *
 * The createRoute function creates a new Route Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createRoute} from '@ion/core/src/services/Connect';
 *
 *     const created = await createRoute(route);
 *
 * ```
 *
 * @param    {Route} route The CTC Route entity which is to be created.
 * @returns  {Promise<Route>} The newly created Route entity.
 */
export const createRoute = async(route: Route): Promise<Route> => {
  const results = await client.post(url('/routes'), JSON.stringify({route}));
  return parse(results, 'route') as Route;
};

/**
 * @function updateRoute
 *
 * The updateRoute function updates an existing Route Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateRoute} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateRoute(route);
 *
 * ```
 *
 * @param    {Route} route The CTC Route entity which is to be updated.
 * @returns  {Promise<Route>} The updated Route entity.
 */
export const updateRoute = async(route: Route): Promise<Route> => {
  const results = await client.put(url(`/routes/${route.id}`), JSON.stringify({route}));
  return parse(results, 'route') as Route;
};

/**
 * The destroyeRoute function deletes an existing Route Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {destroyRoute} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await destroyRoute(route);
 *
 * ```
 */
export const destroyRoute = async(route: Route): Promise<Route> => {
  const results = await client.delete(url(`/routes/${route.id}`));
  return parse(results, 'route') as Route;
};

/**
 * @function updateRouteAssignments
 *
 * The updateRouteAssignments function manages assigning or unassigning a Route to an Asset
 * within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateRouteAssignments} from '@ion/core/src/services/Connect';
 *
 *     // remove route assignments ...
 *     const removed: Route = await updateRouteAssignments(asset.id);
 *
 *     // add a route assignment ...
 *     const added: Route = await updateRouteAssignments(asset.id, route);
 *
 * ```
 *
 * @param    {number} assetId  The id of the asset to which route assignments are to be added,
 *           or removed.
 * @param    {Route} route An optional route to be assigned. If present, the assignment will be
 *           made, otherwise, all route assignments will be removed.
 * @returns  {Promise<Route>} The updated Route assignment entity from the platform.
 */
export const updateRouteAssignments = async(assetId: number, route?: Route): Promise<Route> => {
  let results;
  if (route) {
    const routes = {...route._self, rel: 'route'};
    results = await client.put(url(`/assets/${assetId}/routes`), JSON.stringify({routes}));
  } else {
    results = await client.delete(url(`/assets/${assetId}/routes`));
  }
  return parse(results, 'route') as Route;
};

/**
 * @function loadRoutes
 *
 * Provides a paginated search implementation against CTC Route Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadRoutes} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 routes within the given account hierarchy ...
 *    const {routes, totalCount} = await loadRoutes({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Route entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Routes
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadRoutesResult>
 */
export const loadRoutes = async({
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false
}: LoadRoutesParams): Promise<LoadRoutesResult> => {
  const uri = `/routes/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}&include=schedules,extAttribs`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadRoutesResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {account: accountId, ...filterOn}
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    routes : results?.map(({route}) => route),
    totalCount,
    _links
  };
};

/**
 * @function getRoutes
 *
 * This getRoutes function retrieves the Routes within the give Account by account
 * id.
 *
 * ```typescript
 *    import {getRoutes} from '@ion/core/src/services/Connect';
 *
 *    const routes = await getRoutes(accountId);
 *
 * ```
 *
 * @param  {number} accountId The id of the account for which the Routes are to be
 *         retrieved
 */
export const getRoutes = async(accountId: number): Promise<Route[]> => {
  const response = await client.get(url(`/accounts/${accountId}/routes`));
  return parseCollection(response, 'route') as Route[];
};

/**
 * @function getRoute
 *
 * This getRoute function retrieves an individual Routes by Route id.
 *
 * ```typescript
 *    import {getRoute} from '@ion/core/src/services/Connect';
 *
 *    const route = await getRoute(routeId);
 *
 * ```
 *
 * @param  {number} routeId The id of the Route which is to be retrieved.
 */
export const getRoute = async(routeId: number): Promise<Route> => {
  const response = await client.get(url(`/routes/${routeId}`));
  return parse(response, 'route') as Route;
};

/**
 * @function getSchedules
 *
 * Retrieves the schedules for the given account id.
 *
 * ```typescript
 *    import {getSchedules} from '@ion/core/src/services/Connect';
 *
 *    const schedules = await getSchedules(accountId);
 *
 * ```
 */
export const getSchedules = async(accountId: number): Promise<Schedule[]> => {
  const response = await client.post(url('/schedules/search'), JSON.stringify({
    search : {
      maxResults  : 999,
      searchTerms : {
        account : accountId
      }
    }
  }));
  return parseCollection(response, 'schedule');
};

/**
 * @function getIOProfiles
 *
 * The getIOProfiles method, as the name suggests, allows the user to get
 * a list of IOProfiles based on account number.
 *
 * ```typescript
 *    import {getIOProfiles} from '@ion/core/src/services/Connect';
 *
 *    const auth = await getIOProfiles(accountId);
 *
 * ```
 *
 */
export const getIOProfiles = async(id): Promise<any> => {
  const result = await client.get(url(`/accounts/${id}/ioprofiles`));
  return parseCollection(result, 'ioProfile');
};

/**
 * Retrieves Peg Labels from the Connect service.
 *
 * ```typescript
 *
 *    import {getPegLabels} from '@ion/core/src/services/Connect';
 *    const options = {
 *      accountId: 2,
 *      sortOn : '+name'
 *    };
 *    const pegLabelsResult = await getPegLabels(options);
 *
 * ```
 */
export const getPegLabels = async({
  accountId,
  sortOn,
  type,
  filterOn = {},
  pageId = 1,
  pageSize = 20,
  isLoadAll = false
}: LoadPegLabelsParams): Promise<LoadPegLabelsResult> => {
  const loadAllUri = '/peglabels/search';
  const uri = `/peglabels/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(!isLoadAll ? uri : loadAllUri, false));
  const response: LoadPegLabelsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : MAX_RESULTS,
      sort        : sortOn,
      searchTerms : {
        account : accountId,
        type,
        ...filterOn
      }
    }
  }));
  const {totalCount, _links} = response.data?.response;
  return {
    pegLabels : parseCollection(response, 'pegLabel'),
    totalCount,
    _links
  };
};

/**
 * Retrieve PEG Behaviors from the Connect service.
 *
 * ```typescript
 *
 *    import {getPegBehaviors} from '@ion/core/src/services/Connect';
 *    const options = {
 *      accountId: 2,
 *      sortOn : '+name'
 *    };
 *    const pegBehaviorsResult = await getPegBehaviors(options);
 *
 * ```
 */
export const getPegBehaviors = async({
  accountId,
  sortOn,
  filterOn = {},
  pageId = 1,
  pageSize = 20,
  excludeInheritedPegBehaviors = false
}: LoadPegBehaviorsParams): Promise<LoadPegBehaviorsResult> => {
  const exclude = excludeInheritedPegBehaviors ? '&exclude=inheritable' : '';
  const uri = `/pegbehaviors/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}${exclude}`;
  const endpoint = url(setHierLevel(uri, false));
  const response: LoadPegBehaviorsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : MAX_RESULTS,
      sort        : sortOn,
      searchTerms : {
        account : accountId,
        ...filterOn
      }
    }
  }));
  const {totalCount, _links} = response.data?.response;
  return {
    pegBehaviors : parseCollection(response, 'pegBehavior'),
    totalCount,
    _links
  };
};

/**
 * Deletes the Peg Label from Connect services.
 *
 * ```typescript
 *
 *  import {deletePegLabel} from '@ion/core/src/services/Connect';
 *
 *  const deletedPegLabel = await deletePegLabel(pegLabelToDelete);
 *
 * ```
 */
export const deletePegLabel = async(pegLabel: PegLabel): Promise<PegLabel> => {
  const results = await client.delete(url(`/peglabels/${pegLabel.id}?v=${config.ctcVersion}`));
  return parse(results, 'pegLabel') as PegLabel;
};

/**
 * Deletes the provided Peg Labels from Connect services.
 *
 * ```typescript
 *
 *  import {deletePegLabels} from '@ion/core/src/services/Connect';
 *
 *  const deletedPegLabels = await deletePegLabels([pegLabelToDelete, pegLabelToDelete2]);
 *
 * ```
 */
export const deletePegLabels = async(pegLabels: PegLabels): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: pegLabels, api: deletePegLabel});
};

/**
 * Creates a Peg Label in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createPegLabel} from '@ion/core/src/services/Connect';
 *  const createdPegLabel = await createPegLabel(pegLabelToBeCreated);
 *
 * ```
 */
export const createPegLabel = async(pegLabel: PegLabel): Promise<PegLabel> => {
  const results = await client.post(url('/peglabels'), JSON.stringify({pegLabel}));
  return parse(results, 'pegLabel') as PegLabel;
};

/**
 * Gets the given Peg Label with the provided details.
 *
 * ```typescript
 *
 *    import {getPegLabel} from '@ion/core/src/services/Connect';
 *    const getPegLabel = await getPegLabel(pegLabelId);
 *
 * ```
 */
export const getPegLabel = async(pegLabelId: number): Promise<PegLabel> => {
  const response = await client.get(url(`/peglabels/${pegLabelId}`));
  return parse(response, 'pegLabel') as PegLabel;
};

/**
 * Updates the given PEG Label with the provided details
 *
 * ```typescript
 *
 *    import {updatePegLabel} from '@ion/core/src/services/Connect';
 *    const updatedPegLabel = await updatePegLabel(pegLabelToBeUpdated);
 *
 * ```
 */
export const updatePegLabel = async(pegLabel: PegLabel): Promise<PegLabel> => {
  const results = await client.put(url(`/peglabels/${pegLabel.id}`), JSON.stringify({pegLabel}));
  return parse(results, 'pegLabel') as PegLabel;
};

/**
 * Provides a paginated search implementation against CTC Applications Services.
 *
 * ```typescript
 *
 *    import {loadApplications} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 10 applications within the given account ...
 *    const {applications, totalCount} = await loadApplications({
 *      accountId        : 321
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve AEMPConfig entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @returns Promise<LoadApplicationsResult>
 */
export const loadApplications = async({
  accountId,
  sortOn,
  pageId = 1,
  pageSize = 20,
  filterQuery = {},
  includeSubGroups = false
}: LoadApplicationsParams): Promise<LoadApplicationsResult> => {
  const uri = `/applications/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups));
  const response: LoadApplicationsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      maxResults  : 1000,
      sort        : sortOn,
      searchTerms : {
        account : accountId,
        ...filterQuery
      }
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    application : results?.map(({application}) => application),
    totalCount,
    _links
  };
};

/**
 * @function getApplication
 *
 * Retrieves the full entity representation of the given Application from CTC services.
 *
 * ```typescript
 *    import {getApplication} from '@ion/core/src/services/Connect';
 *
 *    const application = await getApplication(appKey);
 *
 * ```
 *
 * @param   {string} appKey the key of the application to be retrieved.
 * @return  {Promise<Application>} The application for the given appKey.
 */
export const getApplication = async(appKey: string): Promise<Application> => {
  const response = await client.get(url(`/applications/${appKey}`));
  return parse(response, 'application') as Application;
};

/**
 * Creates the given Application in the Connect services.
 *
 * ```typescript
 *  import {createApplication} from '@ion/core/src/services/Connect';
 *  const createdApplication = createApplication(applicationToCreate);
 * ```
 */
export const createApplication = async(application: Application): Promise<Application> => {
  const results = await client.post(url('/applications'), JSON.stringify({application}));
  return parse(results, 'application') as Application;
};

/**
 * Updates the given Application with the provided details
 *
 * ```typescript
 *
 *    import {updateApplication} from '@ion/core/src/services/Connect';
 *    const updateApplication = await updateApplication(applicationToBeUpdated);
 *
 * ```
 */
export const updateApplication = async(application: Application): Promise<Application> => {
  const results = await client.put(url(`/applications/${application?.applicationKey}`), JSON.stringify({application}));
  return parse(results, 'application') as Application;
};

/**
 * @function getApplications
 *
 * Retrieves the applications assigned to the given account, as either their full entity
 * representation of the given asset from CTC services.
 *
 * ```typescript
 *
 *    import {getApplications} from '@ion/core/src/services/Connect';
 *
 *    // retrieve all account applications as their full entity representations ...
 *    const applications = await getApplications(accountId);
 *
 *    // retrieve all account applications as their link representations ...
 *    const applications = await getApplications(accountId, false);
 *
 * ```
 *
 * @param   {number} accountId The id of the account for which applications are to be
 *          retrieved.
 * @parma   {boolean} linksOnly When true, only the application links will be returned,
 *          with rel set to application, otherwise, the application entities will be
 *          returned.
 * @return  {Promise<Applications|Links>} A collection of Applications or application
 *          Links for the given account id..
 */
export const getApplications = async(
  accountId: number, linksOnly = false
): Promise<Applications | Links> => {
  const response = await client.get(url(`/accounts/${accountId}/applications`));
  const items = parseCollection(response, 'application') as Application[];
  if (linksOnly && items?.length) {
    return items.map(({_self}) => {
      return {..._self, rel: 'application'};
    }) as Links;
  }
  return items as Applications;
};

/**
 * Deletes the Application from Connect services.
 *
 * ```typescript
 *
 *  import {deleteApplication} from '@ion/core/src/services/Connect';
 *
 *  const deletedApplication = await deleteApplication(applicationToDelete);
 *
 * ```
 */
export const deleteApplication = async(application: Application): Promise<Application> => {
  const results = await client.delete(url(`/applications/${application.applicationKey}?v=${config.ctcVersion}`));
  return parse(results, 'application') as Application;
};

/**
 * Deletes the provided Applications from Connect services.
 *
 * ```typescript
 *
 *  import {deleteApplications} from '@ion/core/src/services/Connect';
 *
 *  const deletedApplications = await deleteApplications([applicationToDelete, applicationToDelete2]);
 *
 * ```
 */
export const deleteApplications = async(applications: Applications): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: applications, api: deleteApplication});
};

/**
 * @function getUserExtendedAttributes
 *
 * The getApplicationExtendedAttributes method retrieves the extended attributes
 * for the given application, returning the extended attributes response with
 * the value property of the retrieved extended attributes parsed to an object.
 *
 * ```typescript
 *   import {getApplicationExtendedAttributes} from '@ion/core/services/Connect';
 *
 *   const attrs = getApplicationExtendedAttributes(appKey);
 *
 * @param  {string} userId The id of the User for which the extended
 *         attributes are to be retrieved.
 */
export const getApplicationExtendedAttributes = async(
  appKey: string
): Promise<any> => {
  const response = await client.get(url(`/applications/${appKey}/extendedattributes`));
  if (response) {
    const results = parseCollection(response, 'extendedAttribute');
    if (results?.length) {
      const extendedAttribute = results[0];
      extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
      return extendedAttribute;
    }
  }
};

/**
 * @function getUserExtendedAttributes
 *
 * The getUserExtendedAttributes method retrieves the extended attributes
 * for the given user id, returning the extended attributes response with
 * object.
 *
 *   const attrs = getUserExtendedAttributes(userId);
 *
 * @param  {string} userId The id of the User for which the extended
 *         attributes are to be retrieved.
 */
export const getUserExtendedAttributes = async(userId: number): Promise<any> => {
  const response = await client.get(url(`/users/${userId}/extendedattributes`));
  if (response) {
    const results = parseCollection(response, 'extendedAttribute');
    if (results?.length) {
      const extendedAttribute = results[0];
      extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
      return extendedAttribute;
    }
  }
};

/**
 * @function saveUserExtendedAttributes
 *
 * The saveUserExtendedAttributes method saves the extended attributes
 * for the given user id; returning the extended attributes response
 * with the value property of the retrieved extended attributes parsed
 * to an object.
 *
 * ```typescript
 *   import Connect from 'core/services/Connect';
 *
 *   Connect.saveUserExtendedAttributes(userId, value).then(extendedAttributes => {
 *     console.log(extendedAttributes.value);
 *     console.log(extendedAttributes.application);
 *   });
 *
 * @param  {string} userId The id of the User for which the extended
 *         attributes are to be saved.
 * @param  {object} value The value to be saved for the extendedAttribute
 *         value property. Note, this object will automatically be
 *         converted to a string via JSON.stringify.
 */
export const saveUserExtendedAttributes = async(userId: number, value: any, method = 'put'): Promise<ExtendedAttribute> => {
  const response = await client[method](url(`/users/${userId}/extendedattributes`), JSON.stringify({
    value : JSON.stringify(value)
  }));
  const results = parseCollection(response, 'extendedAttribute');
  if (results?.length) {
    const extendedAttribute = results[0];
    extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
    return extendedAttribute;
  }
};

/**
 * This getSubscriptions function retrieves the Subscriptions within the give Account by account
 * id.
 *
 * ```typescript
 *    import {getSubscriptions} from '@ion/core/src/services/Connect';
 *
 *    const subscriptions = await getSubscriptions(accountId);
 *
 * ```
 *
 * @param  {number} accountId The id of the account for which the Subscriptions are to be
 *         retrieved
 */
export const getSubscriptions = async(accountId): Promise<any> => {
  const response = await client.get(url(`/accounts/${accountId}/subscription`));
  return parseCollection(response, 'subscription');
};

/**
 * Retrieves all contacts for the given account.
 *
 * ```typescript
 *    import {getContacts} from '@ion/core/src/services/Connect';
 *
 *    const accounts = await getContacts(account.id);
 *
 * ```
 */
export const getContacts = async(accountId: number): Promise<Contact[]> => {
  const response = await client.get(url(`/accounts/${accountId}/contacts`));
  return parseCollection(response, 'contact') as Contact[];
};

/**
 * Provides a paginated search implementation against CTC Alert notification Services.
 *
 * ```typescript
 *
 *    import {loadAlertNotification} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 10 applications within the given account ...
 *    const {applications, totalCount} = await loadAlertNotification({
 *      accountId        : 321
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve AEMPConfig entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @returns Promise<LoadAlertNotificationResult>
 */
export const loadAlertNotification = async({
  sortOn,
  accountId,
  pageId = 1,
  pageSize = 20,
  api = '2.2',
  includeSubGroups = false,
  filterOn = {},
  subAccountIds
}: LoadAlertsNotificationParams): Promise<LoadAlertsNotificationResult> => {
  const hierarchy = !includeSubGroups ? `hierarchy=${false}&` : `hierarchy=${true}&`;
  const uri = `/alertsfired/search?v=${api}&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(uri, Service.Alerts);
  const response: LoadAlertsNotificationResponse = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : createAlertNotificationSearchTerms({
        includeSubAccount : includeSubGroups,
        accountId,
        filterOn,
        subAccountIds
      })
    }
  }));
  const {results, totalCount} = response.data?.response;
  return {
    items : results?.map(data => data?.alertsFired),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all Notifications for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all Notifications in a single pseudo async call. Generally
 * this function is only to be used for performing exports of Notifications.
 *
 * @param {LoadAlertsNotificationParams} params The parameters against which the Notifications
 *        are to be retrieved.
 */
export const loadAllAlertNotification = async(params: LoadAlertsNotificationParams): Promise<AlertNotification[]> => {
  const notifications = await loadAll(loadAlertNotification, params, 'items');
  return notifications;
};

/**
 * The createAccountContact function creates a new Contact for the given account.
 *
 * ```typescript
 *
 *     import {createAccountContact} from '@ion/core/src/services/Connect';
 *
 *     const created = await createAccountContact(contact);
 *
 * ```
 *
 * @param    {Contact} contact The CTC Contact entity which is to be created.
 * @returns  {Promise<Contact>} The newly created Contact entity.
 */
export const createAccountContact = async(accountId: number, contact: Contact): Promise<Contact> => {
  const results = await client.post(url(`/accounts/${accountId}/contacts`), JSON.stringify({contact}));
  return parse(results, 'contact') as Contact;
};

/**
 * Creates a Message Endpoint entity as a 1 to 1 relationship to a parent account (group).
 *
 * ```typescript
 *
 *    import {createAccountMessageEndpoint} from '@ion/core/src/services/Connect';
 *
 *    const createdMessageEndpoint = createAccountMessageEndpoint(messageEndpointToCreate);
 *
 * ```
 */
export const createAccountMessageEndpoint =
  async({id}: Account, messageEndpoint: MessageEndpoint): Promise<MessageEndpoint> => {
    const results = await client.post(
      url(`/accounts/${id}/messageendpoint?v=${config.ctcVersion}`),
      JSON.stringify({messageEndpoint})
    );
    return parse(results, 'messageEndpoint') as MessageEndpoint;
  };

/**
 * Gets a Message Endpoint entity associated to the given account (group) id.
 *
 * ```typescript
 *
 *    import {getAccountMessageEndpoint} from '@ion/core/src/services/Connect';
 *
 *    const accountMessageEndpoint = getAccountMessageEndpoint(accountId);
 *
 * ```
 */
export const getAccountMessageEndpoint = async(accountId: string): Promise<MessageEndpoint> => {
  const response = await client.get(url(`/accounts/${accountId}/messageendpoint?v=${config.ctcVersion}`));
  return parse(response, 'messageEndpoint') as MessageEndpoint;
};

/**
 * Updates a Message Endpoint entity associated to the given account (group) id to the provided Message Endpoint.
 *
 * ```typescript
 *
 *    import {updateAccountMessageEndpoint} from '@ion/core/src/services/Connect';
 *
 *    const updatedMessageEndpoint = updateAccountMessageEndpoint(accountId, messageEndpointToUpdateTo);
 *
 * ```
 */
export const updateAccountMessageEndpoint =
async({id}: Account, messageEndpoint: MessageEndpoint): Promise<MessageEndpoint> => {
  const response = await client.put(
    url(`/accounts/${id}/messageendpoint?v=${config.ctcVersion}`),
    JSON.stringify({messageEndpoint})
  );
  return parse(response, 'messageEndpoint') as MessageEndpoint;
};

/**
 * Deletes the Message Endpoint associated to the given parent account.
 *
 * ```typescript
 *
 *    import {deleteAccountMessageEndpoint} from '@ion/core/src/services/Connect';
 *
 *    const deletedMessageEndpoint = deleteAccountMessageEndpoint(account);
 *
 * ```
 */
export const deleteAccountMessageEndpoint = async({id}: Account): Promise<MessageEndpoint> => {
  const response = await client.delete(url(`/accounts/${id}/messageendpoint?v=${config.ctcVersion}`));
  return parse(response, 'messageEndpoint') as MessageEndpoint;
};

/**
 * The createContact function creates a new Contact entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createContact} from '@ion/core/src/services/Connect';
 *
 *     const created = await createContact(contact);
 *
 * ```
 *
 * @param    {Contact} contact The CTC Contact entity which is to be created.
 * @returns  {Promise<Contact>} The newly created Contact entity.
 */
export const createContact = async(contact: Contact): Promise<Contact> => {
  const results = await client.post(url('/contacts'), JSON.stringify({contact}));
  return parse(results, 'contact') as Contact;
};

/**
 * The updateContact function update an existing Contact Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateContact} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateContact(contact);
 *
 * ```
 *
 * @param   {Contact} contact The CTC Contact entity which is to be updated.
 * @returns Promise<Contact> The updated Contact entity.
 */
export const updateContact = async(contact: Contact): Promise<Contact> => {
  const results = await client.put(url(`/contacts/${contact.id}`), JSON.stringify({contact}));
  return parse(results, 'contact') as Contact;
};

/**
 * Provides a convenience API which allows for consecutively loading all pages for
 * a given service. This function effectively allows for bypassing manual pagination
 * and eagerly loading all entities in a pseudo-single async call. Generally, this
 * function is only to be used for performing exports of all entities in an account
 * hierarchy.
 *
 * ```typescript
 *
 *   // retrieve all assets for all pages within the given hierarchy ...
 *   export const loadAllAssets = async(params: LoadAssetsParams): Promise<Asset[]> => {
 *     const assets = await loadAll(loadAssets, params, 'assets');
 *     return assets;
 *   };
 *
 * ```
 *
 * @param  {Function} api The async API (generally, an API function from this module)
 *         from which to retrieve all items for all pages.
 * @param  {LoadParams} params The parameters which are to be used when invoking the
 *         api, such as the pageId, pageSize, etc.
 * @param  {string} entity The entity which is to be parsed from each resulting api
 *         invocation.
 * @param  {boolean} isParallel - If true, fetches all pages in parallel. 
 *          Otherwise sequentially.
 * @param  {boolean} isSequenceAfter - If true, fetches pages in parallel up to a defined PAGE_LIMIT 
 *          then sequentially to support searchAfter based pagination. Otherwise parallelly.
 */
export const loadAll = async(
  api: Function,
  params: LoadParams,
  entity: string,
  isParallel = false,
  isSequenceAfter = false
// eslint-disable-next-line max-params
): Promise<CTCEntity[]> => {
  const {pageId, pageSize, exportLimit} = params;
  let isMaxPages = false;
  if (isParallel) {
    try {
      const response = await api(params);
      const pageLimitCount = exportLimit || response.totalCount;
      const results: CTCEntity[] = response[entity] || response;
      const pages   = Math.ceil(pageLimitCount / pageSize);
      const pending = [];
      if (pages > pageId) {
        for (let i = pageId + 1; i <= pages; i++) {
          if (isSequenceAfter && i > PAGE_LIMIT) {
            isMaxPages = true;
            break;
          }
          pending.push(new Promise(resolve => {
            api({...params, pageId: i}, entity).then(data => {
              resolve(data[entity]);
            });
          }));
        }
      }
      const consolidatedEntity = await Promise.all(pending);
      let devices = [];
      if (isSequenceAfter && isMaxPages) {
        devices = await loadAll(api, {...params, pageId: 100, exportLimit}, 'items', false, true);
      }
      return [...results, ...consolidatedEntity.flat(), ...devices];
    } catch (err) {
      error(`Error invoking loadAll for ${entity}`, err);
      throw err;
    }
  } else {
    let results: CTCEntity[] = [];
    let response = await api(params);
    const pageLimitCount = exportLimit || response.totalCount;
    results = results.concat(response[entity] || response);
    const searchAfter = getSearchAfter(response?._links);
    if (pageLimitCount > (pageId * pageSize)) {
      const searchParams = {
        ...params,
        pageId : pageId + 1
      };
      if (isSequenceAfter) {
        searchParams.paging = `pg=${pageId+1}&pgsize=100&searchAfter=${searchAfter}`;
      }
      response = await loadAll(api, searchParams, entity, isParallel, isSequenceAfter);
      results = results.concat(response[entity] || response);
    }
    return results;
  }
};

/**
 * @function simulatedBulkOperation
 *
 * The simulatedBulkOperation function provides a utility which allows for
 * simulating a bulk operation based on individual requests for a collection
 * of entities.
 *
 * The individual responses for all invocations are managed collectively,
 * with the results being aggregated into a single response which contains
 * the combined successful responses, and erroneous responses, respectively.
 *
 * ```typescript
 *
 *    // invoke updateSchedule against a collection of schedules, and return the
 *    // consolidates results and errors ...
 *    export const updateSchedules = async(
 *      schedules: Schedule[]): Promise<BulkOperationResults> => {
 *      return simulatedBulkOperation({items: schedules, api: updateSchedule});
 *    };
 *
 *    // invoke updateOperator against a collection of schedules, and return the
 *    // consolidates results and errors ...
 *   export const updateOperators = async(
 *     operators: Operator[]): Promise<BulkOperationResults> => {
 *     return simulatedBulkOperation({
 *       items  : operators,
 *       api    : updateOperator,
 *       name   : ({firstName, lastName}: Operator): string => {
 *         return `${firstName}, ${lastName}`;
 *       }
 *     });
 *   };
 *
 * ```
 *
 * @method  simulatedBulkOperation
 * @param   {CTCEntity} items An array of CTC entities which are to be invoked
 *          within the bulk operation. Each entity will be issued as a single
 *          request against the given Connect API function, and returned within
 *          the combined response in either the results array, or the errors
 *          array (if the request failed for any reason).
 * @param   {Function} api The name of the specific Connect Services function
 *          (as defined within this module; e.g. updateAsset, etc.) against which
 *          the individual invocations of the bulk operations are to be executed.
 * @param   {Function} getOptions Function which returns the optional arguments
 *          for the api function to invoke any secondary Connect Services function
 *          post primary invocation, e.g updateOperatorSchedules within updateOperator.
 * @param   {string|Function} name The CTC entity name attribute which is to
 *          be used for error look-ups. Use this argument if the entity has
 *          a different attribute which should be used when mapping errors to
 *          entities other than the name attribute. If more than one attribute
 *          is needed to convey the entity name, a function can be provided
 *          for this argument which returns a name based on the entity passed
 *          to the function. Defaults to 'name'.
 * @returns {Promise<BulkOperationResults>} A Promise which returns the combined
 *          results and errors of all requests made for the bulk operation.
 */
export const simulatedBulkOperation = async(
  {items, api, getOptions, name, context}: BulkOperationParams): Promise<BulkOperationResults> => {
  const executions = items.map(async(item) => await api(item, getOptions?.(item), context));
  const errorIdMap = {};
  const results    = [];
  const errors     = [];
  const responses = await Promise.all(executions.map(p => p.catch(err => {
    const {url, error, entity} = err;
    let item, label;
    if (error) {
      const id = entityId(url || error?.request?.responseURL);
      item = items.find((item: CTCEntity) => item.id === id);
      if (item) {
        label = getBulkOperationName(item, name);
        errorIdMap[id] = label;
      }
    } else {
      const type = Object.keys(entity)[0];
      item  = entity[type];
      label = getBulkOperationName(item, name);
      err[type] = item;
      errorIdMap[item.id || label] = label;
    }
    return err;
  })));
  responses.forEach(response => {
    if (response && !isUndefined(response.error)) {
      const id = entityId(response.url);
      errors.push({...response, id, name: errorIdMap[id]});
    } else {
      results.push(response);
    }
  });
  return {results, errors};
};

/**
 * @function bulkSearchDevices
 *
 * The bulkSearchDevices method performs a consolidated bulk Device search
 * based on the provided searchTerms Array. This method behaves exactly the
 * same as the searcDevices method, with the only difference being that it
 * allows for searching for multiple devices against multiple accounts, and
 * returns the consolidated results.
 *
 * The following example demonstrates performing a bulk devices search based
 * on the Device ESNs for three different Groups.
 *
 * ```typescript
 *
 *   import { bulkSearchDevices } from '@ion/core/src/services/Connect';
 *
 *   const deviceSearch = [{
 *     esn: {
 *       value: firstGroup.esns.toString(),
 *       wildcard: false
 *     },
 *     account: {
 *       value: firstGroup.id // 123
 *     }
 *   }, {
 *     esn: {
 *       value: secondGroup.esns.toString(),
 *       wildcard: false
 *     },
 *     account: {
 *       value: secondGroup.id //456
 *     }
 *   }];
 *
 *   const devices = await bulkSearchDevices(deviceSearch);
 *
 * ```
 * @param  {GenericObject} searchTerms An array of search term objects which contain
 *         searchable Device attributes as keys, and the value of each key
 *         being an object which defines a value property for the searchable
 *         attribute, and an optional wildcard option, which, when true,
 *         performs a wildcard search for the given value, meaning, any
 *         matches will be returned which contain the given value. Note,
 *         the wildcard option is only applicable for string based values.
 */
export const bulkSearchDevices = async(searchTerms: GenericObject[]): Promise<CTCEntityResponseWrapper<Devices>> => {
  const requests: SearchTerm[]   = [];
  searchTerms.forEach(searchTerm => {
    requests.push(searchTerm);
  });
  const responses = await simulatedBulkOperation({items: requests, api: devicesSearch});
  const {results} = responses;

  return mapDeviceSearchResults(results);
};

/**
 * @function bulkSearchIOProfil,es
 *
 * bulkSearchIOProfiles the devices for the given search term.
 *
 * ```typescript
 *
 *    import {bulkSearchIOProfiles} from '@ion/core/src/services/Connect';
 *
 *    const params = [
 *      {
 *         "profileName": {
 *           "value": "IOP-1",
 *          "wildcard": false
 *        },
 *        "account": {
 *          "value": "15153"
 *        }
 *      },
 *      {
 *         "profileName": {
 *           "value": "profile12",
 *          "wildcard": false
 *        },
 *        "account": {
 *           "value": "39901"
 *        }
 *      }]
 *
 *    const ioprofiles = await bulkSearchIOProfiles(param);
 *
 * ```
 */
export const bulkSearchIOProfiles = async(
  searchTerms: GenericObject[]
): Promise<CTCEntityResponseWrapper<IOProfiles>> => {
  const requests: SearchTerm[] = [];
  const resultsMap = {};
  searchTerms.forEach((searchTerm) => {
    resultsMap[searchTerm.account.value] = searchTerm;
    requests.push(searchTerm);
  });

  const responses = await simulatedBulkOperation({
    items : requests,
    api   : ioProfileSearch
  });
  const {results} = responses;
  results.forEach((result, i) => {
    const key = searchTerms[i].account.value;
    resultsMap[key] = result;
  });
  return resultsMap;
};

export const bulkSearchDrivers = async(
  searchTerms: GenericObject
): Promise<CTCEntityResponseWrapper<Operators>> => {
  const drivers = await searchDrivers(searchTerms, 999);
  return drivers;
};

/**
 * @function bulkSearchSchedules
 *
 * bulkSearchSchedules the devices for the given search term.
 *
 * ```typescript
 *
 *    import {bulkSearchSchedules} from '@ion/core/src/services/Connect';
 *    const params = [
 *        {
 *          "name": {
 *            "value": "Moules Test Schedule - Weekend",
 *            "wildcard": false
 *          },
 *          "account": {
 *            "value": "15153"
 *          }
 *        },
 *        {
 *          "name": {
 *            "value": "1schedule_Monday",
 *            "wildcard": false
 *          },
 *          "account": {
 *             "value": "39901"
 *          }
 *        }]
 *
 *    const ioprofiles = await bulkSearchSchedules(param);
 *
 * ```
 */
export const bulkSearchSchedules = async(
  searchTerms: GenericObject[]
): Promise<CTCEntityResponseWrapper<Schedules>> => {
  const requests: SearchTerm[] = [];
  const resultsMap = {};
  searchTerms.forEach((searchTerm) => {
    resultsMap[searchTerm.account.value] = searchTerm;
    requests.push(searchTerm);
  });

  const responses = await simulatedBulkOperation({
    items : requests,
    api   : schedulesSearch
  });
  const {results} = responses;
  results.forEach((result, i) => {
    const key = searchTerms[i].account.value;
    resultsMap[key] = result;
  });
  return resultsMap;
};

/**
 * @function devicesSearch
 *
 * Retrieves the devices for the given search term.
 *
 * ```typescript
 *
 *    import {devicesSearch} from '@ion/core/src/services/Connect';
 *
 *    const param = {"esn":{"value":"AOTest_04","wildcard":false}};
 *    const devices = await devicesSearch(param);
 *
 * ```
 */
export const devicesSearch = async(term: SearchTerm): Promise<Devices> => {
  const url = '/devices/search';
  const response = await client.post(url, JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : constructSearchTerms(term)
    }
  }));
  return parseCollection(response, 'device');
};

/**
 * @function schedulesSearch
 *
 * schedulesSearch the devices for the given search term.
 *
 * ```typescript
 *
 *    import {schedulesSearch} from '@ion/core/src/services/Connect';
 *
 *    const param = {"esn":{"value":"AOTest_04","wildcard":false}};
 *    const devices = await schedulesSearch(param);
 *
 * ```
 */
export const schedulesSearch = async(term: SearchTerm): Promise<Schedules> => {
  const url = '/schedules/search';
  const response = await client.post(url, JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : constructSearchTerms(term)
    }
  }));
  return parseCollection(response, 'schedule');
};

/**
 * @function ioProfileSearch
 *
 * ioProfileSearch the devices for the given search term.
 *
 * ```typescript
 *
 *    import {ioProfileSearch} from '@ion/core/src/services/Connect';
 *
 *    const param = {"esn":{"value":"profile12","wildcard":false}};
 *    const devices = await ioProfileSearch(param);
 *
 * ```
 */
export const ioProfileSearch = async(term: SearchTerm): Promise<IOProfiles> => {
  const url = '/ioprofiles/search';
  const response = await client.post(url, JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : constructSearchTerms(term)
    }
  }));
  return parseCollection(response, 'ioProfile');
};

/**
 * @function bulkUpdateDevices
 *
 * The bulkUpdateDevices function updates existing devices Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {bulkUpdateDevices} from '@ion/core/src/services/Connect';
 *
 *     const updated = await bulkUpdateDevices(devices);
 *
 * ```
 *
 * @param    {Devices} devices The CTC Notifications entity which are to be updated.
 * @returns  {Promise<Notifications>} The updated Notifications entity.
 */
export const bulkUpdateDevices = async(
  devices: Devices): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: devices, api: updateDevice});
};

/**
 * Executes a bulk operation on an array of assets by dividing them into chunks,
 * calling an API function for each chunk, and merging the results into a single response object.
 */
export const assetBulkOperation = async({
  items,
  api
}: {
  items: Asset[],
  api: (items: Asset[]) => Promise<GenericObject>,
}): Promise<GenericObject[]> => {
  const chunkedItems = chunkRequests(items, get('bulkUploadDefaultSize') || items.length);
  const resultsPromises = chunkedItems.map(chunk => api(chunk));

  const results = await Promise.all(resultsPromises);
  const mergedResponse = {
    data : {
      response : {
        results : results
          .flatMap(({data}) => data.response.results)
          .filter(Boolean),
        errors : results
          .flatMap(({data}) => data.response.errors)
          .filter(Boolean)
      }
    }
  };

  return mergedResponse;
};

/**
 * @function bulkUpdateAssets
 *
 * The bulkUpdateAssets method updates a list of existing Asset Entities within
 * the CTC Platform for the given environment. This method facilitates the ability
 * to provide Bulk Asset Editing functionality.
 *
 * @param {array} assets An array of Asset entities which are to be updated.
 */
export const bulkUpdateAssets = async(
  assets: Assets): Promise<BulkOperationResults> => {
  const scheduleMap = {};
  assets?.forEach(asset => {
    scheduleMap[asset.name] = asset?.schedules?.length ? asset.schedules[0] : null;
  });
  const responses = await simulatedBulkOperation({items: assets, api: bulkSearchAndUpdateAssets});
  let results    = {errors: [], results: []};
  const partitioned = partitionBulkUpdates({
    uploaded : assets,
    searched : [].concat(...responses.results),
    entity   : Entity.asset,
    key      : 'id'
  });
  const {adds, updates} = partitioned;
  let createAssetsResponse: BulkAssetsResponse;
  let updateAssetsResponse: BulkAssetsResponse;

  const resolvedAddAssets = [];
  const resolvedUpdateAssets = [];

  adds.forEach(({asset}) => {
    resolvedAddAssets.push(asset);
  });
  updates.forEach(({asset}) => {
    resolvedUpdateAssets.push(asset);
  });

  if (adds.length) {
    createAssetsResponse = await createAssets(resolvedAddAssets, scheduleMap);
    results = aggregateResults(results, createAssetsResponse);
  }

  if (updates.length) {
    updateAssetsResponse = await updateAssets(resolvedUpdateAssets, scheduleMap);
    return aggregateResults(results, updateAssetsResponse);
  }
  return results;
};

/**
 * @function bulkSearchAndUpdateAssets
 *
 * The bulkSearchAndUpdateAssets method provides a composite method which
 * performs a CTC Search, Bulk Update, and Bulk Add (if needed) against a
 * list of Asset entities. The list of entities is iterated and segmented
 * into separate lists based on the account to which the assets reside.
 *
 * @param {array} assets An array of Asset entities which are to be updated and
 *        / or created.
 */
export const bulkSearchAndUpdateAssets = async(asset: Asset): Promise<Assets> => {
  const groupMap = {};
  const groupId = entityId(asset.account);
  groupMap[groupId] = groupMap[groupId] || [];
  groupMap[groupId].push(asset);
  const response = await bulkAssetSearch(groupMap[groupId], false);
  return response;
};

/**
 * @function bulkAssetSearch
 *
 * The bulkAssetSearch method provides a CTC Search against a list of Asset
 * entities by asset name.
 *
 * @param {array} assets An array of Asset entities which are to be located by
 *        Asset name.
 * @param {boolean} includeAccount When true, search request will include account Id.
 */
export const bulkAssetSearch = async(assets: Assets, includeAccount = true): Promise<Assets> => {
  const assetIds = assets.map(asset => asset?.id).toString();
  const searchTerms: AssetFilter = {
    ...(assetIds.length !== 0 && {
      id : assetIds
    })
  };
  if (includeAccount) {
    const account = assets?.length ? assets[0].account : {};
    searchTerms.account = entityId(account);
  }
  let response;
  if (!isEmpty(searchTerms)) {
    response = await searchAssets(searchTerms, 10000);
  } else {
    response = [];
  }
  return response;
};

/**
 * The bulkUpdateAccounts method updates a list of existing Asset Entities within
 * the CTC Platform for the given environment. This method facilitates the ability
 * to provide Bulk Asset Editing functionality.
 *
 */
export const bulkUpdateAccounts = async(
  groups: Account[], application: any): Promise<BulkOperationResults> => {
  const groupMap  = {};
  let results    = {errors: [], results: []};
  groups.forEach(account => {
    const parentGroupId = entityId(account.parent);
    groupMap[parentGroupId] = groupMap[parentGroupId] || [];
    groupMap[parentGroupId].push(account);
  });
  const requests: SearchTerm[] = [];
  Object.keys(groupMap).forEach(parentGroupId => {
    const accounts = groupMap[parentGroupId];
    if (accounts) {
      const accountIds = accounts.map(account => account?.id).filter(id => !isNil(id)).toString();
      if (accountIds.length !== 0) {
        requests.push({id: accountIds});
      }
    }
  });

  let consolidated = [];
  const searchAccountResults = await simulatedBulkOperation({
    items      : requests,
    api        : searchAccounts,
    getOptions : () => ['extAttribs']
  });
  const searchedResults = [].concat(...searchAccountResults.results);
  consolidated = mergeAccounts(searchedResults, groups);
  setAccountExtendedAttributes(consolidated.concat(groups), application);
  const partitioned = partitionBulkUpdates({
    uploaded     : groups,
    searched     : consolidated,
    entity       : Entity.account,
    key          : 'id',
    excludeAttrs : true,
    validator    : (existing, updated, attr) => {
      if (attr === 'parent' && existing?.parent?.title === updated?.parent?.title) {
        return true;
      }
      if (attr !== 'applications') {
        return propertyResolver(existing, updated, attr);
      }
      return true;
    }
  });
  const {adds, updates} = partitioned;
  const resolvedAddAssets = [];
  const resolvedUpdateAssets = [];

  adds.forEach(({account}) => {
    resolvedAddAssets.push(account);
  });
  updates.forEach(({account}) => {
    resolvedUpdateAssets.push(account);
  });
  if (adds.length) {
    const createAccountResults = await simulatedBulkOperation({
      items : resolvedAddAssets,
      api   : createAccount
    });
    results = aggregateResults(results, createAccountResults);
  }

  if (updates.length) {
    const updateAccountResults = await simulatedBulkOperation({
      items : resolvedUpdateAssets,
      api   : updateAccount
    });
    return aggregateResults(results, updateAccountResults);
  }
  return results;
};

/**
 * Retrieves the roles for the given search term.
 *
 * ```typescript
 *
 *    import {rolesSearch} from '@ion/core/src/services/Connect';
 *
 *    const param = {"role":{"value":"Admin","wildcard":false}};
 *    const roles = await rolesSearch(param);
 * ```
 *
 * @param term the search term against which the roles are retrieved
 * @returns the retrieved roles for the give search term
 */
export const rolesSearch = async(term: SearchTerm): Promise<Roles> => {
  const url = '/roles/search';
  const response = await client.post(url, JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : constructSearchTerms(term)
    }
  }));
  return parseCollection(response, 'role');
};

/**
   * The bulkSearchRoles method performs a consolidated bulk Roles search
   * based on the provided searchTerms Array. This method behaves exactly the
   * same as the searchRoles method, with the only difference being that it
   * allows for searching for multiple roles against multiple accounts, and
   * returns the consolidated results.
   *
   * ```typescript
   *
   *   import {bulkSearchRoles} from '@ion/core/src/services/Connect';
   *
   *   const terms = [{
   *     name: {
   *       value: firstGroup.role.toString(),
   *       wildcard: false
   *     },
   *     account: {
   *       value: firstGroup.id // 123
   *     }
   *   }, {
   *     name: {
   *       value: secondGroup.role.toString(),
   *       wildcard: false
   *     },
   *     account: {
   *       value: secondGroup.id //456
   *     }
   *   }, {
   *     name: {
   *       value: thirdGroup.role.toString(),
   *       wildcard: false
   *     },
   *     account: {
   *       value: thirdGroup.id //789
   *     }
   *   }];
   *
   *   bulkSearchRoles(terms)
   *     .then(results => {
   *       // object with each search term entry's account id as the key
   *       // and the roles search results as the value ...
   *       console.log(results[123]); // first search entry's results ...
   *       console.log(results[456]); // second search entry's results ...
   *       console.log(results[789]); // third search entry's results ...
   *     })
   *     .catch(error => {
   *       // error ...
   *     });
   * ```
   *
   * @param  searchTerms An array of search term objects which contain
   *         searchable Roles attributes as keys, and the value of each key
   *         being an object which defines a value property for the searchable
   *         attribute, and an optional wildcard option, which, when true,
   *         performs a wildcard search for the given value, meaning, any
   *         matches will be returned which contain the given value. Note,
   *         the wildcard option is only applicable for string based values.
   * @return the consolidated results
   */
export const bulkSearchRoles = async(
  searchTerms: GenericObject[]
): Promise<CTCEntityResponseWrapper<Roles>> => {
  const requests: SearchTerm[] = [];
  const resultsMap = {};
  searchTerms.forEach((searchTerm) => {
    resultsMap[searchTerm?.account?.value] = searchTerm;
    requests.push(searchTerm);
  });

  const responses = await simulatedBulkOperation({
    items : requests,
    api   : rolesSearch
  });
  const {results} = responses;
  results.forEach((result, i) => {
    const key = searchTerms[i]?.account?.value;
    resultsMap[key] = result;
  });
  return resultsMap;
};

/**
 * Retrieves the assets for the given search term.
 *
 * ```typescript
 *
 *    import {assetsSearch} from '@ion/core/src/services/Connect';
 *
 *    const param = {"role":{"value":"asset1","wildcard":false}};
 *    const assets = await assetsSearch(param);
 * ```
 *
 * @param   search term against which the assets are retrieved
 * @returns the retrieved assets for the give search term
 */
export const assetsSearch = async(term: SearchTerm): Promise<Assets> => {
  const url = '/assets/search';
  const response = await client.post(url, JSON.stringify({
    search : {
      maxResults  : 10000,
      searchTerms : constructSearchTerms(term)
    }
  }));
  return parseCollection(response, 'asset');
};

/**
 * The bulkSearchAssets method performs a consolidated bulk Assets search
 * based on the provided searchTerms Array. This method behaves exactly the
 * same as the searchAssets method, with the only difference being that it
 * allows for searching for multiple assets against multiple accounts, and
 * returns the consolidated results.
 *
 * ```typescript
 *
 *   import {bulkSearchAssets} from '@ion/core/src/services/Connect';
 *
 *   const terms = [{
 *     name: {
 *       value: 'asset1',
 *       wildcard: false
 *     },
 *     account: {
 *       value: '15153'
 *     }
 *   }, {
 *     name: {
 *       value: 'asset2',
 *       wildcard: false
 *     },
 *     account: {
 *       value: '39901'
 *     }
 *   }, {
 *     name: {
 *       value: 'asset3',
 *       wildcard: false
 *     },
 *     account: {
 *       value: '22892'
 *     }
 *   }];
 *
 *   const results = bulkSearchAssets(searchTerms);
 *
 * ```
 *
 * @param  searchTerms An array of search term objects which contain
 *         searchable Assets attributes as keys, and the value of each key
 *         being an object which defines a value property for the searchable
 *         attribute, and an optional wildcard option, which, when true,
 *         performs a wildcard search for the given value, meaning, any
 *         matches will be returned which contain the given value. Note,
 *         the wildcard option is only applicable for string based values.
 * @return the consolidated results
 */
export const bulkSearchAssets = async(
  searchTerms: GenericObject[]
): Promise<CTCEntityResponseWrapper<Assets>> => {
  const requests: SearchTerm[] = [];
  const resultsMap = {};
  searchTerms.forEach((searchTerm) => {
    resultsMap[searchTerm?.account?.value] = searchTerm;
    requests.push(searchTerm);
  });

  const responses = await simulatedBulkOperation({
    items : requests,
    api   : assetsSearch
  });
  const {results} = responses;
  results.forEach((result, i) => {
    const key = searchTerms[i]?.account?.value;
    resultsMap[key] = result;
  });
  return resultsMap;
};

/**
 * The bulkOperatorSearch method provides a CTC Search against a list of Operator
 * entities by firstName and lastName.
 *
 * @param operators An array of Asset entities which are to be located by
 *        Asset name.
 * @param {boolean} includeAccount When true, search request will include account Id.
 */
export const bulkOperatorSearch = async(operators: Operators, includeAccount = true): Promise<Operators> => {
  const operatorIds = operators?.map(operator => operator?.id)?.toString() || '';
  const searchTerms: OperatorFilter = {
    ...(operatorIds.length !== 0 && {
      id : operatorIds
    })
  };
  if (includeAccount) {
    const account = operators?.length ? operators[0]?.account : {};
    searchTerms.account = entityId(account);
  }
  let response;
  if (!isEmpty(searchTerms)) {
    response = await searchDrivers(searchTerms, 10000, ['schedules']);
  } else {
    response = [];
  }
  return response;
};

/**
 * The bulkSearchAndUpdateOperators method provides a composite method which
 * performs a CTC Search, Update and Add (if needed) against an Operator
 * entity.
 *
 * @param operator The Operator entity which is to be updated and
 *        / or created.
 */
export const bulkSearchAndUpdateOperators = async(operator: Operator): Promise<Operators> => {
  const groupMap = {};
  const groupId = entityId(operator.account);
  groupMap[groupId] = groupMap[groupId] || [];
  groupMap[groupId].push(operator);
  const response = await bulkOperatorSearch(groupMap[groupId], false);
  return response;
};

/**
 * The bulkUpdateOperators method updates a list of existing Operator Entities within
 * the CTC Platform for the given environment. This method faciliates the ability
 * to provide Bulk Operator Editing functionality.
 *
 * ```typescript
 *
 * import {bulkUpdateOperators} from '@ion/core/src/services/Connect'
 * const updatedOperators = bulkUpdateOperators(operators);
 *
 * ```
 *
 * @param operators Operator entities which are to be updated.
 * @returns the Operator entities which are updated successfully and failed if any.
 */
export const bulkUpdateOperators = async(
  operators: Operators): Promise<BulkOperationResults> => {
  const responses = await simulatedBulkOperation({items: operators, api: bulkSearchAndUpdateOperators});
  let results    = {errors: [], results: []};
  const partitioned = partitionBulkUpdates({
    uploaded : operators,
    searched : [].concat(...responses.results),
    entity   : Entity.operator,
    key      : ['id']
  });
  const {adds, updates} = partitioned;
  let createDriversResponse: BulkOperationResults;
  let updateDriversResponse: BulkOperationResults;

  const resolvedAddDrivers = [];
  const resolvedUpdateDrivers= [];

  adds?.forEach(({operator}) => {
    resolvedAddDrivers.push(operator);
  });

  updates.forEach(({operator}) => {
    resolvedUpdateDrivers.push(operator);
  });

  if (adds.length) {
    createDriversResponse = await createOperators(resolvedAddDrivers);
    results = aggregateResults(results, createDriversResponse);
  }

  if (updates.length) {
    updateDriversResponse = await updateOperators(resolvedUpdateDrivers);
    return aggregateResults(results, updateDriversResponse);
  }
  return results;
};

/**
 * Provides a paginated search implementation against CTC Grups Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {LoadGroups} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 10 loadGroups within the given account ...
 *    const {loadGroups, totalCount} = await LoadGroups({
 *      accountId        : 321,
 *      includeSubGroups : true,
 *      pageId           : 1,
 *      pageSize         : 10
 *    });
 *
 * ```
 *
 * @param   {number} accountId The id of the account from which to retrieve Grups entities.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {string} sortOn The field on which the results are to be sorted.
 * @param   {string} filterOn An object containing additional searchable properties from
 *          which the searchTerms request is to be based.
 * @param   {includeSubGroups} includeSubGroups When true, indicates that all Groups
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadGroupResult>
 */
export const loadGroups = async({
  accountId,
  name,
  pageId = 1,
  pageSize = 20,
  sortOn,
  filterOn = {},
  includeSubGroups = false,
  includeGlobalSearch = false,
  excludeInheritedGroups = false,
  maxResults = 100
}: LoadGroupsParams): Promise<LoadGroupResult> => {
  const excludeGroups = excludeInheritedGroups ? '&exclude=inheritable' : '';
  const uri           = `/groups/search?v=${config.ctcVersion}&pg=${pageId}&pgsize=${pageSize}${excludeGroups}`;
  const groupUrl      = url(setHierLevel(uri, includeSubGroups));
  let search;
  if (isNil(name)) {
    if (!includeGlobalSearch) {
      search = {account: accountId, ...filterOn};
    } else {
      search = {...filterOn};
    }
  } else {
    search = {account: accountId, name: `*${name}*`, ...filterOn};
  }
  const response: LoadGroupResponse = await client.post(groupUrl, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : search,
      maxResults
    }
  }));
  const {results, totalCount, _links} = response.data?.response;
  return {
    groups : results?.map(({group}) => group),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all groups for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all groups in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a groups.
 *
 * @param {LoadGroupsParams} params The parameters against which the groups are
 *        to be retrieved.
 */
export const loadAllGroups = async(params: LoadGroupsParams): Promise<Group[]> => {
  const groups = await loadAll(loadGroups, params, 'groups');
  return groups;
};

/**
 * The createGroup function creates a new Group Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createGroup} from '@ion/core/src/services/Connect';
 *
 *     const created = await createGroup(group);
 *
 * ```
 */
export const createGroup = async(group: Group, apiVersion = 2.1): Promise<Group> => {
  const results = await client.post(url(`/groups?v=${apiVersion}`), JSON.stringify({group}));
  return parse(results, 'group') as Group;
};

/**
 * The createGroupMembers function creates a new Group Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createGroupMember} from '@ion/core/src/services/Connect';
 *
 *     const created = await createGroupMembers(group);
 */
export const createGroupMembers = async(
  groupId: number,
  groupMembers: GroupMembers,
  apiVersion = 2.1
): Promise<GroupMembers> => {
  const results = await client.post(url(`/groups/${groupId}/members?v=${apiVersion}`), JSON.stringify({groupMembers}));
  const errors = results?.data?.response?.errors;
  if (errors?.length) {
    throw new Error(errors);
  }
  return parse(results, 'group') as GroupMembers;
};

/**
 * The updateGroup function updates an existing Group Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateGroup} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateGroup(group);
 *
 * ```
 */
export const updateGroup = async(
  group: Group,
  apiVersion = 2.1
): Promise<Group> => {
  const results = await client.put(url(`/groups/${group.id}?v=${apiVersion}`), JSON.stringify({group}));
  return parse(results, 'group') as Group;
};

/**
 * The updateGroupMembers function updates selected Group Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateGroupMembers} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateGroupMembers(group);
 */
export const updateGroupMembers = async(
  groupId: number,
  groupMembers: GroupMembers,
  apiVersion = 2.1
): Promise<GroupMembers> => {
  const results = await client.put(url(`/groups/${groupId}/members?v=${apiVersion}`), JSON.stringify({groupMembers}));
  return parse(results, 'group') as GroupMembers;
};

/**
 * The deleteGroupMembers function deletes selected Group Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteGroupMembers} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteGroupMembers(group);
 */
export const deleteGroupMembers = async(
  groupId: number,
  groupMembers: GroupMembers,
  apiVersion = 2.1
): Promise<BulkGroupsResponse> => {
  const response = await client.delete(url(`/groups/${groupId}/members?v=${apiVersion}`), {
    data : JSON.stringify({groupMembers})
  });
  return parseAssetsBulkCollection(response?.data?.response, 'group') as BulkGroupsResponse;
};

/**
 * The deleteAllGroupMembers function deletes selected memebers from all Groups within the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAllGroupMembers} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAllGroupMembers(group);
 *
 * ```
 */
export const deleteAllGroupMembers = async(
  groupMembers: GroupMembers,
  apiVersion = 2.1
): Promise<GroupMembers> => {
  const results = await client.delete(url(`/groups/members?v=${apiVersion}`), {
    data : JSON.stringify({groupMembers})
  });
  return parse(results, 'group') as GroupMembers;
};

/** The getGroup function retrieves an existing Group Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getGroup} from '@ion/core/src/services/Connect';
 *
 *     const group = await getGroup(id);
 *
 * ```
 */
export const getGroup = async(id: number, apiVersion = 2.1): Promise<Group> => {
  const results = await client.get(url(`/groups/${id}?v=${apiVersion}`));
  return parse(results, 'group') as Group;
};

/**
 * The deleteGroup function deletes an existing Group Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteAdminGroup} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteAdminGroup(group);
 *
 * ```
 */
export const deleteAdminGroup = async(group: Group, apiVersion = 2.1): Promise<Group | null> => {
  const results = await client.delete(url(`/groups/${group.id}?v=${apiVersion}`));
  return parse(results, 'group') as Group;
};

/**
 * Deletes the provided Groups from Connect services.
 *
 * ```typescript
 *
 *  import {deleteAdminGroups} from '@ion/core/src/services/Connect';
 *
 *  const deleteAdminGroups = await deletePegLabels([groupToDelete1, groupToDelete2]);
 *
 * ```
 */
export const deleteAdminGroups = async(groups: Group[]): Promise<BulkOperationResults> => {
  return simulatedBulkOperation({items: groups, api: deleteAdminGroup});
};

/**
 * The getGroupMembers function returns the Group member details from the CTC Platform.
 *
 * ```typescript
 *
 *     import {getGroupMembers} from '@ion/core/src/services/Connect';
 *
 *     const memebrs = await getGroupMembers(group);
 *
 * ```
 */
export const getGroupMembers = async({
  id,
  pageId = 1,
  pageSize = 100,
  filterOn = {},
  apiVersion = 2.1
}: LoadGroupsParams): Promise<LoadGroupResult> => {
  const memberUrl = `/groups/${id}/members?v=${apiVersion}&pg=${pageId}&pgsize=${pageSize}`;
  const response = await client.get(url(memberUrl));
  const {totalCount} = response?.data?.response;
  return {
    groups : parseCollection(response, 'groupMember'),
    totalCount
  } as LoadGroupResult;
};

/**
 * Provides a convenience API which allows for retrieving all groups for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all items in a single pseudo async call.
 *
 * @param {LoadGroupsParams} params The parameters against which the groups are to be
 *        retrieved.
 */
export const loadAllGroupMembers = async(params: LoadGroupsParams): Promise<Group[]> => {
  const items = await loadAll(getGroupMembers, params, 'groups');
  return items;
};

/**
 * The createJob function creates a new Job Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createJob} from '@ion/core/src/services/Connect';
 *
 *     const created = await createJob(job);
 *
 * ```
 *
 */
export const createJob = async({job}: CreateJob): Promise<CreateJob> => {
  const results = await client.post(url('/jobs', Service.PulsBaseUrl), JSON.stringify({job}));
  return parse(results, 'job') as CreateJob;
};

/**
 * Retrieves an array of the Tasks for a given account
 *
 * ```typescript
 *
 *    import {loadTasks} from '@ion/core/src/services/Connect';
 *
 *    const tasks = await loadTasks(accountId);
 *
 * ```
 */
export const loadTasks = async(accountId: number, pageCursor = '', sortOn: string): Promise<any> => {
  let uri = `/accounts/${accountId}/tasks?expand=info`;
  if (pageCursor) {
    uri += `&cursor=${pageCursor}`;
  } if (!isNil(sortOn)) {
    uri += `&sort=${sortOn}`;
  }
  const response = await client.get(url(uri, Service.ApiBaseUrl));
  const result   = response.data?.response;
  return {
    tasks  : parseCollection(response, 'task') as JobStatus,
    errors : result?.errors,
    cursor : result?.cursor,
    sortOn
  };
};

/**
 *
 * Provides a paginated search implementation against CTC Job Staus Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadJobStaus} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 tasks within the given account ...
 *    const {notifications, totalCount} = await loadJobStaus({
 *      accountId        : 321,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 */
export const loadJobStatus = async({
  accountId,
  pageId = 1,
  pageSize = 20
}: LoadjobStatusParams): Promise<LoadjobStatusResult> => {
  const endpoint = url(`/accounts/${accountId}/tasks?expand=info&pg=${pageId}&pgsize=${pageSize}`, Service.ApiBaseUrl);
  const response: LoadjobStatusResponse = await client.get(endpoint);
  const {results, count} = response.data?.response;
  return {
    items : results?.map(({task}) => task),
    count
  } as LoadjobStatusResult;
};

/**
 * Provides a paginated search implementation against CTC Job Status Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadJobStatus} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 tasks within the given account ...
 *    const {items} = await loadJobStatus({
 *      id: 98893c4a-51eb-4941-8061-1563e3258015
 *    }, false);
 *
 * ```
 */
export const loadTaskStatus = async({id}, cursor): Promise<LoadjobStatusResult> => {
  const endpoint = createLoadTaskStatusURL(id, cursor);
  const response: LoadjobStatusResponse = await client.get(endpoint);
  return parseCollection(response, 'task');
};

/**
 *
 * Provides a search implementation against CTC Bulk Entitites Services.
 *
 * ```typescript
 *
 *    import {loadBulkEntities} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 tasks within the given account ...
 *    const {items} = await loadBulkEntities({
 *      id: 98893c4a-51eb-4941-8061-1563e3258015
 *    }, false);
 *
 * @param id To fetch jobs based on the current selected account.
 * @param includeBulkEntities The page which is to be loaded.
 *
 * ```
 */
export const loadBulkEntities = async({id}, cursor, includeBulkEntities): Promise<LoadBulkEntitiesResult> => {
  const endpoint = createLoadBulkEntitiesURL(id, cursor, includeBulkEntities);
  const response: LoadjobStatusResponse = await client.get(endpoint);
  return parseCollection(response, 'task');
};

/**
 * Loads Subtasks from the API gateway for a given "main" Task.
 *
 * @param mainTaskId the main parent task's alpha-numeric string id
 * @param cursor if provided, provides the encrypted id of the last retrieved subtask for seamless pagination
 * @param isBulkOperation if the subtasks should retrieve bulk operation details (entities & action details)
 * @param isBulkExport if the subtasks should not fetch the entity details
 * @returns requested subtasks (limit of 10 subtasks due to 1mb network packet size limit) & next cursor
 */
export const loadSubtasks = async(
  mainTaskId,
  cursor,
  isBulkOperation
): Promise<SubtaskResult> => {
  try {
    const endpoint = createLoadSubtasksURL(mainTaskId, cursor, isBulkOperation);
    const response: SubtaskResult = await client.get(endpoint);
    return {
      subtasks : parseCollection(response, 'task'),
      cursor   : response?.data?.response?.cursor,
      errors   : response?.data?.response?.errors
    };
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 *
 * Provides a paginated search implementation against CTC Devices files Services which supports
 * optional sorting and hierarchical support.
 *
 * @param   {number} accountId To fetch jobs based on the current selected account.
 * @param   {number} pageId The page which is to be loaded.
 * @param   {number} pageSize The size of the page to be loaded.
 * @param   {Array<string>} sortOn The field on which the results are to be sorted.
 *          which the searchTerms request is to be based.
 *          within the account hierarchy are to be returned.
 * @returns Promise<LoadDownloadJobsResult>
 */
export const loadDownloadJobs = async({
  accountId,
  name,
  pageId = 1,
  pageSize = 20,
  sortOn: sort,
  filterOn = {},
  includeSubGroups = false
}: LoadDownloadJobsParams): Promise<LoadDownloadJobsResult> => {
  const uri = `/jobs/search/?v=2.1&pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.PulsBaseUrl);
  const response = await client.post(endpoint, safeJSONStringify({
    search : {
      searchTerms : {account: accountId, ...filterOn},
      sort,
      name
    }
  }));
  const {results, totalCount} = response?.data?.response;
  return {
    items : results.map(({job}) => job),
    totalCount
  } as LoadDownloadJobsResult;
};

/**
 * Provides a convenience API which allows for retrieving all Jobs for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all Jobs in a single pseudo async call. Generally
 * this function is only to be used for performing exports of Jobs.
 *
 * @param {LoadDownloadJobsParams} params The parameters against which the Jobs
 *        are to be retrieved.
 */
export const loadAllDownloadJobs = async(params: LoadDownloadJobsParams): Promise<DownloadJob[]> => {
  const jobs = await loadAll(loadDownloadJobs, params, 'items');
  return jobs;
};

/**
 * Provides a convenience API which allows for retrieving all Devices with status for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devices in a single pseudo async call. Generally
 * this function is only to be used for performing exports of Devices with status.
 *
 * @param {LoadDevicesStatusParams} params The parameters against which the Devices
 *        are to be retrieved.
 */
export const loadAllDevicesStatus = async(params: LoadDevicesStatusParams): Promise<CTCEntity[]> => {
  const devices = await loadAll(loadDevicesStatus, params, 'items');
  return devices;
};

export const loadDevicesStatus = async({
  accountId,
  index,
  pageId,
  pageSize
}: LoadDevicesStatusParams): Promise<LoadDevicesStatusResult> => {
  const endpoint = url(`/jobs/${accountId}/tasks/${index}/devices?pg=${pageId}&pgsize=${pageSize}`, Service.PulsBaseUrl);
  const response = await client.get(endpoint);
  const {results, totalCount, errors} = response?.data?.response;
  return {
    items : !isEmpty(errors) ? results?.concat(errors) : results,
    totalCount
  } as LoadDevicesStatusResult;
};

export const loadDownloadDevicesJobs = async({id}): Promise<LoadDownloadJobsResult> => {
  const endpoint = url(`/jobs/${id}`, Service.PulsBaseUrl);
  const response: LoadDownloadJobsResponse = await client.get(endpoint);
  const {results, totalCount} = response.data?.response;
  return {
    items : results.map(({job}) => job),
    totalCount
  } as LoadDownloadJobsResult;
};

export const getJob = async(id: number): Promise<unknown[]> => {
  const results = await client.get(url(`/jobs/${id}`, Service.PulsBaseUrl));
  return parse(results, 'job') as any[];
};

export const removeDownloadJob = async(job: DownloadJob): Promise<DownloadJob | null> => {
  const results = await client.put(url(`/jobs/${job.id}`, Service.PulsBaseUrl),
    JSON.stringify({job})
  );
  return parse(results, 'job') as DownloadJob;
};

export const removeTask = async(id: number, index: number, requestBody: string) => {
  const results = await client.put(url(`/jobs/${id}/tasks/${index}/progressStatus`, Service.PulsBaseUrl),
    requestBody,
    getNoCacheHeaders(false)
  );
  return results;
};

export const removeDevice = async(job) => {
  const results = await client.put(url(`/jobs/${job.id}`, Service.PulsBaseUrl), JSON.stringify({job}), getNoCacheHeaders(true));
  return results;
};

/**
 * The deletePegBehavior function deletes an existing PegBehavior Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deletePegBehavior} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deletePegBehavior(pegBehavior);
 *
 * ```
 *
 * @param   {PegBehavior} pegBehavior The CTC PegBehavior entity which is to be deleted.
 * @returns Promise<PegBehavior> The deleted PegBehavior entity or null if not found.
 */
export const destroyPegBehavior = async({id}: PegBehavior): Promise<PegBehavior | null> => {
  const results = await client.delete(url(`/pegbehaviors/${id}`));
  return parse(results, 'pegBehavior') as PegBehavior;
};

/**
 * @function sciUpdate
 *
 * The sciUpdate function updates the existing sci setting of device.
 *
 * ```typescript
 *
 *     import {sciUpdate} from '@ion/core/src/services/Connect';
 *
 *     const updateSCI = await sciUpdate(changedSettingsFields);
 *
 * ```
 *
 * @param    changedSettingsFields Updated SCI fields.
 * @returns  {Promise<any>} The Updated SCI entity.
 */
export const sciUpdate = async(changedSettingsFields: GenericObject): Promise<any> => {
  const results = await client.post(url('/devicecommands/device/devicecommands?v=2.0'), changedSettingsFields);
  return {results};
};

/**
 * @function userPermission
 *
 * Retrieves all the permissions of the user from Connect (i.e. the logged in user).
 *
 * ```typescript
 *
 *    import {userPermission} from '@ion/core/src/services/Connect';
 *
 *    const devicePermission = await userPermission();
 *
 * ```
 */
export const userPermission = async(): Promise<Permissions> => {
  const response = await client.get(url('/users/current/permissions/'));
  return parseCollection(response, '');
};

/**
 * Provides a paginated search implementation against CTC Crashboxx Services which supports
 * optional sorting and hierarchical support.
 *
 * ```typescript
 *
 *  import {getCrashEvents} from '@ion/core/src/services/Connect';
 *
 *  const {crashEvents} = await getCrashEvents({accountId: 5099});
 *
 * ```
 */
export const getCrashEvents = async({
  accountId,
  searchTerms = {},
  pageId = 1,
  pageSize = 20,
  sort = '-crashDate',
  includeSubGroups = true,
  accountIdType = 'AccountType'
}: LoadCrashBoxxEventsParams): Promise<any> => {
  let uri = `/icn/search?pg=${pageId}&pgsize=${pageSize}&sort=${sort}`;
  if (includeSubGroups) {
    uri += '&hierarchy=true';
  }
  const response = await client.post(
    url(uri, Service.Crashboxx),
    JSON.stringify({
      search : {
        searchTerms : {
          accountId,
          accountIdType,
          ...searchTerms
        }
      }
    })
  );
  const {results, totalCount, _links} = response.data?.response || {};
  return {
    crashEvents : results?.map(result => result.icn),
    totalCount,
    _links
  };
};

/**
 * Provides a search implementation against Driving Analytics trip services.
 * 
 * ```typescript
 *
 *  import {getTrips} from '@ion/core/src/services/Connect';
 *
 *  const {getTrips} = await getTrips({accountId: 5099});
 *
 * ```
 */
export const getTrips = async({
  searchTerms = {},
  maxResults = 100,
  pageId = 1,
  sort
}: LoadTripsParams): Promise<any> => {
  const response = await client({
    url    : url(`/driving-analytics/services/trips/search?pg=${pageId}&pgSize=${maxResults}`, Service.Base),
    method : 'POST',
    data   : JSON.stringify({
      search : removeUndefined({
        maxResults,
        searchTerms,
        sort
      })
    })
  });
  const {
    results,
    totalCount,
    searchableProperties
  } = response.data?.response || {};

  return {
    trips : results?.map(result => result?.trips).filter(Boolean) || [],
    totalCount,
    searchableProperties
  };
};

/**
 * Updates the business/private tag for a Driving Analytics trip.
 */
export const tagTrips = async({
  business,
  tripType,
  tripUuid
}: TagTripsParams): Promise<void> => {
  await client({
    url    : url('/driving-analytics/services/trips/tagtrips', Service.Base),
    method : 'PUT',
    data   : JSON.stringify([{
      business,
      tripType,
      tripUuid
    }])
  });
};

/**
 * Creates a Bulk Entities(Assets/Devices) in API Services with the provided details.
 *
 * ```typescript
 *
 *    import {createBulkEntities} from '@ion/core/src/services/Connect';
 *
 *    const response = await createBulkEntities(requestType, device);
 *
 * ```
 *
 */
export const createBulkEntities = async(
  accountId: number, entity: string, data: GenericObject[]): Promise<any> => {
  const endpoint = url('/entities/bulk', Service.ApiBaseUrl);
  const response = await client.post(endpoint, JSON.stringify({
    accountId,
    requestType    : entity,
    [`${entity}s`] : data
  }));
  const result = response?.data?.response;
  return result;
};

/**
 * Creates a Bulk Manufactured Devices in API Services with the provided details.
 *
 * ```typescript
 *
 *    import {uploadManufacturingDevices} from '@ion/core/src/services/Connect';
 *
 *    const response = await uploadManufacturingDevices({operation, api});
 *
 * ```
 *
 */
export const uploadManufacturingDevices = async({
  operation,
  version = 2,
  api = client
}: ManufacturedDeviceOperationRequest): Promise<OperationTask> => {
  const URL = url('/entities/bulk-operations/manufactureddevice', Service.ApiBaseUrl);
  const results = await api.post(URL, {...operation});
  return parse(results, 'task') as OperationTask;
};

/**
 * Provides s3UploadUrl and s3DownloadKey based on the provided details.
 *
 * ```typescript
 *
 *    import {getS3UploadUrl} from '@ion/core/src/services/Connect';
 *
 *    const response = await getS3UploadUrl({accountId, entityType, actionType, userId});
 *
 * ```
 *
 */
export const getS3UploadUrl = async({
  accountId,
  entityType,
  actionType,
  userId
}: UploadUrlParams): Promise<any> => {
  const response = await client.post(url('/entities/upload/url', Service.ApiBaseUrl), JSON.stringify({
    accountId,
    entityType,
    actionType,
    userId
  }));
  const {results} = response?.data?.response;
  return results?.[0];
};

/**
 * The uploadExcelToS3Bucket utility sends PUT request to upload excel.
 *
 * ```typescript
 *
 * import {uploadExcelToS3Bucket} from '@ion/core/src/services/ConnectUtils';
 *
 * const response = uploadExcelToS3Bucket(url, data);
 *
 * ```
 */
export const uploadExcelToS3Bucket = async(s3UploadUrl, file) => {
  const response =   await client({
    method          : 'PUT',
    withCredentials : false,
    url             : s3UploadUrl,
    data            : file,
    headers         : {
      'Content-Type' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });

  return response?.status;
};

export const loadHeartBeatInfo = async(devicecheckinsearch, includeSubGroups) => {
  const hierLevel = includeSubGroups ? '?hierarchy=true' : '';
  const uri       = url(`/devices/search${hierLevel}`, Service.Crashboxx);
  const response  = await client.post(uri, JSON.stringify({
    devicecheckinsearch
  }));
  const result = response?.data?.response;
  return result;
};

/**
 * Clone PEG Behavior
 *
 * ```typescript
 *
 *    import {clonePEGBehavior} from '@ion/core/src/services/Connect';
 *
 *    const response = await clonePEGBehavior(pegBehaviorId, data);
 *
 * ```
 *
 */
export const clonePEGBehavior = async(
  pegBehaviorId: number, clone: ClonedPegBehavior): Promise<ClonedPegBehavior> => {
  const results = await client.post(url(`/pegbehaviors/${pegBehaviorId}/clone`), safeJSONStringify({clone}));
  return parse(results, 'pegBehavior') as ClonedPegBehavior;
};

/**
 * Get Vehicle Profile Data from the API tier gateway url.
 *
 * ```typescript
 *
 *     import {getVinData} from '@ion/core/src/services/Connect';
 *
 *     const response = await getVinData(vinValue);
 *
 * ```
 *
 * @param    {number} vinValue The vinValue of the CTC Device entity which is to be retrieved.
 */
export const getVinData = async(vinValue) => {
  const response = await client({
    url     : url(`/vins/test?${vinValue}`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Load Hardware Parts details from the API tier gateway url.
 *
 * ```typescript
 *
 *     import {getHardwarePart} from '@ion/core/src/services/Connect';
 *
 *     const response = await getHardwarePart(partnumbers);
 *
 * ```
 *
 * @param    {number} esn The esn of the CTC Device entity which is to be retrieved.
 * @returns  {Promise<any>} The retrieved Device  Manufacturing entity.
 */
export const getHardwarePart = async(): Promise<HardwarePart> => {
  const uri      = `/partnumbers?_=${new Date().getTime()}`;
  const response = await client.get(url(uri, Service.CommonServiceUrl));
  return {hardwareParts: response.data} as HardwarePart;
};

/**
 * Get Hardware Parts by id from the API tier gateway url.
 *
 * ```typescript
 *
 *     import {getHardwarePartById} from '@ion/core/src/services/Connect';
 *
 *     const response = await getHardwarePartById(hardwarepartID);
 *
 * ```
 *
 * @param    {number} id The id of the Hardware Part which is to be retrieved.
 * @returns  {Promise<HardwarePart>} The retrieved hardware part details.
 */
export const getHardwarePartById = async(hardwarePartID: number): Promise<HardwarePart> => {
  const uri      = `/partnumbers/${hardwarePartID}`;
  const response = await client.get(url(uri, Service.CommonServiceUrl));
  return response?.data as HardwarePart;
};

/*
 * The destroyHardwarePart function deletes existing Hardware Parts
 * from the Connect services.
 *
 * ```typescript
 *
 * import {destroyHardwarePart} from '@ion/core/src/services/Connect';
 *
 * const deleted = await destroyHardwarePart(hardwarePart);
 *
 * ```
 *
 * @param   The CTC HardwarePart entity which are to be deleted.
 * @returns Promise<Users> The deleted HardwarePart  entity or null if not found.
 */
export const destroyHardwarePart = async({id}): Promise<HardwarePart> => {
  const results = await client.delete(url(`/partnumbers/${id}`, Service.CommonServiceUrl));
  return results?.data as HardwarePart;
};

/**
 * Retrieves the part number dropdown values by the type
 *
 * ```typescript
 *
 *    import {getHardwarePartDropDowns} from '@ion/core/src/services/Connect';
 *    const response = await getHardwarePartDropDowns();
 *
 * ```
 *
 * @param noCache When true, the request will append a cache busting (date string)
 *        to the query string. Defaults to `false`.
 */
export const getHardwarePartDropDowns = async(type = HardwarePartType.Applications): Promise<any> => {
  try {
    const uri = `/partnumbers/${type}?_=${new Date().getTime()}`;
    const response = await client.get(url(uri, Service.CommonServiceUrl));
    return response?.data;
  } catch (err) {
    return err;
  }
};

/**
 * Load Hardware Part Device Source details for PULS type.
 *
 * ```typescript
 *
 *     import {getDeviceSources} from '@ion/core/src/services/Connect';
 *
 *     const response = await getDeviceSources();
 *
 * ```
 *
 */
export const getDeviceSources = async(): Promise<any> => {
  const response = await client.get(url('/devicesources', Service.CommonServiceUrl));
  return response?.data?.response?.results;
};

/**
 * Load Hardware Part Carriers details for Provisioning
 *
 * ```typescript
 *
 *     import {getCarriers} from '@ion/core/src/services/Connect';
 *
 *     const response = await getCarriers();
 *
 * ```
 *
 */
export const getCarriers = async(): Promise<any> => {
  const response = await client.get(url('', Service.CarrierServiceUrl));
  return response?.data?.response?.results?.carrierResponses?.carriers;
};

/**
 * Loads all needed manufacturing enums ("auxiliary values").
 */
export const getManufacturingAuxValues = async(): Promise<any> => {
  const response = await client.post(createManufacturingURL('auxiliaryvalue/types'),
    JSON.stringify({types: Object.values(MANUFACTURING_AUX_VALUES)})
  );
  return response?.data?.response?.results;
};

/**
 * Creates a Hardware Part in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createHardwarePart} from '@ion/core/src/services/Connect';
 *  const createHardwarePart = await createHardwarePart(hardwarePartToBeCreated);
 *
 * ```
 */
export const createHardwarePart = async(hardwarePart: HardwarePart): Promise<HardwarePart> => {
  const results = await client.post(url('/partnumbers', Service.CommonServiceUrl), JSON.stringify(hardwarePart));
  return parse(results) as HardwarePart;
};

/**
 * Updates a Hardware Part in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {updateHardwarePart} from '@ion/core/src/services/Connect';
 *  const updateHardwarePart = await updateHardwarePart(hardwarePartToBeUpdated);
 *
 * ```
 */
export const updateHardwarePart = async(hardwarePart: HardwarePart): Promise<HardwarePart> => {
  const results = await client.put(url(`/partnumbers/${hardwarePart.id}`, Service.CommonServiceUrl), JSON.stringify(hardwarePart));
  return parse(results) as HardwarePart;
};

/**
 * Retrieves the full entity representation of the given subscription from CTC services.
 *
 * ```typescript
 *    import {getSubscription} from '@ion/core/src/services/Connect';
 *
 *    const asset = await getSubscription(id);
 *
 * ```
 *
 * @param {number} The id of the subscription to which is to be retrieved.
 */
export const getSubscription = async(id: number, api: AxiosInstance = client): Promise<Subscription> => {
  const response = await api.get(url(`/subscriptions/${id}`));
  return parse(response, 'subscription') as Subscription;
};

/**
 * Retrieves SCI devicses based on the provided search type (Type Name and accountID).
 *
 * ```typescript
 * import {loadSCIDevicesBySerialNumber} from '@ion/core/src/services/Connect';
 *
 * const sciDevices = await loadSCIDevicesBySerialNumber(searialNumbers, deviceTypes , accountId);
 *
 * ```
 */
export const loadSCIDevicesBySerialNumber = async(serialNumbers: string[], deviceTypes, accountId: number) => {
  const uri      = `/devices/smartsearch?v=${config.ctcVersion}&pgsize=100`;
  const endpoint = url(setHierLevel(uri, !!deviceTypes?.hierLevel), Service.PULS);
  const idType   = deviceTypes?.idType;
  const response = await client.post(endpoint, {
    search : {
      type      : deviceTypes?.entity,
      accountId : accountId,
      query     : {
        query : {
          terms : {
            [idType] : serialNumbers
          }
        }
      }
    }
  });
  return parseCollection(response, '');
};

/**
 * @function bulkSCIUpdate
 *
 * The bulkSCIUpdate function updates the existing sci setting of devices in bulk.
 *
 * ```typescript
 *
 *     import {bulkSCIUpdate} from '@ion/core/src/services/Connect';
 *
 *     const updateBulkSCI = await bulkSCIUpdate(commandPayload);
 *
 * ```
 *
 * @param    commandPayload Updated SCI fields.
 * @returns  {Promise<any>} The Updated SCI entity.
 */
export const updateBulkSCI = async(commandPayload: GenericObject): Promise<any> => {
  const results = await client.post(url('/devices/bulk/devicecommands?expand=info', Service.ApiBaseUrl), commandPayload);
  return {results};
};

/**
 * The updateAWSFile utility sends post request.
 *
 * ```typescript
 *
 * import {updateAWSFile} from '@ion/core/src/services/ConnectUtils';
 *
 * const header = updateAWSFile(url, data);
 *
 * ```
 */
export const updateAWSFile = async(url: string, data: GenericObject) => {
  await client({
    method          : 'POST',
    withCredentials : false,
    url,
    data
  });
};

/**
 * Creates a Peg Behavior in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createPegBehavior} from '@ion/core/src/services/Connect';
 *  const createdPegBehavior = await createPegBehavior(pegBehaviorToBeCreated);
 *
 * ```
 */
export const createPegBehavior = async(pegBehavior: PegBehavior): Promise<PegBehavior> => {
  const results = await client.post(url('/pegbehaviors'), safeJSONStringify({pegBehavior}));
  return parse(results, 'pegBehavior') as PegBehavior;
};

/**
 * Update the given PEG Behavior with the provided details
 *
 * ```typescript
 *
 *    import {updatePegBehavior} from '@ion/core/src/services/Connect';
 *    const updatePegBehavior = await updatePegBehavior(pegBehavior);
 *
 * ```
 */
export const updatePegBehavior = async(pegBehavior: PegBehavior): Promise<PegBehavior> => {
  const results = await client.put(url(`/pegbehaviors/${pegBehavior.id}`), safeJSONStringify({pegBehavior}));
  return parse(results, 'pegBehavior') as PegBehavior;
};

/**
 * Provides a convenience API which allows for retrieving all peglabels for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all peglabels in a single pseudo async call. Generally
 * this function is only to be used for performing PEG Behavior operation.
 *
 * @param {LoadPegLabelsParams} params The parameters against which the peglabels are to
 *        be retrieved.
 */
export const loadAllPegLabels = async(params: LoadPegLabelsParams): Promise<Operator[]> => {
  const pegLabels = await loadAll(getPegLabels, params, 'pegLabels');
  return pegLabels;
};

/**
 *
 * Get a System of Units.
 *
 * ```typescript
 *
 *  import {getSystemOfUnits} from '@ion/core/src/services/Connect';
 *  const getSystemOfUnits = await getSystemOfUnits();
 *
 * ```
 */
export const getSystemOfUnits = async(): Promise<systemOfUnit> => {
  const response = await client.get('systemofunits/name/Device');
  return parseCollection(response, 'quantity');
};

/**
 * The deletePegEvents function deletes an existing PEG Events Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deletePegEvents} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deletePegEvents(pegEvent);
 *
 * ```
 */
export const deletePegEvents = async(pegBehavior: PegBehavior, pegEvent: PegEvent): Promise<PegBehavior> => {
  const results = await client.delete(url(`/pegbehaviors/${pegBehavior.id}/events/${pegEvent.id}`));
  return parse(results, 'pegBehavior') as PegBehavior;
};

/**
 * Creates a Peg Behavior Event in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createPegEvent} from '@ion/core/src/services/Connect';
 *  const createdPegEvent = await createPegBehavior(pegEventToBeCreated);
 *
 * ```
 */
export const createPegEvent = async(pegBehavior: PegBehavior, pegEvent: PegEvent): Promise<PegEvent> => {
  const results = await client.post(url(`/pegbehaviors/${pegBehavior.id}/events`), safeJSONStringify({pegEvent}));
  return parse(results, 'pegEvent') as PegEvent;
};

/**
 * Create Multiple PEG Events with reference of PegBehavior
 * details.
 *
 * ```typescript
 *
 *  import {createPEGEvents} from '@ion/core/src/services/Connect';
 *  const createPEGEvent = await createPEGEvents(pegEventToBeCreated);
 *
 * ```
 */
export const createPEGEvents = async(
  pegBehavior: PegBehavior,
  pegEvents: PegEvents
): Promise<PegEvent[]> => {
  const pending           = [];
  let batch               = 25;
  const {pegAccumulators} = pegEvents?.[0]?.pegEvent || {};
  const accumsLength      = pegAccumulators?.length;
  if (accumsLength > 150) {
    batch = 10;
  }
  pegEvents?.forEach(async(item) => {
    pending.push(createPegEvent(pegBehavior, item?.pegEvent));
    if (pending?.length >= batch) {
      try {
        await Promise.all(pending);
      } catch (err) {
        error(err);
      }
      pending.length = 0;
    }
  });
  try {
    return await Promise.all(pending);
  } catch (err) {
    error(err);
    return err;
  }
};

/**
 * Get complete peg behavior which includes all the pegevents and accumulators.
 *
 * ```typescript
 *
 *  import {getPegBehavior} from '@ion/core/src/services/Connect';
 *  const getPegBehavior = await getPegBehavior(pegBehavior);
 *
 * ```
 */
export const getPegBehavior = async(
  // [CORE PACKAGE TODO]: includes parameter type was set to `PegBehaviorIncludes`, howerver
  // this type does not exist, thus change to string[] to reflect its current defaults to
  // resolve eslint errors.
  pegBehavior: PegBehavior, includes: PegBehaviorIncludes[] = ['pegEvents', 'pegAccumulators']): Promise<PegBehavior> => {
  const response = await client.get(`/pegbehaviors/${pegBehavior?.id}?include=${includes.toString()}`);
  return parseCollection(response, 'pegBehavior');
};

/**
 * Search Peg behavior by its name to verify the given name is already exist or not.
 *
 * ```typescript
 *
 *  import {searchPegBehavior} from '@ion/core/src/services/Connect';
 *  const searchPegBehavior = await searchPegBehavior(accountId, pegBehaviorName);
 *
 * ```
 */
export const searchPegBehavior = async({
  accountId,
  name,
  pg = 1,
  pgSize = 10
}: SearchPegBehaviorParams): Promise<PegBehavior> => {
  const uri = url(`/pegbehaviors/search?v=${config.ctcVersion}&pg=${pg}&pgSize=${pgSize}`);
  const results = await client.post(uri, safeJSONStringify({
    search : {
      maxResults  : MAX_RESULTS,
      searchTerms : {
        account : accountId,
        name
      }
    }
  }));
  return parseCollection(results, 'pegBehavior');
};

/**
 * Creates a Peg Behavior Event in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createPegEvent} from '@ion/core/src/services/Connect';
 *  const createdPegEvent = await createPegBehavior(pegEventToBeCreated);
 *
 * ```
 */
export const updatePegEvent = async(pegBehavior: PegBehavior, pegEvent: PegEvent): Promise<PegEvent> => {
  const eventId = pegEvent.id ? `/${pegEvent.id}` : '';
  const URL     = `/pegbehaviors/${pegBehavior.id}/events${eventId}`;
  const results = eventId
    ? await client.put(url(URL), safeJSONStringify({pegEvent}))
    : await client.post(url(URL), safeJSONStringify({pegEvent}));
  return parse(results, 'pegEvent') as PegEvent;
};

/**
 * update Multiple PEG Events with reference of PegBehavior
 * details.
 *
 * ```typescript
 *
 *  import {updatePEGEvents} from '@ion/core/src/services/Connect';
 *  const updatePEGEvent = await updatePEGEvents(pegEventToBeUpdated);
 *
 * ```
 */
export const updatePEGEvents = async(
  pegBehavior: PegBehavior,
  pegEvents: PegEvents,
  hasPegAccumulator: boolean
): Promise<PegEvent[]> => {
  const pending           = [];
  let batch               = 25;
  const {pegAccumulators} = pegEvents?.[0]?.pegEvent || {};
  const accumsLength      = pegAccumulators?.length;
  if (accumsLength > 150) {
    batch = 10;
  }
  pegEvents?.forEach(async(item) => {
    if (item?.pegEvent?.isModifiedEvent && !hasPegAccumulator) {
      pending.push(updatePegEvent(pegBehavior, item?.pegEvent));
    } else if (hasPegAccumulator) {
      pending.push(updatePegEvent(pegBehavior, item?.pegEvent));
    }
    if (pending?.length >= batch) {
      try {
        await Promise.all(pending);
      } catch (err) {
        error(err);
      }
      pending.length = 0;
    }
  });
  try {
    return await Promise.all(pending);
  } catch (err) {
    error(err);
    return err;
  }
};

/**
 * Gets the given Peg Event with the provided details.
 *
 * ```typescript
 *
 *  import {getPegEvent} from '@ion/core/src/services/Connect';
 *  const pegEvent = await getPegEvent(pegBehavior, pegEvent);
 *
 * ```
 */
export const getPegEvent = async(pegBehaviorId: number, pegEventId: number): Promise<PegEvent> => {
  const response = await client.get(url(`/pegbehaviors/${pegBehaviorId}/events/${pegEventId}`));
  return parse(response, 'pegEvent') as PegEvent;
};

/**
 * The deletePegAccumulator function deletes an existing PEG Accumulator Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deletePegAccumulator} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deletePegAccumulator(pegAccumulator);
 *
 * ```
 */
export const deletePegAccumulator = async(
  pegBehaviorId: number,
  pegEventId: number,
  pegAccumulatorId: number
): Promise<PegAccumulator | null> => {
  const results = await client.delete(url(`/pegbehaviors/${pegBehaviorId}/events/${pegEventId}/accumulators/${pegAccumulatorId}`));
  return parse(results, 'pegAccumulator') as PegAccumulator;
};

export const updateDeviceFiles = async({
  deviceFileUrl,
  deviceHeader,
  releaseNoteUrl,
  releaseHeader
}): Promise<unknown> => {
  const promises = [];
  if (deviceFileUrl) {
    promises.push(await updateAWSFile(deviceFileUrl, deviceHeader));
  }
  if (releaseNoteUrl) {
    promises.push(await updateAWSFile(releaseNoteUrl, releaseHeader));
  }
  return await Promise.allSettled(promises);
};

/**
 * The getArchitecturesAndCategories function retrives architecture and category values to show in the dropdowns.
 *
 * ```typescript
 *
 *     import {getArchitecturesAndCategories} from '@ion/core/src/services/Connect';
 *
 *     const archiAndCategory = await getArchitecturesAndCategories();
 *
 * ```
 */
export const getArchitecturesAndCategories = async(api: AxiosInstance = client): Promise<any> => {
  const response = await api.get(url('/devicetypes/architecturesandcategories'));
  return parse(response);
};

/**
 * @function getPermissions
 *
 * Retrieves all the permissions from Connect and assign it to each applications
 * while create/update role from ctc-admin application.
 *
 * ```typescript
 *
 *    import {permissions} from '@ion/core/src/services/Connect';
 *
 *    const getPermissions = await getPermissions();
 *
 * ```
 */
export const getPermissions = async(): Promise<Permissions> => {
  const response = await client.get(url('/permissions'));
  return parseCollection(response, '');
};

/**
 * The createSSOConfiguration function creates a new SSO Configuration Entity for a selected
 * account within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createSSOConfiguration} from '@ion/core/src/services/Connect';
 *
 *     const result = await createSSOConfiguration();
 *
 * ```
 */
export const createSSOConfiguration = async(ssoConfig: SSOConfiguration): Promise<GenericObject> => {
  const result = await client.post(
    url('/.well-known/openid-configuration', Service.Base),
    JSON.stringify(ssoConfig)
  );
  return result?.data;
};

/**
 * The updateSSOConfiguration function updates a SSO Configuration Entity for a selected
 * account within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateSSOConfiguration} from '@ion/core/src/services/Connect';
 *
 *     const result = await updateSSOConfiguration();
 *
 * ```
 */
export const updateSSOConfiguration = async(ssoConfig: SSOConfiguration): Promise<GenericObject> => {
  const result = await client.put(
    url(`/.well-known/openid-configuration/${ssoConfig.id}`, Service.Base),
    JSON.stringify(ssoConfig)
  );
  return result?.data;
};

/**
 * The deleteSSOConfiguration function delete a SSO Configuration Entity for a selected
 * account within the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteSSOConfiguration} from '@ion/core/src/services/Connect';
 *
 *     const result = await deleteSSOConfiguration(id);
 *
 * ```
 */
export const deleteSSOConfiguration = async(id: string): Promise<GenericObject> => {
  const results = await client.delete(url(`/.well-known/openid-configuration/${id}`, Service.Base));
  return parse(results, 'ssoConfiguration');
};

/**
 * Retrieves the SSOConfiguration of given configuration id from CTC.
 *
 * ```typescript
 *    import {getSSOConfiguration} from '@ion/core/src/services/Connect';
 *
 *    const config = await getSSOConfiguration(username, password);
 *
 * ```
 *
 * @param {string} The id of the configuration to which is to be retrieved.
 */
export const getSSOConfiguration = async(id: string): Promise<GenericObject> => {
  const result = await client.get(url(`/.well-known/openid-configuration/${id}`, Service.Base));
  return result?.data;
};

/**
 * The queryOpenIdConfigurationForDomain method retrieves CTC's openid configuration.
 *
 * ```typescript
 *    import {queryOpenIdConfigurationForDomain} from '@ion/core/src/services/Connect';
 *
 *    const config = await queryOpenIdConfigurationForDomain(oidcBaseUrl, username, accountId);
 *
 * ```
 */
export const queryOpenIdConfigurationForDomain = async(oidcBaseUrl: string, usernameWithDomain?: string,
  userAccountId?: string): Promise<any> => {
  const oidcClient = createClient({withCredentials: false});
  const requestOptions: AxiosRequestConfig = {
    withCredentials : false,
    url             : `${oidcBaseUrl}/.well-known/openid-configuration`,
    method          : 'get',
    headers         : {}
  };
  if (usernameWithDomain) {
    requestOptions.headers['X-Username'] = usernameWithDomain;
  }
  if (userAccountId) {
    requestOptions.headers['X-Account-ID'] = userAccountId;
  }
  const result = await oidcClient(requestOptions);
  return result?.data;
};

type BulkOperationRequest = {
  operation: BulkEntityOperation;
  api?: AxiosInstance;
  version?: number;
  isProvisioning?: boolean;
}

type ManufacturedDeviceOperationRequest = {
  operation: ManufacturedDeviceDetails;
  api?: AxiosInstance;
  version?: number;
}

/**
 * Main endpoint for performing bulk entity operations.
 *
 * Works with the Bulk Operation API in Connect;
 * https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/29266051073/Large+Scale+Bulk+Operations
 *
 * ```typescript
 *
 *  import {performBulkOperation} from '@ion/core/src/services/Connect';
 *
 *  const result = performBulkOperation(operation);
 *
 * ```
 */
export const performBulkOperation = async({
  operation,
  version = 2,
  api = client,
  isProvisioning = false
}: BulkOperationRequest): Promise<OperationTask> => {
  const service = (isProvisioning
    ? 'bulk-operations/provisioneddevice'
    : `bulkOperations?v=${version}`);
  const URL = url(`/entities/${service}`, Service.ApiBaseUrl);
  const results = await api.post(URL, {...operation});
  return parse(results, 'task') as OperationTask;
};

/**
 * Generates Key File based on the inputs and Encryption Key provided.
 *
 * ```typescript
 * import {getKeyFileBuilder} from '@ion/core/src/services/Connect';
 *
 * const devices = await getKeyFileBuilder(keyFile: KeyfileBuilderInterface);
 *
 * ```
 */
export const getKeyFileBuilder = async(keyFile: KeyfileBuilderInterface): Promise<any> => {
  const results = await client.post(url('/api/keyfilebuilder/v1/keyfile', Service.Base), JSON.stringify(keyFile));
  return results;
};

/**
 * Retrieves devicses based on the provided search type (identifiers and accountID).
 *
 * ```typescript
 * import {loadDevicesByIdentifiers} from '@ion/core/src/services/Connect';
 *
 * const devices = await loadDevicesByIdentifiers({identifiers, accountId, hierLevel});
 *
 * ```
 */
export const loadDevicesByIdentifiers = async({
  identifiers,
  accountId,
  hierLevel,
  pgSize,
  extension,
  entity,
  identifierType,
  omitExtensions = false
}) => {
  let uri = `/devices/smartsearch?v=${config.ctcVersion}&pgsize=${pgSize}`;
  uri = uri + (omitExtensions ? '' : `&include=${extension}`);
  const endpoint = url(setHierLevel(uri, hierLevel), Service.PULS);
  const response = await client.post(endpoint, {
    search : {
      type      : entity,
      accountId : accountId,
      query     : {
        query : {
          terms : {
            [identifierType] : identifiers
          }
        }
      }
    }
  });
  return parseCollection(response, '');
};

/**
 * Retrieves a single device by its numeric device ID using the Smart Search API.
 *
 * This helper is a thin, focused wrapper around the `/devices/smartsearch` endpoint
 * and is optimized for fetching exactly one device record.
 *
 * Internally, it performs a Smart Search query using a `queryString`
 * in the form of `id:<deviceId>`.
 *
 * ```typescript
 * 
 * import {getDeviceByIDBySmartSearch} from '@ion/core/src/services/Connect';
 *
 * const device = await getDeviceByIDBySmartSearch(123456);
 * 
 * ```
 *
 * @param id - The unique numeric device identifier to search for.
 *
 * @returns - A parsed Smart Search collection containing the matching device.
 *            The returned value is typically an array with at most one element.
 */
export const getDeviceByIdSmartSearch = async(id: number): Promise<Device> => {
  const uri = `/devices/smartsearch?v=${config.ctcVersion}&pgsize=1`;
  const endpoint = url(uri, Service.PULS);
  const response = await client.post(endpoint, {
    search : {
      queryString : `id:${id}`
    }
  });
  return parse(response, 'device') as Device;
};

/**
 *
 * The getAppIdPlatformTypes method retrieves a collection of platform APP IDs for Devices.
 *
 * @returns Promise<any>
 */
export const getAppIdPlatformTypes = async() => {
  const uri = '/platforms/types/app_id';
  const response = await client.get(url(uri, Service.PulsBaseUrl));
  const results = response?.data;
  return results;
};

/**
 * The loadProvisionedDevices function get all inventory devices within
 * the CTC Platform.
 */
export const loadProvisionedDevices = async({
  pageId = 1,
  pageSize = 20,
  filterOn
}: LoadInventoryDevicesParams) => {
  const params  = `pg=${pageId}&pgsize=${pageSize}`;
  const uri     = `/mfg/v1/provisioneddevice/search?${params}`;
  const results = await client.post(url(uri, Service.ApiBaseUrl), safeJSONStringify(filterOn));
  const {totalCount, _links} = results?.data?.response;
  return {
    devices : parseCollection(results, 'deviceProvisioning'),
    totalCount,
    _links
  };
};

/**
 * Provides a convenience API which allows for retrieving all inventory devices for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devices in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devices.
 *
 * @param {LoadInventoryDevicesParams} params The parameters against which the devices are
 *        to be retrieved.
 */
export const loadAllInventoryDevices = async(params: LoadInventoryDevicesParams): Promise<CTCEntity[]> => {
  const devices = await loadAll(loadProvisionedDevices, params, 'devices');
  return devices;
};

/**
 * The loadApplicationIds function fetches all application Ids within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {loadApplicationIds} from '@ion/core/src/services/Connect';
 *
 *     const created = await loadApplicationIds();
 *
 * ```
 */
export const loadApplicationIds = async(): Promise<any> => {
  const results = await client.get(url('/mfg/v1/applicationid', Service.ApiBaseUrl));
  return {
    applicationIds : parseCollection(results, 'applicationId') as ApplicationIds
  };
};

/**
 * Provides a paginated search implementation against CTC Application Ids Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *     import {getApplicationIds} from '@ion/core/src/services/Connect';
 *
 *     const applicationIds = await getApplicationIds();
 *
 * ```
 */
export const getApplicationIds = async({
  sortOn,
  pageId = 1,
  pageSize,
  filterOn = {},
  includeSubGroups = false
}) => {
  const uri      = `/mfg/v1/applicationid/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.ApiBaseUrl);
  const response = await client.post(endpoint, safeJSONStringify({
    search : {
      sort        : sortOn,
      searchTerms : {
        status : `${EntityStatus.Enabled}, ${EntityStatus.Deleted}, ${EntityStatus.Disabled}`,
        ...filterOn
      }
    }
  }));
  const {results, totalCount} = response.data?.response;
  return {
    applicationId : results?.map(({applicationId}) => applicationId),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all application ids for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all application ids in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a application ids.
 *
 * @param {LoadApplicationIdsParams} params The parameters against which the application ids are
 *        to be retrieved.
 */
export const loadAllApplicationIds = async(params: LoadApplicationIdsParams): Promise<CTCEntity[]> => {
  const applicationId = await loadAll(getApplicationIds, params, 'applicationId');
  return applicationId;
};

/**
 * Provides a paginated search implementation against CTC Shipments Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *     import {getShipments} from '@ion/core/src/services/Connect';
 *
 *     const shipments = await getShipments({pageId, pagesize, filterOn});
 *
 * ```
 */
export const getShipments = async({
  pageSize,
  pageId = 1,
  filterOn = {}
}) => {
  const endpoint = createManufacturingURL(`shipment/search?pg=${pageId}&pgsize=${pageSize}`);
  const response = await client.post(endpoint, safeJSONStringify(filterOn));
  const {totalCount} = response.data?.response;
  return {
    shipments : parseCollection(response, 'shipment'),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving Device Data
 * which has to be passed for re processing / re send the shipment
 *
 * ```typescript
 *
 *     import {getShipmentDevices} from '@ion/core/src/services/Connect';
 *
 *     const getDeviceData = await getShipments(shipment);
 *
 * ```
 */
export const getShipmentDevices = async(shipment: Shipment): Promise<Shipment | null> => {
  const endpoint = createManufacturingURL(`shipment/${shipment?.id}`);
  const response = await client.get(endpoint);
  return parse(response) as Shipment;
};

/**
 * The resendShipment function will allow to re submit or re process
 * the shipment devices
 *
 * ```typescript
 *
 *     import {resendShipment} from '@ion/core/src/services/Connect';
 *
 *     const resendShipment = await resendShipment(shipment);
 *
 * ```
 */
export const resendShipment = async(
  shipment: Shipment
): Promise<Shipment | null> => {
  const endpoint = createManufacturingURL(`shipment/${shipment?.id}?reprocess=true`);
  const results  = await client.put(endpoint, safeJSONStringify(shipment));
  return parse(results, 'shipments') as Shipment;
};

/**
 * Provides a paginated search implementation against Manufactured Devices Services which supports
 * optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *     import {getManufacturedDevices} from '@ion/core/src/services/Connect';
 *
 *     const manufacturedDevices = await getManufacturedDevices();
 *
 * ```
 */
export const getManufacturedDevices = async({
  sortOn,
  pageId = 1,
  pageSize,
  filterOn = {}
}) => {
  const url = createManufacturingURL(`manufactureddevice/search?pg=${pageId}&pgsize=${pageSize}`);
  const response = await client.post(url, safeJSONStringify({
    search : {
      searchTerms : {
        status : EntityStatus.Enabled,
        ...filterOn
      },
      sort : sortOn
    }
  }));
  const {results, totalCount} = response.data?.response;
  return {
    manufacturedDevice : parseCollection(response, 'manufacturedDevice'),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all manufactured devices for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all manufactured devices in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a manufactured devices.
 *
 * @param {LoadManufacturedDevicesParams} params The parameters against which the manufactured devices are
 *        to be retrieved.
 */
export const loadAllManufacturedDevices = async(params: LoadManufacturedDevicesParams): Promise<CTCEntity[]> => {
  const manufacturedDevice = await loadAll(getManufacturedDevices, params, 'manufacturedDevice');
  return manufacturedDevice;
};

/**
 * The loadDevicePartNumbers function fetches all device part numbers within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {loadDevicePartNumbers} from '@ion/core/src/services/Connect';
 *
 *     const created = await loadDevicePartNumbers();
 *
 * ```
 */
export const loadDevicePartNumbers = async({
  pageId = 1,
  pageSize,
  filterOn
}): Promise<any> => {
  const url = createManufacturingURL(`devicepartnumber/search?pg=${pageId}&pgsize=${pageSize}`);
  const results = await client.post(url, safeJSONStringify({
    search : {
      searchTerms : filterOn
    }
  }));
  return {
    devicePartNumbers : parseCollection(results, 'devicePartNumber') as DevicePartNumbers
  };
};

/**
 * Provides a paginated search implementation against CTC Device Part Numbers Services
 * which supports optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *     import {getDevicePartNumbers} from '@ion/core/src/services/Connect';
 *
 *     const devicePartNumber = await getDevicePartNumbers();
 *
 * ```
 */
export const getDevicePartNumbers = async({
  pageId = 1,
  pageSize,
  sortOn,
  includeSubGroups = false,
  filterOn = {}
}) => {
  const uri      = `/mfg/v1/devicepartnumber/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.ApiBaseUrl);
  const response = await client.post(endpoint, safeJSONStringify({
    search : {
      searchTerms : {
        status : EntityStatus.Enabled,
        ...filterOn
      },
      sort : sortOn
    }
  }));
  const {results, totalCount} = response.data?.response;
  return {
    devicePartNumber : results?.map(({devicePartNumber}) => devicePartNumber),
    totalCount
  };
};

/**
 * Provides a convenience API which allows for retrieving all device part numbers for every page
 * within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all device part numbers in a single pseudo async call. Generally
 * this function is only to be used for performing exports of a devices part numbers.
 *
 * @param {LoadDevicePartNumbersParams} params The parameters against which the device part numbers are
 *        to be retrieved.
 */
export const loadAllDevicePartNumbers = async(params: LoadDevicePartNumbersParams): Promise<CTCEntity[]> => {
  const devicePartNumber = await loadAll(getDevicePartNumbers, params, 'devicePartNumber');
  return devicePartNumber;
};

/**
 * @function createDevicePartNumber
 *
 * The createDevicePartNumber function creates a new Device Part Number Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {createDevicePartNumber} from '@ion/core/src/services/Connect';
 *
 *     const devicePartNumber = await createDevicePartNumber(item);
 *
 * ```
 *
 * @param   {devicePartNumber} devicePartNumber The CTC DevicePartNumber entity which is to be created.
 * @returns Promise<DevicePartNumber> The newly created Device Part Number entity.
 */
export const createDevicePartNumber = async(
  devicePartNumber: DevicePartNumber
): Promise<DevicePartNumber> => {
  const results = await client.post(
    url('/mfg/v1/devicepartnumber', Service.ApiBaseUrl),
    JSON.stringify(devicePartNumber)
  );
  return parse(results, 'devicePartNumber') as DevicePartNumber;
};

/**
 * @function editDevicePartNumber
 *
 * The editDevicePartNumber function edit a existing Device Part Number Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {editDevicePartNumber} from '@ion/core/src/services/Connect';
 *
 *     const devicePartNumber = await editDevicePartNumber(devicePartNumber);
 *
 * ```
 *
 * @param   {devicePartNumber} devicePartNumber The CTC DevicePartNumber entity which is to be created.
 * @returns Promise<DevicePartNumber> The editing existing Device Part Number entity.
 */
export const editDevicePartNumber = async(
  devicePartNumber: DevicePartNumber,
  devicePartNumberId: number
): Promise<DevicePartNumber> => {
  const uri      = `/mfg/v1/devicepartnumber/${devicePartNumberId}`;
  const endpoint = (url(uri, Service.ApiBaseUrl));
  const results  = await client.put(endpoint, safeJSONStringify({
    ...devicePartNumber
  }));
  return parse(results, 'devicePartNumber') as DevicePartNumber;
};

/**
 * The viewDevicePartNumber function views a existing Device Part Number Entity within the CTC Platform.
 *
 * ```typescript
 *
 *     import {viewDevicePartNumber} from '@ion/core/src/services/Connect';
 *
 *     const devicePartNumber = await viewDevicePartNumber(devicePartNumber);
 *
 * ```
 */
export const viewDevicePartNumber = async(
  devicePartNumberId: number
): Promise<DevicePartNumber> => {
  const uri     = `/mfg/v1/devicepartnumber/${devicePartNumberId}`;
  const results = await client.get(url(uri, Service.ApiBaseUrl));
  return parse(results, 'devicePartNumber') as DevicePartNumber;
};

/**
 * The deleteDevicePartNumbers function deletes an existing device part number Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteDevicePartNumbers} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteDevicePartNumbers(id);
 *
 * ```
 */
export const deleteDevicePartNumber = async(
  id: number
): Promise<DevicePartNumber> => {
  const results = await client.delete(createManufacturingURL(`devicepartnumber/${id}`));
  return parse(results, 'devicePartNumber') as DevicePartNumber;
};

/**
 * The loadMfgCarrier function fetches all Manufacturing Carrier within the CTC Platform.
 *
 * ```typescript
 *
 *     import {loadMfgCarrier} from '@ion/core/src/services/Connect';
 *
 *     const created = await loadMfgCarrier();
 *
 * ```
 */
export const loadMfgCarrier = async(): Promise<ManufacturingCarrier[]> => {
  const response = await client.get(
    url('/mfg/v1/auxiliaryvalue/type/CARRIER', Service.ApiBaseUrl)
  );
  return parseCollection(response, 'auxiliaryValue') as ManufacturingCarrier[];
};

/**
 * The updateProvisionedDevice function updates a Provisioned device Entity for a selected
 * account within the CTC Platform.
 *
 * ```typescript
 *
 *     import {updateProvisionedDevice} from '@ion/core/src/services/Connect';
 *
 *     const result = await updateProvisionedDevice(id, device);
 *
 * ```
 */
export const updateProvisionedDevice = async(id: number): Promise<GenericObject> => {
  const provisionedDevice = {
    deviceProvisionIds : [id]
  };
  const result = await client.post(url('/mfg/v1/provisioneddevice/changeregions', Service.ApiBaseUrl), JSON.stringify(provisionedDevice));
  return result?.data;
};

/**
 * The deleteProvisionedDevice function deletes an existing provisioned device Entity from the CTC Platform.
 *
 * ```typescript
 *
 *     import {deleteProvisionedDevice} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteProvisionedDevice(deviceId);
 *
 * ```
 */
export const deleteProvisionedDevice = async(
  deviceId: number
): Promise<Device | null> => {
  const results = await client.delete(url(`/mfg/v1/provisioneddevice/${deviceId}`, Service.ApiBaseUrl));
  return parse(results, 'deviceProvisioning') as Device;
};

/**
 *
 * The getServiceProfiles function fetches all serviceProfiles.
 *
 * ```typescript
 *
 *     import {getServiceProfiles} from '@ion/core/src/services/Connect';
 *
 *     const serviceProfiles = await getServiceProfiles();
 *
 * ```
 *
 * @returns  {Promise<ServiceProfile>} Get Device File Typesentity.
 */
export const getServiceProfiles = async(): Promise<ServiceProfile[]> => {
  const response = await client.get(url('/deviceServices/profile?allVersions=false', Service.PulsBaseUrl));
  const results = response?.data;
  return results as ServiceProfile[];
};

/**
 *
 * The getAccountServiceProfile function fetches service profile of an account
 * using provided account id.
 *
 * ```typescript
 *
 *     import {getAccountServiceProfile} from '@ion/core/src/services/Connect';
 *
 *     const serviceProfile = await getAccountServiceProfile(accountId);
 *
 * ```
 */
export const getAccountServiceProfile = async(id: number): Promise<ServiceProfile> => {
  const response = await client.get(url(`/accounts/${id}/serviceprofiles?status=active`));
  return parse(response, 'serviceProfile') as ServiceProfile;
};

/**
 *
 * The createServiceProfile function creates a new service profile.
 *
 * ```typescript
 *
 *     import {createServiceProfile} from '@ion/core/src/services/Connect';
 *
 *     const serviceProfile = await createServiceProfile(serviceProfile);
 *
 * ```
 */
export const createServiceProfile = async(serviceProfile: ServiceProfile): Promise<ServiceProfile> => {
  const response = await client.post(url('/serviceprofiles'), JSON.stringify({serviceProfile}));
  return parse(response, 'serviceProfile') as ServiceProfile;
};

/**
 *
 * The updateServiceProfile function updates existing service profile.
 *
 * ```typescript
 *
 *     import {updateServiceProfile} from '@ion/core/src/services/Connect';
 *
 *     const serviceProfile = await updateServiceProfile(serviceProfile);
 *
 * ```
 */
export const updateServiceProfile = async(serviceProfile: ServiceProfile): Promise<ServiceProfile> => {
  const response = await client.put(url(`/serviceprofiles/${serviceProfile.id}`), JSON.stringify({serviceProfile}));
  return parse(response, 'serviceProfile') as ServiceProfile;
};

/**
 *
 * The deleteServiceProfile function deletes existing service profile from the CTC platform.
 *
 * ```typescript
 *
 *     import {deleteServiceProfile} from '@ion/core/src/services/Connect';
 *
 *     const serviceProfile = await deleteServiceProfile(id);
 *
 * ```
 * */
export const deleteServiceProfile = async(id: number): Promise<ServiceProfile> => {
  const response = await client.delete(url(`/serviceprofiles/${id}`));
  return parse(response, 'serviceProfile') as ServiceProfile;
};

/**
 * The performScheduleDataSyncOperation function forces updates to the device to keep the
 * data in sync across platforms.
 *
 * ```typescript
 *
 *  import {performScheduleDataSyncOperation} from '@ion/core/src/services/Connect';
 *
 *  const result = performScheduleDataSyncOperation(selectedDevice);
 *
 * ```
 */
export const performScheduleDataSyncOperation = async(selectedDevice: GenericObject): Promise<any> => {
  const results = await client.post(url('/devices/forceCTCUpdate', Service.PulsBaseUrl), JSON.stringify(selectedDevice));
  return results;
};

/**
 * Main endpoint for performing bulk provisioned devices operations.
 *
 * Works with the Bulk Operation API in Connect;
 * https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/29541564420/Bulk+Provisioning+Operation
 *
 * ```typescript
 *
 *  import {performBulkProvisionedOperation} from '@ion/core/src/services/Connect';
 *
 *  const result = performBulkProvisionedOperation(operation);
 *
 * ```
 */
export const performBulkProvisionedOperation = async(
  operation: BulkEntityOperation,
  api: AxiosInstance = client
): Promise<OperationTask> => {
  const results = await api.post(url('/entities/bulk-operations/provisioneddevice', Service.ApiBaseUrl), {...operation});
  return parse(results, 'task') as OperationTask;
};

/**
 * The getAccountExtendedAttributes method retrieves the extended attributes
 * for the given account id; returning the extended attributes response
 * with the value property of the retrieved extended attributes parsed
 * to an object.
 *
 * ```typescript
 *   import Connect from 'core/services/Connect';
 *
 *   Connect.getAccountExtendedAttributes(accountId).then(extendedAttributes => {
 *     console.log(extendedAttributes.value);
 *     console.log(extendedAttributes.application);
 *   });
 * ```
 *
 * @param  {string} accountId The id of the Account for which the extended
 *         attributes are to be retrieved.
 * @returns {Promise<ExtendedAttribute>} The extended attribute object.
 */
export const getAccountExtendedAttributes = async(accountId: number): Promise<ExtendedAttribute> => {
  const response = await client.get(url(`/accounts/${accountId}/extendedattributes`));
  const results = parseCollection(response, 'extendedAttribute');
  if (results?.length) {
    const extendedAttribute = results[0];
    extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
    return extendedAttribute;
  }
};

/**
 * The saveAccountExtendedAttributes method saves the extended attributes
 * for the given account id; returning the extended attributes response
 * with the value property of the retrieved extended attributes parsed
 * to an object.
 *
 * ```typescript
 *   import Connect from 'core/services/Connect';
 *
 *   Connect.saveAccountExtendedAttributes(accountId, value).then(extendedAttributes => {
 *     console.log(extendedAttributes.value);
 *     console.log(extendedAttributes.application);
 *   });
 * ```
 *
 * @param  {string} accountId The id of the Account for which the extended
 *         attributes are to be saved.
 * @param  {object} value The value to be saved for the extendedAttribute
 *         value property. Note, this object will automatically be
 *         converted to a string via JSON.stringify.
 * @param  {string} method The HTTP method to be used for the request ('post' or 'put').
 * @returns {Promise<ExtendedAttribute>} The extended attribute object.
 */
export const saveAccountExtendedAttributes = async(accountId: number, value: any, method = 'put'): Promise<ExtendedAttribute> => {
  const response = await client[method](url(`/accounts/${accountId}/extendedattributes`), JSON.stringify({
    value : JSON.stringify(value)
  }));
  const results = parseCollection(response, 'extendedAttribute');
  if (results?.length) {
    const extendedAttribute = results[0];
    extendedAttribute.value = parseExtendedAttributes({extendedAttribute}, true);
    return extendedAttribute;
  }
};

/**
 * Retrieves job search aggregations based on the provided account ID and devices.
 *
 * ```typescript
 * import {getJobSearchAggregations} from '@ion/core/src/services/Connect';
 *
 * const handleDeviceConflicts = async(accountId, devices) => {
 *  const jobSearchAggregations = await getJobSearchAggregations(accountId, devices)
 * ...
 * }
 *
 * ```
 * @param   {number} accountId - The ID of the account.
 * @param   {string} devices - The devices to search for.
 * @returns {Promise<unknown>} A job search aggregations object.
 *
 */
export const getJobSearchAggregations = async({
  accountId,
  devices,
  transactionStatus,
  platformId,
  searchEntireAccount = false,
  page = 1,
  pageSize = 100
}: JobConflictParams): Promise<unknown> => {
  const status = `(${transactionStatus})`;
  const filePlatformId = `(filePlatformId:${platformId})`;
  const query = !searchEntireAccount ? `(${devices}) AND (filePlatformId:${platformId}) AND ${status}` : `${status} AND ${filePlatformId}`;
  const results = await client.post(url(`/v3/jobs/devices/search?pg=${page}&pgsize=${pageSize}&features=jobSearch&aggregations=true`, Service.PulsBaseUrl),
    JSON.stringify({
      account : {
        accountId          : accountId,
        includeSubaccounts : true
      },
      query : {
        query_string : {
          query
        }
      },
      sort : [{
        propertyName : 'taskIndex',
        order        : 'DESC'
      }]
    }));
  return results?.data?.response;
};

/**
 * Performs a job search query using Elasticsearch on PulsBaseUrl.
 *
 * ```typescript
 *
 * import { getJobSearchV3 } from './services/Connect';
 *
 * const handleJobSearch = async () => {
 *   const searchResults = await getJobSearchV3({
 *     accountId: 11024,
 *     query: 'jobId: *392*',
 *     page: 1,
 *     pageSize: 100
 *   });
 *   console.log(searchResults);
 * };
 *
 * ```
 *
 * @param   {number} accountId - The account ID for the job search.
 * @param   {string} query - Elasticsearch query string to filter jobs (e.g., `jobId: *392*`).
 * @param   {number} [page=1] - The page number for pagination (default is 1).
 * @param   {number} [pageSize=100] - The number of results per page (default is 100).
 * @returns {Promise<unknown>} Job search results from the API.
 */
export const getJobSearchV3 = async({
  accountId,
  query,
  page = 1,
  pageSize = 100,
  useElasticQuery = false
}: JobConflictParams): Promise<unknown> => {
  const uri  = url(`/v3/jobs/search?pg=${page}&pgsize=${pageSize}&features=jobSearch`, Service.PulsBaseUrl);
  const args = createJobSearchV3Params(accountId, query, useElasticQuery);
  const results = await client.post(uri, args);
  return results?.data?.response;
};

/**
 * Utilizes the new V3 job search API to retrieve job data for a specific account.
 * It allows for filtering, pagination, sorting, and inclusion of subaccounts in the search.
 * The response includes a list of job items, total count, and aggregations if applicable.
 * If a date range is provided, it applies a date filter for the specified range.
 *
 * @param accountId        - The ID of the account to search for jobs.
 * @param pageId           - The page number to retrieve.
 * @param pageSize         - The number of items per page.
 * @param includeSubGroups - Whether to include subaccounts in the search.
 * @param sortOn           - The sorting options. Each object should have
 *                           the format `{ propertyName: string, order: "ASC" | "DESC" }`.
 * @param query            - The query string to search for jobs.
 *                           The query uses the Elasticsearch `query_string` format. You can combine
 *                           different attributes of tasks using AND/OR operators.
 * @param dateRange        - Optional date range filter for job creation date.
 *                           The date range should have the format `{ gte: string, lte: string }` where
 *                           `gte` represents the start date and `lte` the end date, formatted as `YYYY-MM-DD`
 *                           or epoch milliseconds to meet Elasticsearch's strict date format requirements.
 *
 * @returns                  Returns the search results including the list of jobs, aggregations, and total count.
 *
 * ```typescript
 * import {loadJobSearchEngine} from '@ion/core/src/services/Connect';
 *
 * // Search for jobs in account 5099, including subaccounts, with sorting by jobId in descending order.
 * const result = await loadJobSearchEngine({
 *   accountId: 5099,
 *   pageId: 2,
 *   pageSize: 20,
 *   sortOn: [{ propertyName: 'jobId', order: 'DESC' }],
 *   includeSubGroups: true,
 *   query: 'jobId: *392*'
 * });
 *
 * // Search for multiple jobIds using an OR query.
 * const result = await loadJobSearchEngine({
 *   accountId: 5099,
 *   query: 'jobId: (39265 OR 123123)',
 *   sortOn: [{ propertyName: 'jobId', order: 'ASC' }]
 * });
 *
 * // Search with a date range filter applied.
 * const result = await loadJobSearchEngine({
 *   accountId: 5099,
 *   query: 'jobId: *392*',
 *   dateRange: { gte: '2024-09-30', lte: '2024-10-07' },
 *   sortOn: [{ propertyName: 'jobId', order: 'DESC' }]
 * });
 *
 * // Search for specific devices using a terms query.
 * const result = await loadJobSearchEngine({
 *   accountId: 5099,
 *   query: {
 *     bool: {
 *       must: [
 *         { terms: { deviceIdentifier: [1110055555, 11100555123] } }
 *       ]
 *     }
 *   },
 *   sortOn: [{ propertyName: 'jobId', order: 'ASC' }]
 * });
 * ```
 *
 * @see https://test-projectcalamp.readme.io/reference/jobtasksearch-1
 */
export const loadJobSearchEngine = async({
  paging,
  accountId,
  pageId = 1,
  pageSize = 20,
  sortOn: sort,
  isFileTypeChecked = false,
  includeSubGroups = false,
  query = 'jobId:*',
  dateRange = null,
  platformId = '',
  nameFilter = '',
  fileIds = [],
  filters = []
}: JobSearchEngineParams): Promise<LoadDownloadJobsResult> => {
  const searchQuery = createJobSearchQuery({
    isFileTypeChecked,
    query,
    dateRange,
    platformId,
    nameFilter,
    fileIds,
    filters
  });
  const uri      = `/v3/jobs/search?pg=${pageId}&pgsize=${pageSize}&features=jobSearch&aggregations=true`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.PulsBaseUrl);
  
  const response = await client.post(endpoint, JSON.stringify({
    account : {
      accountId,
      includeSubaccounts : includeSubGroups
    },
    query                : searchQuery,
    additionalProperties : ['description', 'account', 'progress', 'task.counts', 'task.progress'],
    sort
  }));

  const {results, totalCount, aggregations, links} = response?.data?.response;
  paging?.setLinks(links);
  return {
    items : results.map((job) => job),
    aggregations,
    totalCount
  } as LoadDownloadJobsResult;
};

/**
 * Retrieves the devices associated with a specific job and task from the job search API.
 * It supports pagination, filtering by progress status, and inclusion of subaccounts.
 * The response includes a list of device items, total count, and aggregations if applicable.
 *
 * @param {number} pageId - The page number to retrieve (default is 1).
 * @param {number} pageSize - The number of items per page (default is 20).
 * @param {boolean} includeSubGroups - Whether to include subaccounts in the search.
 * @param {number} jobId - The ID of the job to retrieve the task devices for.
 * @param {number} taskIndex - The index of the task to retrieve the devices for.
 *
 * @returns {Promise<LoadDownloadJobsResult>} - Returns a promise that resolves to the
 *      search result including the list of devices, aggregations, and total count.
 *
 * ```typescript
 * import {getJobTaskDevices} from '@ion/core/src/services/Connect';
 *
 * // Retrieve devices for a specific job and task, with pagination and subaccount inclusion.
 * const result = await getJobTaskDevices({
 *   jobId: 5099,
 *   taskIndex: 2,
 *   pageId: 1,
 *   pageSize: 20,
 *   includeSubGroups: true
 * });
 *
 * // Retrieve devices with specific pagination for a job task without subaccount inclusion.
 * const result = await getJobTaskDevices({
 *   jobId: 5099,
 *   taskIndex: 1,
 *   pageId: 2,
 *   pageSize: 10
 * });
 * ```
 *
 * @see https://test-projectcalamp.readme.io/reference/getdevicesbyjobidandtaskindex-1
 */
export const getJobTaskDevices = async({
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false,
  jobId,
  taskIndex
}): Promise<LoadDownloadJobsResult> => {
  const uri = `/v3/jobs/${jobId}/tasks/${taskIndex}/devices?pg=${pageId}&pgsize=${pageSize}&features=jobSearch&aggregations=true`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.PulsBaseUrl);
  const response = await client.get(endpoint);
  const {results, totalCount, aggregations} = response?.data?.response;
  return {
    items : results.map((device) => device),
    aggregations,
    totalCount
  } as LoadDownloadJobsResult;
};

/**
 * Provides a convenience API which allows for retrieving all devices, jobs and task status
 * for every page within the given parameters. This function effectively allows for bypassing manual
 * pagination and eagerly loading all devices, jobs and task status in a single pseudo async call.
 * Generally this function is only to be used for performing exports of a jobs.
 *
 * @param {JobSearchEngineParams} params The parameters against which the Devices/Jobs and Task Status
 *        are to be retrieved.
 * @param {boolean} isParallel - If true, fetches all pages in parallel. 
 *          Otherwise sequentially.
 * @param {boolean} isSequenceAfter - If true, fetches pages in parallel up to a defined PAGE_LIMIT 
 *          then sequentially to support searchAfter based pagination. Otherwise parallelly.
 */
export const loadAllJobDevices = async(
  params: JobSearchEngineParams,
  isParallel = false,
  isSequenceAfter = false
): Promise<CTCEntity[]> => {
  const results = await loadAll(loadJobDevicesSearch, params, 'items', isParallel, isSequenceAfter);
  return results;
};

/**
 * Retrieves Job Devices for a specific account with support for pagination,
 * sorting, and custom search queries. In the query string format, different
 * attributes of the device can be combined using AND/OR operators in the query.
 *
 * **Searchable Properties**: `jobId`, `taskIndex`, `deviceIdentifier`, `deviceTypeId`, `jobName`,
 * `userId`, `deviceTaskStatus`, `transactionStatus`, `statusDate`, `jobCreationDate`, `updatedOn`,
 * `filePlatformId`, `externalFileId`, `reportedName`, `fileVersion`, `isCurrent`, `otaDiagnosticCode`,
 * `otaDiagnosticString`, `otaStatCode`, `appId`, `commandType`
 *
 * **Sortable Properties**: `jobId`, `taskIndex`, `deviceTypeId`, `userId`, `deviceTaskStatus`,
 * `transactionStatus`, `statusDate`, `jobCreationDate`, `filePlatformId`, `externalFileId`,
 * `otaDiagnosticCode`, `otaStatCode`
 *
 * @param {number} accountId - The ID of the account for which to search devices.
 * @param {number} [pageId] - The page number to retrieve (default is 1).
 * @param {number} [pageSize] - The number of items per page (default is 20).
 * @param {Array<object>} [sortOn] - The sorting options for the search results.
 *      Each object should be in the format `{ propertyName: string, order: "ASC" | "DESC" }`.
 * @param {boolean} [includeSubGroups] - Whether to include devices from subaccounts
 *      in the search (default is false).
 * @param {string} [query] - The search query string using Elasticsearch `query_string` format.
 *      You can combine different attributes of devices using AND/OR operators.
 *      Searchable properties include: `jobId`, `taskIndex`, `deviceIdentifier`, `deviceTypeId`,
 *      `jobName`, `userId`, `deviceTaskStatus`, `transactionStatus`, `statusDate`,
 *      `jobCreationDate`, `updatedOn`, `filePlatformId`, `externalFileId`, `reportedName`,
 *      `fileVersion`, `isCurrent`, `otaDiagnosticCode`, `otaDiagnosticString`, `otaStatCode`,
 *      `appId`, `commandType`.
 *
 * @returns {Promise<LoadDownloadJobsResult>} - A promise that resolves to the search result,
 *      which includes the list of job devices, aggregations, and total count.
 *
 * ```typescript
 * import {loadJobDevicesSearch} from '@ion/core/src/services/Connect';
 *
 * const result = await loadJobDevicesSearch({
 *   accountId: 5099,
 *   pageId: 2,
 *   pageSize: 20,
 *   sortOn: [{ propertyName: 'jobId', order: 'DESC' }],
 *   includeSubGroups: true,
 *   query: 'jobId:*392*'
 * });
 *
 * // Search for devices associated with multiple job IDs using an OR query.
 * const result = await loadJobDevicesSearch({
 *   accountId: 5099,
 *   query: 'jobId:(39265 OR 123123)',
 *   sortOn: [{ propertyName: 'jobId', order: 'ASC' }]
 * });
 *
 * ```
 *
 * @see https://test-projectcalamp.readme.io/reference/jobdevicesearch-1
 */
export const loadJobDevicesSearch = async({
  accountId,
  paging = null,
  pageId = 1,
  pageSize = 20,
  sortOn: sort,
  includeSubGroups = false,
  query = 'jobId:*',
  hasPaging = false
}: JobSearchEngineParams): Promise<LoadDownloadJobsResult> => {
  const paginationQuery = `pg=${pageId}&pgsize=${pageSize}`;
  let pagination = hasPaging
    ? paging?.getPaging(pageId, pageSize) :(pageSize * pageId > MAX_LIMIT) ? paging : paginationQuery;
  if (isNil(paging)) {
    pagination = `pg=${pageId}&pgsize=${pageSize}`;
  }
  const uri = `/v3/jobs/devices/search?${pagination}&features=jobSearch&aggregations=true`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.PulsBaseUrl);
  const response = await client.post(endpoint, JSON.stringify({
    account : {
      accountId,
      includeSubaccounts : includeSubGroups
    },
    query : query,
    sort
  }));
  const {results, totalCount, aggregations, errors, links} = response?.data?.response;
  const finalResults = !isEmpty(errors) ? results?.concat(errors) : results;
  paging?.setLinks(links);
  return {
    items  : finalResults?.map((job) => job),
    _links : links,
    aggregations,
    totalCount
  } as LoadDownloadJobsResult;
};

/**
 * Retrieves ModBus data for a specific account with support for pagination,
 * sorting, and custom search quries.
 *
 * ```typescript
 *
 *  import {loadModBusData} from '@ion/core/src/services/Connect';
 *  const modBusData = await loadModBusData();
 *
 * ```
 */
export const loadModBusData = async({
  account,
  sortOn,
  filterOn = {},
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false
}: LoadModBusParams): Promise<LoadModBusResult> => {
  const uri       = `/modbus/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint  = url((uri), Service.Connect);
  const hierLevel = includeSubGroups ? 'ALL' : '';
  const response  = await client.post(endpoint, JSON.stringify({
    search : {
      searchTerms : {
        account,
        sort      : sortOn,
        hierLevel : hierLevel
      }
    }
  }));

  const {
    totalCount
  } = response?.data?.response;

  return {
    modbus : parseCollection(response, 'modbus'),
    totalCount
  };
};

/**
 * Creates a ModBus in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createModBus} from '@ion/core/src/services/Connect';
 *  const createdModBus = await createModBus(modbus);
 *
 * ```
 */
export const createModBus = async(modbus: ModBus): Promise<ModBus> => {
  const results = await client.post(url('/modbus', Service.Connect), safeJSONStringify({modbus}));
  return parse(results, 'modbus') as ModBus;
};

/**
 * updated a ModBus in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {updateModBus} from '@ion/core/src/services/Connect';
 *  const updatedModBus = await updateModBus(modbus);
 *
 * ```
 */
export const updateModBus = async(modbus: ModBus): Promise<ModBus> => {
  const results = await client.put(url(`/modbus/${modbus?.id}`, Service.Connect), JSON.stringify(modbus));
  return parse(results, 'modbus') as ModBus;
};

/**
 * Deletes a ModBus in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {deleteModBus} from '@ion/core/src/services/Connect';
 *  const deletedModBus = await deleteModBus(modbus);
 *
 * ```
 */
export const deleteModBus = async(modbus: ModBus): Promise<ModBus> => {
  const results = await client.delete(url(`/modbus/${modbus?.id}`, Service.Connect));
  return parse(results, 'modbus') as ModBus;
};

/**
 * Retrieves a ModBus in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBus} from '@ion/core/src/services/Connect';
 *  const modBus = await getModBus(modbus);
 *
 * ```
 */
export const getModBus = async(modbus: ModBus): Promise<ModBus> => {
  const results = await client.get(url(`/modbus/${modbus?.id}`, Service.Connect));
  return parse(results, 'modbus') as ModBus;
};

/**
 * Retrieves a ModBus CRC in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBus} from '@ion/core/src/services/Connect';
 *  const modBus = await getModBus(modbus);
 *
 * ```
 */
export const getModBusCrc = async(modbus: ModBus): Promise<ModBus> => {
  const results = await client.get(url(`/modbus/crc/${modbus?.dataCrc}`, Service.Connect));
  return parse(results, 'modbus') as ModBus;
};

/**
 * Retrieves a ModBus Parameter in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusParameter} from '@ion/core/src/services/Connect';
 *  const modBusParameter = await getModBusParameter(modbus);
 *
 * ```
 */
export const getModBusParameter = async(): Promise<ModBusParameters> => {
  const results = await client.get(url('/modbus/parameter', Service.PULS));
  return parseCollection(results, 'modbusParameter') as ModBusParameters;
};

/**
 * Retrieves a ModBus Parameter by Id in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusParameterById} from '@ion/core/src/services/Connect';
 *  const modBusParameterById = await getModBusParameterById(modbus);
 *
 * ```
 */
export const getModBusParameterById = async(modbus: ModBusParameter): Promise<ModBusParameter> => {
  const results = await client.get(url(`/modbus/parameters/${modbus?.id}`, Service.PULS));
  return parse(results, 'modbusParameter') as ModBusParameter;
};

/**
 * Retrieves a ModBus Parameter by Index and Id in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusParameterByIndex} from '@ion/core/src/services/Connect';
 *  const modBusParameterByIndex = await getModBusParameterByIndex(modbus);
 *
 * ```
 */
export const getModBusParameterByIndex = async(modbus: ModBusParameter): Promise<ModBusParameter> => {
  const results = await client.get(url(`/modbus/parameters/${modbus?.id}/index/${modbus?.index}`, Service.PULS));
  return parse(results, 'modbusParameter') as ModBusParameter;
};

/**
 * Retrieves ModBus Config data for a specific account with support for
 * pagination, sorting, and custom search quries.
 *
 * ```typescript
 *
 *  import {loadModBusConfigData} from '@ion/core/src/services/Connect';
 *  const modBusConfigData = await loadModBusConfigData();
 *
 * ```
 */
export const loadModBusConfigData = async({
  account,
  sortOn,
  filterOn = {},
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false
}: LoadModBusConfigParams): Promise<LoadModBusConfigResult> => {
  const uri       = `/modbus/config/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint  = url((uri), Service.Connect);
  const hierLevel = includeSubGroups ? 'ALL' : '';
  const response  = await client.post(endpoint, JSON.stringify({
    search : {
      searchTerms : {
        account,
        sort      : sortOn,
        hierLevel : hierLevel
      }
    }
  }));

  const {
    totalCount
  } = response?.data?.response;

  return {
    modbusConfig : parseCollection(response, 'modbusConfig'),
    totalCount
  };
};

/**
 * Creates a ModBus Config in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {createModBusConfig} from '@ion/core/src/services/Connect';
 *  const createdModBusConfig = await createModBusConfig(modbusConfig);
 *
 * ```
 */
export const createModBusConfig = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.post(url('/modbus/config', Service.Connect), safeJSONStringify({modbusConfig}));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * updated a ModBus Config in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {updateModBusConfig} from '@ion/core/src/services/Connect';
 *  const updatedModBusConfig = await updateModBusConfig(modbus);
 *
 * ```
 */
export const updateModBusConfig = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.put(url(`/modbus/config/${modbusConfig?.id}`, Service.Connect), JSON.stringify(modbusConfig));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * Deletes a ModBus Config in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {deleteModBusConfig} from '@ion/core/src/services/Connect';
 *  const deletedModBusConfig = await deleteModBusConfig(modbusConfig);
 *
 * ```
 */
export const deleteModBusConfig = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.delete(url(`/modbus/config/${modbusConfig?.id}`, Service.Connect));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * Retrieves a ModBus Config in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusConfig} from '@ion/core/src/services/Connect';
 *  const modBusConfig = await getModBusConfig(modbusConfig);
 *
 * ```
 */
export const getModBusConfig = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.get(url(`/modbus/config/${modbusConfig?.id}`, Service.Connect));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * Retrieves a ModBus Config By Id in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusConfigById} from '@ion/core/src/services/Connect';
 *  const modBusConfigById = await getModBusConfigById(modbusConfig);
 *
 * ```
 */
export const getModBusConfigById = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.get(url(`/modbus/${modbusConfig?.id}/config`, Service.Connect));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * Retrieves a ModBus Config CRC in Connect Services with the provided details.
 *
 * ```typescript
 *
 *  import {getModBusConfigCrc} from '@ion/core/src/services/Connect';
 *  const modBusConfigCRC = await getModBusConfigCrc(modbusConfig);
 *
 * ```
 */
export const getModBusConfigCrc = async(modbusConfig: ModBusConfigs): Promise<ModBusConfigs> => {
  const results = await client.get(url(`/modbus/crc/${modbusConfig?.id}/config`, Service.Connect));
  return parse(results, 'modbusConfig') as ModBusConfigs;
};

/**
 * Fetches the dasnboard to a specified details.
 *
 * @param accountId - The ID of the account for which to fetch profile data.
 * @param pageId    - The page number to retrieve (default is 1).
 * @param pageSize  - The number of items per page (default is 20).
 *
 * @returns         - A promise that resolves to a compliance dashboard,
 *                    including the list of details and the total count.
 *
 * ```typescript
 * import {loadComplianceDashboard} from '@ion/core/src/services/Connect';
 *
 * const result = await loadComplianceDashboard({
 *   accountId: 5099,
 *   pageId: 1,
 *   pageSize: 20
 * });
 * ```
 */
export const loadComplianceDashboard = async({
  accountId,
  sortOn,
  pageId = 0,
  pageSize = 20,
  includeSubGroups = false,
  ...searchFields
}: LoadComplianceDashboardParams): Promise<LoadComplianceDashboardResult> => {
  const uri = `/carbs/accounts/dashboard?pg=${pageId}&pgsize=${pageSize}`;

  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.ApiBaseUrl);

  const searchTerms = removeUndefined({
    accountId,
    ...searchFields
  });
  
  const requestBody = {
    search : {
      sort : sortOn,
      searchTerms
    }
  };

  const response = await client.post(endpoint, safeJSONStringify(requestBody));
  const {
    content,
    totalCount
  } = response?.data;

  return {
    carb : content.map((carb) => carb),
    totalCount
  };
};

/**
 * Endpoint for performing bulk Submit NST operations.
 *
 * ```typescript
 *
 *  import {performSubmitNst} from '@ion/core/src/services/Connect';
 *
 *  const result = performSubmitNst({operation});
 *
 * ```
 */
export const performSubmitNst = async({
  operation,
  api = client
}: SubmitNSTOperationRequest): Promise<any> => {
  const URL = url('/carb/bulk-operations/nst', Service.ApiBaseUrl);
  const results = await api.post(URL, {...operation});
  return parse(results, 'nstNotice') as any;
};

/**
 * Provides a paginated search implementation against CTC Event History Result Services
 * which supports optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadTestHistory} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 events within the given device ...
 *    const, {events, totalCount} = await loadTestHistory({
 *      deviceId        : 321,
 *      pageId           : 1,
 *      pageSize         : 20
 *    });
 *
 * ```
 */
export const loadTestHistory = async({
  deviceId,
  assetId,
  result,
  startDate,
  endDate,
  sortOn,
  pageId = 1,
  pageSize = 20
}: LoadTestHistoryParams): Promise<LoadTestHistoryResult> => {
  const sortValue = sortOn?.[0];
  const isDesc = sortValue?.includes('-');

  const sortField = sortValue
    ? (isDesc ? sortValue.split('-')[1] : sortValue)
    : 'date';

  const sortOrder = isDesc ? 'desc' : 'asc';
  const uri =
  `/carbs/v1/emission-test/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, false), Service.ApiBaseUrl);
  const search = {
    deviceId,
    assetId,
    startDate,
    endDate,
    ...(result && {result})
  };

  const response = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : [`${sortField},${sortOrder}`],
      searchTerms : search
    }
  }));

  const {
    content,
    totalCount
  } = response.data || {};

  return {
    events : content,
    totalCount
  };
};

/**
 * Endpoint for Submit the vehicle emission-test by their emission test Id.
 *
 * ```typescript
 *
 *    import {submitEmissionTestById} from '@ion/core/src/services/Connect';
 *
 *    const emissionTestId = '123';
 *    const result = await submitEmissionTestById(emissionTestId);
 *
 * ```
 */
export const submitEmissionTestById = async(id: string): Promise<GenericObject> => {
  const results = await client.post(url(`/carbs/v1/emission-test/${id}/submit`, Service.ApiBaseUrl));
  return results?.data as GenericObject;
};

/**
 * Endpoint to get the device data from CMS side for the given device Id.
 *
 * ```typescript
 *
 *    import {getDeviceByDeviceId} from '@ion/core/src/services/Connect';
 *
 *    const deviceId = '123';
 *    const result = await getDeviceByDeviceId(deviceId);
 *
 * ```
 */
export const getDeviceByDeviceId = async(id: number): Promise<CMSDevice> => {
  const results = await client.get(url(`/carbs/devices/${id}`, Service.ApiBaseUrl));
  return results?.data as CMSDevice;
};

/**
 * Provides a paginated search implementation against CTC Continuous Monitoring Result
 * which supports optional sorting, filtering, and hierarchical support.
 *
 * ```typescript
 *
 *    import {loadContinuousMonitoring} from '@ion/core/src/services/Connect';
 *
 *    // retrieve the first 20 events within the given device ...
 *    const, {events, totalCount} = await loadContinuousMonitoring({
 *      esn       : 80997765,
 *      accountId : 3
 *      pageId    : 1,
 *      pageSize  : 20
 *    });
 *
 * ```
 */
export const loadContinuousMonitoring = async({
  esn,
  accountId,
  preCheckStatus,
  startDate,
  endDate,
  sortOn,
  pageId = 1,
  pageSize = 20
}: LoadContinuousMonitoringParams): Promise<LoadContinuousMonitoringResult> => {
  let sortValue = sortOn?.[0];
  if (sortValue === 'date') {
    sortValue = 'createdOn';
  } else if (sortValue === '-date') {
    sortValue = '-createdOn';
  };

  const isDesc    = sortValue?.includes('-');
  const sortField = sortValue
    ? (isDesc ? sortValue.split('-')[1] : sortValue)
    : 'createdOn';
  
  const sortOrder = isDesc ? 'desc' : 'asc';
  const uri       = `/carbs/v1/precheck/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint  = url(setHierLevel(uri, false), Service.ApiBaseUrl);
  const search = {
    esn,
    accountId,
    createdDate : `[${startDate} TO ${endDate}]`,
    ...(preCheckStatus && {preCheckStatus})
  };

  const response = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : [`${sortField},${sortOrder}`],
      searchTerms : search
    }
  }));

  const {
    content,
    totalCount
  } = response.data || {};

  return {
    events : content,
    totalCount
  };
};

/**
 * Fetches Vehicle Engineering Services Vehicle Manager data for a specific
 * account with support for pagination, sorting, and filtering by environment
 * type (`test` or `production`).
 *
 * @param accountId        - The ID of the account for which to fetch profile data.
 * @param pageId           - The page number to retrieve (default is 1).
 * @param pageSize         - The number of items per page (default is 20).
 * @param sortOn           - Sorting options for the search results.
 * @param environment      - Profile environment type to filter by - 'test' or
 *                           'production'
 * @param includeSubGroups - Whether to include profiles from subaccounts
 *                           (default is false).
 *
 * @returns                - A promise that resolves to the vehicle data,
 *                           including the list of vehicles and the total count.
 *
 * ```typescript
 * import {loadVehicleManagerData} from '@ion/core/src/services/Connect';
 *
 * const result = await loadVehicleManagerData({
 *   accountId: 2,
 *   pageId: 1,
 *   pageSize: 20,
 *   sortOn: [{ propertyName: 'year', order: 'DESC' }],
 *   environment: 'test',
 *   includeSubGroups: true
 * });
 * ```
 *
 * @see https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/30253678593/Vehicles+Search
 */
export const loadVehicleManagerData = async({
  accountId,
  sortOn,
  vin,
  year,
  make,
  model,
  engine,
  fuel,
  parameterName,
  esn,
  environment,
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false
}: LoadVehicleManagerParams): Promise<LoadVehicleManagerResult> => {
  const uri = `/vehicleprofiles/vehicles/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url((uri), Service.VehicleServiceUrl);
  const searchTerms = {
    vin,
    accountId,
    profileEnv : environment,
    year,
    make,
    model,
    engine,
    fuel,
    parameterName,
    esn
  };
  const hierLevelVal = includeSubGroups ? 'ALL' : '';
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : {
      search : {
        searchTerms,
        hierLevel : hierLevelVal,
        sort      : sortOn
      }
    }
  });

  const {results, totalCount} = response.data?.response;
  return {
    vehicleProfile : results?.map(({vehicleProfile}) => vehicleProfile),
    totalCount
  };
};

/**
 * Retrieves the list of vehicle details & validation results for the given VIN.
 *
 * ```typescript
 * import {loadValidationResults} from '@ion/core/src/services/Connect';
 *
 * const {vehicleDetails}       = useLoadValidationResults(vinValue);
 *
 *
 * @returns A Promise containing the list of vehicle details
 * and validationResults with oemParameters
 */
export const loadValidationResults = async(vinValue) => {
  const response = await client({
    url     : url(`/vehicleprofiles/vehicles/${vinValue}`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Retrieves the list of available OTA states for the given Job.
 *
 * ```typescript
 * import {getOtaStatCode} from '@ion/core/src/services/Connect';
 *
 * const loadOtaStatCode = async() => {
 *  const data = await getOtaStatCode();
 *   ...
 * }
 *
 * {
 *  "0": "UNKNOWN",
 *  "1": "DNLD_INPROGRESS",
 *  "2": "DNLD_COMPLETE",
 *  "3": "DNLD_FAILED",
 *  "4": "PRG_INPROGRESS",
 *  "5": "PRG_COMPLETE",
 *  "6": "PRG_FAILED"
 *  }
 *
 * @returns A Promise containing the list of OTA states.
 * @see {@link https://test-projectcalamp.readme.io/reference/getjobstate}
 *
 */
export const getOtaStatCode = async(): Promise<unknown[]> => {
  const results = await client.get(url('/otacode/otastate', Service.PulsBaseUrl));
  return parse(results) as any[];
};

/**
 * Fetches Vehicle Engineering Services Profile Manager data for a specific
 * account with support for pagination, sorting, and filtering by environment
 * type (`test` or `production`).
 *
 * @Info - Profiles Search requires that we pass all params as part of the request body.
 *
 * **Searchable Properties**:
 * - `accountId` (required): Account ID to fetch profiles for.
 * - `profileEnv`: Profile environment type (`test` or `production`).
 * - `year`: Vehicle's year.
 * - `make`: Vehicle's make.
 * - `model`: Vehicle's model.
 * - `engine`: Vehicle's engine type.
 * - `fuel`: Vehicle's fuel type.
 * - `parameterName`: OEM parameter names (comma-separated list).
 *
 * **Sortable Properties**:
 * - `createdOn`
 *
 * @param accountId        - The ID of the account for which to fetch profile data.
 * @param pageId           - The page number to retrieve (default is 1).
 * @param pageSize         - The number of items per page (default is 20).
 * @param sortOn           - Sorting options for the search results.
 * @param environment      - Profile environment type to filter by - 'test' or
 *                           'production'
 * @param includeSubGroups - Whether to include profiles from subaccounts
 *                           (default is false).
 *
 * @returns                - A promise that resolves to the profile data,
 *                           including the list of profiles and the total count.
 *
 * ```typescript
 * import {loadProfileManagerData} from '@ion/core/src/services/Connect';
 *
 * const result = await loadProfileManagerData({
 *   accountId: 5099,
 *   pageId: 1,
 *   pageSize: 20,
 *   sortOn: [{ propertyName: 'year', order: 'DESC' }],
 *   environment: 'test',
 *   includeSubGroups: true
 * });
 * ```
 *
 * @see https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/30259511343/Profiles+Search
 */
export const loadProfileManagerData = async({
  accountId,
  sortOn,
  year,
  make,
  model,
  engine,
  fuel,
  parameterName,
  pageId = 1,
  pageSize = 20,
  environment = 'test',
  includeSubGroups = false
}: LoadProfileManagerParams): Promise<LoadProfileManagerResult> => {
  const uri         = '/vehicleprofiles/profiles/search?v=2';
  const endpoint    = url((uri), Service.VehicleServiceUrl);
  const searchTerms = {
    accountId,
    profileEnv : environment,
    year,
    make,
    model,
    engine,
    fuel,
    parameterName
  };

  const requestBody: ProfileSearchRequest = {
    search : {
      pg     : pageId,
      pgsize : pageSize,
      sort   : sortOn,
      searchTerms
    }
  };

  if (includeSubGroups) {
    requestBody.search.hierLevel = 'ALL';
  }

  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : JSON.stringify(requestBody)
  });

  const {
    results = [],
    totalCount = 0
  } = response?.data?.response || {};

  return {
    profileManager : results.map((profile) => profile),
    totalCount
  };
};

/**
 * Searches vehicle profiles by their numeric IDs rather
 * than string values, with support for pagination and sorting.
 * 
 * **Searchable Properties**:
 * - `accountId` (required): Account ID to fetch profiles for.
 * - `profileEnv`: Profile environment type (`test` or `production`).
 * - `year`: Vehicle's year ID (numeric).
 * - `make`: Vehicle's make ID (numeric).
 * - `model`: Vehicle's model ID (numeric).
 * - `engine`: Vehicle's engine type ID (numeric).
 * - `fuel`: Vehicle's fuel type ID (numeric).
 *
 * **Sortable Properties**:
 * - `createdOn`
 *
 * @param accountId   - The ID of the account for which to fetch profile data.
 * @param year        - The numeric ID of the vehicle's year.
 * @param make        - The numeric ID of the vehicle's make.
 * @param model       - The numeric ID of the vehicle's model.
 * @param engine      - The numeric ID of the vehicle's engine type.
 * @param fuel        - The numeric ID of the vehicle's fuel type.
 * @param pageId      - The page number to retrieve (default is 1).
 * @param pageSize    - The number of items per page (default is 20).
 * @param sortOn      - Sorting options for the search results.
 * @param environment - Profile environment type to filter by - 'test' or
 *                      'production'.
 * @returns           - A promise that resolves to the profile data, including
 *                      the list of profiles and the total count.
 *
 * ```typescript
 * import {searchProfilesById} from '@ion/core/src/services/Connect';
 * ...
 *
 * const result = await searchProfilesById({
 *   accountId: 5099,
 *   year: 2020,
 *   make: 15,
 *   model: 342,
 *   engine: 89,
 *   fuel: 3,
 *   pageId: 1,
 *   pageSize: 20,
 *   environment: 'test'
 * });
 * ```
 */
export const searchProfilesById = async({
  accountId,
  sortOn,
  year,
  make,
  model,
  engine,
  fuel,
  pageId = 1,
  pageSize = 20,
  environment = 'test'
}: SearchProfilesByIdParams): Promise<LoadProfileManagerResult> => {
  const uri         = '/vehicleprofiles/profiles/searchById';
  const endpoint    = url((uri), Service.VehicleServiceUrl);
  const searchTerms = {
    accountId,
    profileEnv : environment,
    year,
    make,
    model,
    engine,
    fuel
  };
  const requestBody: ProfileSearchRequest = {
    search : {
      pg        : pageId,
      pgsize    : pageSize,
      sort      : sortOn,
      hierLevel : 'ALL',
      searchTerms
    }
  };
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : JSON.stringify(requestBody)
  });
  const {
    results = [],
    totalCount = 0
  } = response?.data?.response || {};
  return {
    profileManager : results.map((profile) => profile),
    totalCount
  };
};

/**
 * Fetches the associated vehicles to a specified Profile.
 *  * **Searchable Properties**:
 * - `accountId` (required): Account ID to fetch profiles for.
 * - `profileEnv`: Profile environment type (`test` or `production`).
 * - `year`: Vehicle's year.
 * - `make`: Vehicle's make.
 * - `model`: Vehicle's model.
 * - `engine`: Vehicle's engine type.
 * - `fuel`: Vehicle's fuel type.
 * - `parameterName`: OEM parameter names (comma-separated list).
 *
 * **Sortable Properties**:
 * - `createdOn`
 *
 * @param accountId        - The ID of the account for which to fetch profile data.
 * @param year             - The year of the vehicle.
 * @param make             - The make of the vehicle.
 * @param model            - The model of the vehicle.
 * @param vin              - The vin of the vehicle.
 * @param pageId           - The page number to retrieve (default is 1).
 * @param pageSize         - The number of items per page (default is 20).
 * @param environment      - Profile environment type to filter by - 'test' or
 *                           'production'
 * @param includeSubGroups - Whether to include profiles from subaccounts
 *                           (default is false).
 *
 * @returns                - A promise that resolves to a profile's vehicles,
 *                           including the list of vehicles and the total count.
 *
 * ```typescript
 * import {loadProfileVehicles} from '@ion/core/src/services/Connect';
 *
 * const result = await loadProfileVehicles({
 *   accountId: 5099,
 *   pageId: 1,
 *   pageSize: 20,
 *   environment: 'test',
 *   includeSubGroups: true
 * });
 * ```
 */
export const loadProfileVehicles = async({
  accountId,
  year,
  make,
  model,
  engine,
  fuel,
  vin,
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false,
  environment = 'test'
}: LoadProfileVehiclesParams): Promise<LoadProfileVehiclesResult> => {
  const endpoint = url(`/vehicleprofiles/profiles/vehicles?v=2&pg=${pageId}&pgsize=${pageSize}`, Service.VehicleServiceUrl);
  const searchTerms = {
    accountId,
    profileEnv : environment,
    year,
    make,
    model,
    engine,
    fuel,
    vin
  };
  const requestBody = {
    search : {
      sort : '+vin',
      searchTerms
    }
  };
  if (includeSubGroups) {
    requestBody.search.hierLevel = 'ALL';
  }
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : JSON.stringify(requestBody)
  });
  const {
    results = [],
    totalCount = 0
  } = response?.data?.response || {};

  return {
    vehicles : results.map((vehicle) => vehicle),
    totalCount
  };
};

/**
 * Promotes PIDs (Parameter IDs) from Test to Production profiles for a specific
 * vehicle configuration based on the provided attributes.
 *
 * @Info - To promote PIDs to Production, all required attributes (Year, Make,
 * Model, Engine, Fuel, and OEM Parameters) must be included in the request body.
 *
 * **Request Parameters**:
 * - `year` (required): The vehicle's year.
 * - `make` (required): The vehicle's make.
 * - `model` (required): The vehicle's model.
 * - `engine` (required): The vehicle's engine type.
 * - `fuel` (required): The vehicle's fuel type.
 * - `oemParameter` (required): A comma-separated string of OEM Parameter IDs to
 *   promote.
 *
 * **Response**:
 * - `totalCount`: The total number of PIDs processed.
 * - `results`: An array of objects representing the promotion results, including:
 *    - `paramId`: The ID of the promoted parameter.
 *    - `paramName`: The name of the promoted parameter.
 *    - `success`: A boolean indicating if the promotion was successful.
 *    - `errorMessage` (optional): An error message if the promotion failed.
 *
 * @param year         - The vehicle's year.
 * @param make         - The vehicle's make.
 * @param model        - The vehicle's model.
 * @param engine       - The vehicle's engine type.
 * @param fuel         - The vehicle's fuel type.
 * @param oemParameter - A comma-separated string of OEM Parameter IDs to promote.
 *
 * @returns            - A promise that resolves to an object containing:
 *                       - `results`: The promotion results.
 *                       - `totalCount`: The total number of PIDs processed.
 *
 * ```typescript
 * import {promotePidsToProduction} from '@ion/core/src/services/Connect';
 *
 * const result = await promotePidsToProduction({
 *   year: 2024,
 *   make: 8,
 *   model: 241,
 *   engine: 1,
 *   fuel: 15,
 *   oemParameter: "1,3,7"
 * });
 *
 * ```
 *
 * **Sample Request**:
 * ```json
 * {
 *   "year": 2024,
 *   "make": 8,
 *   "model": 241,
 *   "engine": 1,
 *   "fuel": 15,
 *   "oemParameter": "1,3,7"
 * }
 * ```
 *
 * **Sample Response**:
 * ```json
 * {
 *   "response": {
 *     "totalCount": 3,
 *     "results": [
 *       {
 *         "paramId": 1,
 *         "paramName": "Engine Speed",
 *         "success": true
 *       },
 *       {
 *         "paramId": 3,
 *         "paramName": "Odometer",
 *         "success": true
 *       },
 *       {
 *         "paramId": 7,
 *         "paramName": "Engine Coolant Temp",
 *         "success": false,
 *         "errorMessage": "PID not found"
 *       }
 *     ]
 *   }
 * }
 * ```
 *
 * @see https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/30257119249/Profiles+Promote+PIDs+to+Production
 */
export const promotePidsToProduction = async({
  year,
  make,
  model,
  engine,
  fuelType,
  busProfileIds
}: PromotePidsParams): Promise<PromotePidsParamsToProductionResult> => {
  const uri      = '/vehicleprofiles/profiles/promote?v=2';
  const endpoint = url((uri), Service.VehicleServiceUrl);
  const requestBody: PromotePidsParams = {
    year,
    make,
    model,
    engine,
    fuelType,
    busProfileIds
  };
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : JSON.stringify(requestBody)
  });

  return response as PromotePidsParamsToProductionResult;
};

/**
 * Gets the validation rules for a single oemParameter ID.
 *
 * ```typescript
 * import {getValidationRules} from
 *
 * const result = await getValidationRules(3);
 *
 * ```
 *
 * @param ruleId - the numeric oemParameter rule ID.
 * @returns      - a JSON object containing message data for the requested rule.
 */
export const getValidationRules = async(ruleId: number) => {
  const response = await client({
    url     : url(`/vehicleprofiles/validationrules/${ruleId}`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Retrieves the list of vehicle details & validation results for the given VIN.
 *
 * ```typescript
 * import {getVehicleHistory} from '@ion/core/src/services/Connect';
 *
 * const {vehicleHistory}       = useLoadVehicleHistory(vinValue);
 *
 *
 * @returns A Promise containing the list of vehicle details
 * and validationResults with oemParameters
 */
export const getVehicleHistory = async({
  vinId,
  startDate,
  endDate
}) => {
  const response = await client({
    url     : url(`/v2/vehicleid/history?vin=${vinId}${startDate ? `&dateTriggeredStart=${startDate}` : ''}${endDate ? `&dateTriggeredEnd=${endDate}` : ''}`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response;
};

/**
 * Fetches OEM Validation Rules Services Vehicle Manager data for a specific
 * account with support for pagination, sorting, and filtering by environment
 * type (`test` or `production`).
 *
 * @param accountId        - The ID of the account for which to fetch profile data.
 * @param pageId           - The page number to retrieve (default is 1).
 * @param pageSize         - The number of items per page (default is 20).
 * @param sortOn           - Sorting options for the search results.
 * @param paramName        - The search term to filter data
 * @param includeSubGroups - Whether to include validation rules from subaccounts
 *                           (default is false).
 *
 * @returns                - A promise containing list of OEM Validation Rules,
 *                           including the total count.
 *
 * ```typescript
 * import {getOemValidationRules} from '@ion/core/src/services/Connect';
 *
 * const result = await getOemValidationRules({
 *   accountId: 2,
 *   pageId: 1,
 *   pageSize: 20,
 *   sortOn: [{ propertyName: 'paramName', order: 'ASC' }],
 *   includeSubGroups: true
 * });
 * ```
 *
 * @see https://calampcorp.atlassian.net/wiki/spaces/APITier/pages/30275665932/Validation+Rules+Search
 */
export const getOemValidationRules = async({
  accountId,
  parameterName,
  sortOn,
  pageId = 1,
  pageSize = 20,
  includeSubGroups = false
}: LoadValidationRulesParams): Promise<LoadValidationRulesResult> => {
  const uri = `/vehicleprofiles/validationrules/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.VehicleServiceUrl);
  const searchTerms = {
    accountId,
    parameterName
  };
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : {
      search : {
        searchTerms,
        sort : sortOn
      }
    }
  });

  const {results, totalCount} = response.data?.response;
  return {
    validationRule : results?.map(({validationRule}) => validationRule),
    totalCount
  };
};

/** Loads inspection results based on the provided parameters. This function retrieves paginated
 * inspection results with optional filters, sorting, and subgroup inclusion.
 *
 * ```typescript
 *
 * import {loadInspectionResults} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const results = await loadInspectionResults({
 *     accountId: 12345,
 *     pageId: 2,
 *     pageSize: 50,
 *     sortOn: 'inspectionDate',
 *     filterOn: {status: 'Pass'},
 *     includeSubGroups: true
 *   });
 *   console.log(results.inspectionResults);
 * };
 *
 * ```
 *
 * @param   params.accountId        - The ID of the account for which to load inspection results.
 * @param   params.pageId           - The page number for pagination. Defaults to 1.
 * @param   params.pageSize         - The number of results per page. Defaults to 20.
 * @param   params.sortOn           - The field used to sort the results.
 * @param   params.filterOn         - Filters to apply to the inspection results.
 * @param   params.includeSubGroups - Whether to include subgroups in the results. Defaults to false.
 * @returns                         - A promise resolving to an object containing:
 *                                     - `inspectionResults`: An array of inspection result objects.
 *                                     - `totalCount`: The total number of results.
 *                                     - `links`: Pagination-related links.
 */
export const loadInspectionResults = async({
  sortOn = 'formName asc',
  accountId,
  pageId = 1,
  pageSize = 20,
  searchTerms = {},
  includeSubGroups = false
}: LoadInspectionResultsParams): Promise<any> => {
  try {
    const endpoint      = url('/api/inspection/results/search', Service.Base);
    const response: any = await client.post(endpoint, JSON.stringify({
      search : {
        searchTerms : {
          ...searchTerms,
          accountId
        }
      },
      sort               : sortOn,
      pgsize             : pageSize,
      pg                 : pageId,
      includeSubAccounts : includeSubGroups
    }));
    const {results, totalCount} = response?.data?.response || {};
    return {
      inspectionResults : results?.map(({inspectionResult}) => inspectionResult),
      totalCount,
      results
    };
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 * Loads list of vehicles based on the provided parameters. This function
 * retrieves a paginated list vehicles based on the given parameters.
 *
 * ```typescript
 *  import {loadInspectionVehicles} from '@ion/core/src/services/Connect';
 *  ...
 *
 * const getVehicles = async (): Promise<Vehicle[]> => {
 *   try {
 *     const response = await loadInspectionVehicles({
 *       accountId: 12345,
 *       pageId: 2,
 *       pageSize: 100
 *     });
 *     return response?.results;
 *    } catch (err) {
 *     ...
 *   }
 * };
 * ```
 *
 * @param accountId The ID of the account for which to load inspection results.
 * @param pageId    The page number for pagination. Defaults to 1.
 * @param pageSize  The number of results per page. Defaults to 20
 */
export const loadInspectionVehicles = async({
  account,
  pageId = 1,
  pageSize = 20
}: LoadInspectionVehicleParams): Promise<any> => {
  const endpoint      = url('/api/inspection/vehicles/search', Service.Base);
  const response: any = await client.post(endpoint, JSON.stringify({
    search : {
      searchTerms : {
        account
      },
      hierLevel : 'ALL',
      pg        : pageId,
      pgsize    : pageSize
    }
  }));
  const {results, totalCount} = response?.data?.response;
  return {
    vehicles : results?.map(({asset}) => asset),
    totalCount,
    results
  };
};

/**
 * Loads inspection status options.
 *
 * ```typescript
 *
 * import {loadInspectionStatus} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const response =await loadInspectionStatus();
 *   console.log(response.results);
 * };
 *
 * ```
 *
 */
export const loadInspectionStatus = async(): Promise<any> => {
  const endpoint      = url('/api/inspection/verificationstatus', Service.Base);
  const response: any = await client.get(endpoint);
  const {results} = response?.data?.response;
  return results?.map(({verificationStatus}) => verificationStatus);
};

/**
 * Loads list of inspection forms based on the provided parameters. This function retrieves paginated
 * forms.
 *
 * ```typescript
 *
 * import {loadInspectionForm} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const response = await loadInspectionForm({
 *     accountId: 12345,
 *     pageId: 2,
 *     pageSize: 50
 *   });
 *   console.log(response.results);
 * };
 *
 * ```
 *
 * @param   params.accountId        - The ID of the account for which to load inspection results.
 * @param   params.pageId           - The page number for pagination. Defaults to 1.
 * @param   params.pageSize         - The number of results per page. Defaults to 20
 * @param   params.sortOn           - The field used to sort the results.
 */
export const loadInspectionForm = async({
  sortOn = 'formName ASC',
  accountId
}: LoadInspectionFormParams): Promise<any> => {
  const endpoint      = url('/api/inspection/forms/search', Service.Base);
  const response: any = await client.post(endpoint, JSON.stringify({
    search : {
      sort        : sortOn,
      searchTerms : {
        accountId
      }
    }
  }));
  const {results, totalCount} = response?.data?.response;
  return {
    forms : results?.map(({inspectionForm}) => inspectionForm),
    totalCount,
    results
  };
};

/**
 * Update the oem validation rule for a single oem parameter ID.
 *
 * ```typescript
 * import {updateValidationRule} from
 *
 * const result = await updateValidationRule(3);
 *
 * ```
 *
 * @param ruleId - the numeric oemParameter rule ID.
 * @returns      - a JSON object containing message data for the requested rule.
 */
export const updateValidationRule =  async({
  ruleId,
  updatedRule
}: LoadSaveValidationParams): Promise<LoadValidationRulesResult> => {
  const response = await client({
    url     : url(`/vehicleprofiles/validationrules/${ruleId}`, Service.VehicleServiceUrl),
    method  : 'PUT',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : {
      rule : JSON.stringify(updatedRule)
    }
  });

  return response;
};

/** Loads inspection setup templates based on the provided parameters. This
 * function retrieves paginated inspection setup templates results with
 * optional filters, sorting, and subgroup inclusion.
 *
 * ```typescript
 *
 * import {loadInspectionTemplates} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const results = await loadInspectionTemplates({
 *     accountId: 12345,
 *     pageId: 2,
 *     pageSize: 50,
 *     sortOn: 'inspectionDate',
 *     filterOn: { status: 'Pass' },
 *     includeSubGroups: true,
 *     includeAccountFilter: false,
 *   });
 *   console.log(results.templates);
 *
 * ```
 *
 * @param params.accountId            - The ID of the account for which to load inspection results.
 * @param params.pageId               - The page number for pagination. Defaults to 1.
 * @param params.pageSize             - The number of results per page. Defaults to 20.
 * @param params.sortOn               - The field to sort the results on.
 * @param params.filterOn             - Filters to apply to the inspection results.
 * @param params.includeSubGroups     - Whether to include subgroups in the results. Defaults to false.
 * @param params.includeAccountFilter - Whether to include account-level filters. Defaults to true.
 * @returns                           - A promise that resolves to an object containing inspection
 *                                      results, total count, and links.
 */
export const loadInspectionTemplates = async({
  sortOn,
  accountId,
  pageId = 1,
  pageSize = 20,
  searchTerms = {},
  includeSubGroups = false,
  includeAncestorAccounts = false
}: LoadInspectionTemplatesParams): Promise<any> => {
  try {
    const uri =  url(ServiceURL.GetTemplates, Service.Base);
    const response: any = await client.post(uri, JSON.stringify({
      search : {
        searchTerms : {
          accountId,
          ...searchTerms
        },
        ...(includeSubGroups ? {hierLevel: 'ALL'} : {})
      },
      sort   : sortOn,
      pgsize : pageSize,
      pg     : pageId,
      ...(includeAncestorAccounts ? {includeAncestorAccounts: true} : {})
    }));
    const {results, totalCount, _links} = response?.data?.response;
    return {
      templates : results?.map(({inspectionTemplate}) => inspectionTemplate),
      totalCount,
      _links
    };
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 * Loads inspection setup template items based on the provided parameters. This
 * function retrieves paginated inspection setup template items results with
 * optional filters, sorting, and subgroup inclusion.
 *
 * ```typescript
 *
 * import {loadInspectionTemplateItems} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const results = await loadInspectionTemplateItems({
 *     accountId: 12345,
 *     pageId: 2,
 *     pageSize: 50,
 *     sortOn: 'inspectionDate',
 *     filterOn: { status: 'Pass' },
 *     includeSubGroups: true,
 *     includeAccountFilter: false,
 *   });
 *   console.log(results.items);
 *
 * ```
 *
 * @param params.accountId            - The ID of the account for which to load inspection results.
 * @param params.pageId               - The page number for pagination. Defaults to 1.
 * @param params.pageSize             - The number of results per page. Defaults to 20.
 * @param params.sortOn               - The field to sort the results on.
 * @param params.filterOn             - Filters to apply to the inspection results.
 * @param params.includeSubGroups     - Whether to include subgroups in the results. Defaults to false.
 * @param params.includeAccountFilter - Whether to include account-level filters. Defaults to true.
 * @returns                           - A promise that resolves to an object containing inspection
 *                                      results, total count, and links.
 */
export const loadInspectionTemplateItems = async({
  sortOn,
  accountId,
  pageId = 1,
  pageSize = 20,
  searchTerms = {},
  includeSubGroups = false,
  includeAncestorAccounts = false
}: LoadInspectionTemplatesParams): Promise<any> => {
  try {
    const uri =  url(ServiceURL.GetTemplateItems, Service.Base);
    const response: any = await client.post(uri, JSON.stringify({
      search : {
        searchTerms : {
          accountId,
          ...searchTerms
        },
        ...(includeSubGroups ? {hierLevel: 'ALL'} : {})
      },
      sort   : sortOn,
      pgsize : pageSize,
      pg     : pageId,
      ...(includeAncestorAccounts ? {includeAncestorAccounts: true} : {})
    }));
    const {results, totalCount, _links} = response?.data?.response;
    return {
      items : results?.map(({inspectionItem}) => inspectionItem),
      totalCount,
      _links
    };
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 * Loads inspection setup template groups based on the provided parameters. This
 * function retrieves paginated inspection setup template groups results with
 * optional filters, sorting, and subgroup inclusion.
 *
 * ```typescript
 *
 * import {loadInspectionTemplateGroups} from '@ion/core/src/services/Connect';
 *
 * const fetchResults = async () => {
 *   const results = await loadInspectionTemplateGroups({
 *     accountId: 12345,
 *     pageId: 2,
 *     pageSize: 50,
 *     sortOn: 'inspectionDate',
 *     filterOn: { status: 'Pass' },
 *     includeSubGroups: true,
 *     includeAccountFilter: false,
 *   });
 *   console.log(results.groups);
 *
 * ```
 *
 * @param params.accountId            - The ID of the account for which to load inspection results.
 * @param params.pageId               - The page number for pagination. Defaults to 1.
 * @param params.pageSize             - The number of results per page. Defaults to 20.
 * @param params.sortOn               - The field to sort the results on.
 * @param params.filterOn             - Filters to apply to the inspection results.
 * @param params.includeSubGroups     - Whether to include subgroups in the results. Defaults to false.
 * @param params.includeAccountFilter - Whether to include account-level filters. Defaults to true.
 * @returns                           - A promise that resolves to an object containing inspection
 *                                      results, total count, and links.
 */
export const loadInspectionTemplateGroups = async({
  sortOn,
  accountId,
  pageId = 1,
  pageSize = 20,
  searchTerms = {},
  includeSubGroups = false,
  includeAncestorAccounts = false
}: LoadInspectionTemplatesParams): Promise<any> => {
  try {
    const uri =  url(ServiceURL.GetTemplateGroups, Service.Base);
    const response: any = await client.post(uri, JSON.stringify({
      search : {
        searchTerms : {
          accountId,
          ...searchTerms
        },
        ...(includeSubGroups ? {hierLevel: 'ALL'} : {})
      },
      sort   : sortOn,
      pgsize : pageSize,
      pg     : pageId,
      ...(includeAncestorAccounts ? {includeAncestorAccounts: true} : {})
    }));
    const {results, totalCount, _links} = response?.data?.response;
    return {
      groups : results?.map(({inspectionGroup}) => inspectionGroup),
      totalCount,
      _links
    };
  } catch (err) {
    const {errors} = err?.response?.data?.response || {};
    return errors;
  }
};

/**
 * Retrieves a specific inspection result based on the provided account ID and
 * inspection ID. Fetches detailed inspection data for a particular entry.
 *
 * ```typescript
 *
 * import {getInspectionsResult} from '@ion/core/src/services/Connect';
 *
 * const fetchInspection = async () => {
 *   const inspectionResult = await getInspectionsResult(12345, 67890);
 *   console.log(inspectionResult);
 * };
 *
 * ```
 * @param  accountId - The ID of the account to which the inspection belongs.
 * @param  id        - The unique identifier of the inspection result to retrieve.
 * @returns          - A promise resolving to the inspection result details.
 */
export const getInspectionsResult = async(accountId: number, id: number) => (
  await client.get(url(`/api/inspection/results/${accountId}/${id}`, Service.Base))
);

/**
 * Updates an inspection result with the provided details. This function sends
 * a POST request to update the specified inspection data in the system.
 *
 * ```typescript
 *
 * import {updateInspectionResult} from '@ion/core/src/services/Connect';
 *
 * const updateResult = async () => {
 *   const resultDetails = {
 *     inspectionId: 67890,
 *     accountId: 12345,
 *     status: 'Completed',
 *     comments: 'Inspection completed successfully.',
 *   };
 *   const response = await updateInspectionResult(resultDetails);
 *   console.log(response);
 * };
 *
 * ```
 * @param  resultDetails - An object containing the details of the inspection
 *                         result to update. Must include `inspectionId` and
 *                         `accountId` along with other relevant properties.
 * @returns              - A promise resolving to the server's response after
 *                         updating the inspection result.
 */
export const updateInspectionResult = async(payload: GenericObject) => (
  await client.put(url('/api/inspection/results/update', Service.Base), JSON.stringify(payload))
);

/**
 * Creates a new inspection template with the provided details. This function
 * sends a POST request to store the template data in the system.
 *
 * ```typescript
 * import {createInspectionsTemplate} from '@ion/core/src/services/Connect';
 *
 * const createTemplate = async () => {
 *   const itemDetails = {
 *     name: 'Routine Check',
 *     description: 'Monthly inspection routine',
 *     criteria: ['Safety', 'Compliance'],
 *   };
 *   const response = await createInspectionsTemplate(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing details for the new inspection template.
 * @returns        - A promise resolving to the server's response after
 *                   creating the inspection template.
 */
export const createInspectionsTemplate = async(payload: GenericObject) => (
  await client.post(url('/api/inspection/templates/create', Service.Base), JSON.stringify(payload))
);

/**
 * Updates an existing inspection template with new details. This function
 * sends a PUT request to modify the specified template in the system.
 *
 * ```typescript
 * import {editInspectionsTemplate} from '@ion/core/src/services/Connect';
 *
 * const updateTemplate = async () => {
 *   const itemDetails = {
 *     templateId: 12345,
 *     name: 'Updated Routine Check',
 *     description: 'Updated monthly inspection routine',
 *   };
 *   const response = await editInspectionsTemplate(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing updated details for the inspection template.
 * @returns        - A promise resolving to the server's response after
 *                   updating the inspection template.
 */
export const editInspectionsTemplate = async(payload: GenericObject) => (
  await client.put(url('/api/inspection/templates/update', Service.Base), JSON.stringify(payload))
);

/**
 * Deletes an inspection template based on the provided details. This function
 * sends a DELETE request to remove the specified template from the system.
 *
 * ```typescript
 * import {deleteInspectionsTemplate} from '@ion/core/src/services/Connect';
 *
 * const removeTemplate = async () => {
 *   const itemDetails = {
 *     templateId: 12345,
 *   };
 *   const response = await deleteInspectionsTemplate(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing the details of the inspection template to delete.
 * @returns        - A promise resolving to the server's response after
 *                   deleting the inspection template.
 */
export const deleteInspectionsTemplate = async(payload: GenericObject) => (
  await client.delete(url('/api/inspection/templates/delete', Service.Base), {
    data : JSON.stringify(payload)
  })
);

/**
 * Publishes an inspection template based on the provided details. This function
 * sends a POST request to make the specified template available for use.
 *
 * ```typescript
 *
 * import {publishInspectionsTemplate} from '@ion/core/src/services/Connect';
 *
 * const publishTemplate = async () => {
 *   const itemDetails = {
 *     templateId: 12345,
 *   };
 *   const response = await publishInspectionsTemplate(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing the details of the inspection template to publish.
 * @returns        - A promise resolving to the server's response after
 *                   publishing the inspection template.
 */
export const publishInspectionsTemplate = async(payload: GenericObject) => (
  await client.post(url('/api/inspection/templates/publish', Service.Base), JSON.stringify({
    request : {...payload}
  }))
);

/**
 * Creates a new inspection item with the provided details. This function
 * sends a POST request to store the item data in the system.
 *
 * ```typescript
 * import {createInspectionsItem} from '@ion/core/src/services/Connect';
 *
 * const createItem = async () => {
 *   const itemDetails = {
 *     name: 'Routine Check',
 *     description: 'Monthly inspection routine',
 *     criteria: ['Safety', 'Compliance'],
 *   };
 *   const response = await createInspectionsItem(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing details for the new inspection item.
 * @returns        - A promise resolving to the server's response after
 *                   creating the inspection item.
 */
export const createInspectionsItem = async(payload: GenericObject) => (
  await client.post(url('/api/inspection/items/create', Service.Base), JSON.stringify(payload))
);

/**
 * Updates an existing inspection item with new details. This function
 * sends a PUT request to modify the specified item in the system.
 *
 * ```typescript
 * import {editInspectionsItem} from '@ion/core/src/services/Connect';
 *
 * const updateItem = async () => {
 *   const itemDetails = {
 *     id: 12345,
 *     name: 'Updated Routine Check',
 *     description: 'Updated monthly inspection routine',
 *   };
 *   const response = await editInspectionsItem(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing updated details for the inspection item.
 * @returns        - A promise resolving to the server's response after
 *                   updating the inspection item.
 */
export const editInspectionsItem = async(payload: GenericObject) => (
  await client.put(url('/api/inspection/items/update', Service.Base), JSON.stringify(payload))
);

/**
 * Deletes an inspection item based on the provided details. This function
 * sends a DELETE request to remove the specified item from the system.
 *
 * ```typescript
 * import {deleteInspectionsItem} from '@ion/core/src/services/Connect';
 *
 * const removeItem = async () => {
 *   const itemDetails = {
 *     itemId: 12345,
 *   };
 *   const response = await deleteInspectionsItem(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing the details of the inspection item to delete.
 * @returns        - A promise resolving to the server's response after
 *                   deleting the inspection item.
 */
export const deleteInspectionsItem = async(payload: GenericObject) => (
  await client.delete(url('/api/inspection/items/delete', Service.Base), {
    data    : JSON.stringify(payload),
    headers : {
      ...config.headers
    }
  })
);

/**
 * Creates a new inspection group with the provided details. This function
 * sends a POST request to store the group data in the system.
 *
 * ```typescript
 * import {createInspectionsGroup} from '@ion/core/src/services/Connect';
 *
 * const createGroup = async () => {
 *   const groupDetails = {
 *     name: 'Routine Check',
 *     description: 'Monthly inspection routine',
 *     criteria: ['Safety', 'Compliance'],
 *   };
 *   const response = await createInspectionsGroup(groupDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing details for the new inspection group.
 * @returns        - A promise resolving to the server's response after
 *                   creating the inspection group.
 */
export const createInspectionsGroup = async(payload: GenericObject) => (
  await client.post(url('/api/inspection/groups/create', Service.Base), JSON.stringify(payload))
);

/**
 * Updates an existing inspection item with new details. This function
 * sends a PUT request to modify the specified group in the system.
 *
 * ```typescript
 * import {editInspectionsGroup} from '@ion/core/src/services/Connect';
 *
 * const updateGroup = async () => {
 *   const groupsDetails = {
 *     id: 12345,
 *     name: 'Updated Routine Check',
 *     description: 'Updated monthly inspection routine',
 *   };
 *   const response = await editInspectionsGroup(groupDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing updated details for the inspection group.
 * @returns        - A promise resolving to the server's response after
 *                   updating the inspection group.
 */
export const editInspectionsGroup = async(payload: GenericObject) => (
  await client.put(url('/api/inspection/groups/update', Service.Base), JSON.stringify(payload))
);

/**
 * Deletes an inspection item based on the provided details. This function
 * sends a DELETE request to remove the specified group from the system.
 *
 * ```typescript
 * import {deleteInspectionsGroup} from '@ion/core/src/services/Connect';
 *
 * const removeItem = async () => {
 *   const itemDetails = {
 *     itemId: 12345,
 *   };
 *   const response = await deleteInspectionsGroup(itemDetails);
 *   console.log(response);
 * };
 * ```
 * @param  payload - An object containing the details of the inspection group to delete.
 * @returns        - A promise resolving to the server's response after
 *                   deleting the inspection group.
 */
export const deleteInspectionsGroup = async(payload: GenericObject) => (
  await client.delete(url('/api/inspection/groups/delete', Service.Base), {
    data    : JSON.stringify(payload),
    headers : {
      ...config.headers
    }
  })
);

/**
 * Retrieves inspection template forms based on the provided account and template IDs.
 * This function sends a GET request to fetch the forms associated with the given
 * inspection template.
 *
 * ```typescript
 * import {getInspectionsTemplateForms} from '@ion/core/src/services/Connect';
 *
 * const fetchForms = async() => {
 *   const accountId  = 123;
 *   const templateId = 456;
 *   const response = await getInspectionsTemplateForms(accountId, templateId);
 *   console.log(response);
 * };
 * ```
 *
 * @param accountId  - The unique identifier of the account.
 * @param templateId - The unique identifier of the inspection template.
 * @returns          - A promise resolving to an object containing:
 *   - `forms`: An array of inspection forms extracted from the response.
 *   - `totalCount`: The total number of forms available.
 *   - `_links`: API navigation links, if available.
 */
export const getInspectionsTemplateForms = async(accountId: number, templateId: number) => {
  const response = await client.get(url(`/api/inspection/forms/${accountId}/${templateId}`, Service.Base));
  const {results, totalCount, _links} = response?.data?.response;
  return {
    forms : results?.map(({inspectionForm}) => inspectionForm),
    totalCount,
    _links
  };
};

/**
 * Fetches the list of available inspection item types. This function sends
 * a GET request to retrieve item types used in inspections.
 *
 * ```typescript
 * import {getInspectionsItemTypes} from '@ion/core/src/services/Connect';
 *
 * const fetchItemTypes = async() => {
 *   const response = await getInspectionsItemTypes();
 *   console.log(response);
 * };
 * ```
 *
 * @returns - A promise resolving to the server's response containing the list
 *            of inspection item types.
 */
export const getInspectionsItemTypes = async() => (
  await client.get(url('/api/inspection/items/types', Service.Base))
);

/**
 * Updates the verification status of an inspection result with the provided details.
 * This function sends a PUT request to update the verification status of the specified
 * inspection result in the system.
 *
 * ```typescript
 *
 * import {updateResultVerification} from '@ion/core/src/services/Connect';
 *
 * const updateVerification = async () => {
 *   const verificationId = 67890;
 *   const verificationDetails = {
 *     status     : 'VERIFIED',
 *     verifiedBy : 'Inspector A'
 *   };
 *   const response = await updateResultVerification(verificationId, verificationDetails);
 *   console.log(response);
 * };
 *
 * ```
 * @param  id      - The ID of the inspection result whose verification status
 *                   needs to be updated.
 * @param  payload - An object containing the details of the verification status
 *                   update. This can include properties like `status`, `verifiedBy`,
 *                   and `timestamp`.
 * @returns        - A promise resolving to the server's response after updating
 *                   the verification status.
 */
export const updateResultVerification = async(id: number, payload: GenericObject) => (
  await client.put(url(`/api/inspection/results/${id}/verificationstatus`, Service.Base), JSON.stringify(payload))
);

/**
 * Uploads an inspection image to the system and updates the inspection result if required.
 * This function first requests an S3 pre-signed URL for the upload, then uploads the image,
 * and finally updates the inspection result if a `getResult` function is provided.
 *
 * ```typescript
 * import {uploadInspectionImage} from '@ion/core/src/services/Connect';
 *
 * const uploadImage = async () => {
 *   const file = new File(['image data'], 'inspection.jpg', {type: 'image/jpeg'});
 *   const response = await uploadInspectionImage({
 *     file,
 *     accountId : 12345,
 *     assetId   : 67890,
 *     getResult : (id) => ({ contentId: id })
 *   });
 *   console.log(response);
 * };
 * ```
 *
 * @param  file         - The file object to be uploaded.
 * @param  accountId    - The ID of the account associated with the image.
 * @param  assetId      - The ID of the asset associated with the image.
 * @param  getResult    - A function that generates the inspection result update payload.
 * @param  contentName  - The name of the content being uploaded.
 * @param  contentId    - The existing content ID if updating an existing image.
 * @param  assetType    - The type of asset (default is 'ASSET').
 * @param  uploadStatus - The status of the upload (default is 'SUCCESS').
 * @returns            - A promise resolving to the updated inspection result or `null`.
 */
export const uploadInspectionImage = async({
  file,
  accountId,
  assetId,
  getResult,
  contentName,
  contentId,
  assetType = 'ASSET',
  uploadStatus = 'SUCCESS'
}: UploadInspectionImageParams) => {
  const [s3Response] = await Promise.all([
    client.post(url('/api/inspection/attachment/upload', Service.Base), {
      accountId,
      assetId,
      assetType,
      contentName,
      uploadStatus
    }),
    contentId ? deleteInspectionImage({id: contentId}) : Promise.resolve(null)
  ]);

  const {attachmentContentId, attachmentUrl} = s3Response.data.response.results[0].content;

  const [_, updatedItem] = await Promise.all([client({
    method          : 'PUT',
    withCredentials : false,
    url             : attachmentUrl,
    data            : file,
    headers         : {
      'Content-Type' : file.type
    }
  }), getResult ? updateInspectionResult(getResult(
    attachmentContentId
  )) : Promise.resolve(null)]);
  return getResult ? updatedItem : attachmentContentId;
};

/**
 * Deletes an inspection image from the system and optionally updates the inspection result.
 * This function sends a DELETE request to remove the image and updates the inspection
 * result if a `getResult` function is provided.
 *
 * ```typescript
 * import {deleteInspectionImage} from '@ion/core/src/services/Connect';
 *
 * const deleteImage = async () => {
 *   const response = await deleteInspectionImage({
 *     id       : 'attachment-id',
 *     getResult: (id) => ({ contentId: id })
 *   });
 *   console.log(response);
 * };
 * ```
 *
 * @param  id       - The ID of the attachment content to be deleted.
 * @param  getResult - A function that generates the inspection result update payload.
 * @returns         - A promise resolving to the updated inspection result or `null`.
 */
export const deleteInspectionImage = async({id, getResult}: DeleteInspectionImageParams) => {
  await Promise.allSettled([client.delete(url('/api/inspection/attachment/delete', Service.Base), {
    data : JSON.stringify({attachmentContentId: id})
  })]);
  if (getResult) {
    return await updateInspectionResult(getResult(null));
  }
};

/**
 * Retrieves the URL of an inspection image for viewing.
 * This function sends a POST request to fetch the image details for a given attachment ID.
 *
 * ```typescript
 * import {viewInspectionImage} from '@ion/core/src/services/Connect';
 *
 * const viewImage = async () => {
 *   const response = await viewInspectionImage({
 *     id        : 'attachment-id',
 *     accountId : 12345
 *   });
 *   console.log(response);
 * };
 * ```
 *
 * @param  id        - The ID of the attachment content to be viewed.
 * @param  accountId - The account ID associated with the attachment.
 * @returns         - A promise resolving to the server's response containing the image URL.
 */
export const viewInspectionImage = async({id, accountId}: ViewInspectionImageParams) => (
  await client.post(url('/api/inspection/attachment/view', Service.Base), {
    attachmentContentId : id,
    accountId           : accountId.toString()
  })
);

/*
 * Validate the oem validation rule for a single oem parameter ID.
 *
 * ```typescript
 * import {validateOemValidationRule} from
 *
 * const result = await validateOemValidationRule(3);
 *
 * ```
 *
 * @param ruleId - the numeric oemParameter rule ID.
 * @returns      - a JSON object containing message data for the requested rule.
 */
export const validateOemValidationRule =  async({
  ruleId,
  modifiedRule
}: LoadOEMValidateParams): Promise<LoadOEMValidationResult> => {
  const response = await client({
    url     : url(`/vehicleprofiles/validationrules/${ruleId}/validate`, Service.VehicleServiceUrl),
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : {
      validationRule : JSON.stringify(modifiedRule)
    }
  });

  return response;
};

/**
 * Retrieves smart sensor data for a specified asset and mobile device.
 *
 * This function queries sensor event data based on the provided account, asset,
 * and mobile device identifiers. It allows filtering by sensor type and message time.
 *
 * ```typescript
 * import {getSmartSensorData} from '@ion/core/src/services/Connect';
 *
 * const sensorData = await getSmartSensorData({
 *   accountId: 5099,
 *   mobileId: '6002001127',
 *   mobileIdType: 'ESN',
 *   assetId: 123456,
 *   sensorType: 'TPMS','WETS',
 *   messageTime: '[2025-02-19T00:00:00.000Z TO 2025-02-20T23:59:59.999Z]'
 * });
 *
 * ```
 *
 * @param accountId    - The account ID associated with the sensor data request.
 * @param mobileId     - The mobile ID of the device (e.g., ESN, IMEI).
 * @param mobileIdType - The type of mobile ID (default: 'ESN').
 * @param assetId      - The asset ID linked to the sensor data.
 * @param sensorType   - The type of sensor data to retrieve (default: 'TPMS').
 * @param messageTime  - A time range filter for the sensor events.
 *
 * @returns {Promise<{ sensorData: Object[], totalCount: number }>}
 *          A promise resolving to the retrieved sensor data and total record count.
 */
export const getSmartSensorData = async({
  accountId,
  mobileId,
  mobileIdType = 'ESN',
  assetId,
  sensorType = 'TPMS',
  messageTime
}) => {
  const requestBody = {
    search : {
      maxResults  : 100,
      sort        : ['-messageTime'],
      searchTerms : {
        accountId    : accountId.toString(),
        mobileIdType : mobileIdType,
        mobileId     : mobileId,
        assetId      : assetId,
        sensorType   : sensorType,
        messageTime  : messageTime
      }
    }
  };
  const response = await client.post(
    url('/api/sensor/events/search', Service.Base),
    requestBody
  );
  const {results, totalCount} = response?.data?.response;
  return {
    sensorData : results,
    totalCount
  };
};

/**
 * Fetches the latest AVL (Automatic Vehicle Location) events for a given device.
 *
 * This function retrieves the most recent AVL events for a specified device ID or ESN.
 * It allows filtering by the number of events, pagination, and version control.
 *
 * ```typescript
 * import {getLatestAvlEvents} from '@ion/core/src/services/Connect';
 *
 * const latestAvlEvents = await getLatestAvlEvents({
 *   id: '6002001127',
 *   idType: 'ESN',
 *   numEvents: 2,
 *   pg: 1,
 *   pgSize: 10
 * });
 *
 * ```
 *
 * @param id        - The unique identifier of the device (ESN or deviceId).
 * @param idType    - The type of identifier ('ESN' or 'deviceId'). Defaults to
 *                    'ESN'.
 * @param numEvents - The number of AVL events to retrieve. Defaults to 1.
 * @param pg        - The page number for pagination. Defaults to 1.
 * @param pgSize    - The number of records per page. Defaults to 1.
 *
 * @returns {Promise<Object>} A promise resolving to the latest AVL event data.
 */
export const getLatestAvlEvents = async({
  id,
  idType = 'ESN',
  numEvents = 1,
  pg = 1,
  pgSize = 1
}) => {
  const result = await client.get(
    url(`/connect/results/events/device/${id}/avl/latest?idType=${idType}&numEvents=${numEvents}&v=2.1&pg=${pg}&pgsize=${pgSize}`,
      Service.Base)
  );
  return result?.data?.response;
};

/**
 * Queues the Bulk TPMS Sensor Assignment for an Asset and Device.
 *
 * This allows bulk assignment of TPMS sensors to an asset and its associated devices.
 * It accepts an object containing an account ID, a task nickname, and an array of sensor association details.
 *
 * ```typescript
 * import {queueBulkTpmsSensorsAssignment} from '@ion/core/src/services/Connect';
 *
 * const result = await queueBulkTpmsSensorsAssignment({
 *   accountId: 5099,
 *   taskNickName: 'Queue Sensor Pairing for Asset ID 867309 - Device ID 90210',
 *   sensorAssociationDetails: [
 *     {
 *       assetId: 12234,
 *       assetType: 'Trailer',
 *       tires: [
 *         {
 *           deviceId: 14534,
 *           position: 'T1',
 *           sensorType: 'TPMS',
 *           sensorId: '2132CA'
 *         },
 *         {
 *           deviceId: 4534,
 *           position: 'T2',
 *           sensorType: 'TPMS',
 *           sensorId: '2B32CA'
 *         },
 *         {
 *           deviceId: 4534,
 *           position: 'T3',
 *           sensorType: 'TPMS',
 *           sensorId: '2A32CA'
 *         }
 *       ]
 *     }
 *   ]
 * });
 * ```
 *
 * @param accountId                - The account ID associated with the request.
 * @param taskNickName             - A descriptive name for the bulk assignment
 *                                   task.
 * @param sensorAssociationDetails - A list of sensor assignments.
 *
 * @returns {Promise<Object>} A promise resolving to the result of the bulk
 *                            assignment operation.
 */
export const queueBulkTpmsSensorsAssignment = async({
  accountId,
  taskNickName,
  sensorAssociationDetails
}: BulkTpmsSensorPairingRequest): Promise<BulkTpmsSensorPairingResponse> => {
  const uri = '/api/entities/bulk-operations/sensors/install';
  const endpoint = url(uri, Service.Base);
  const payload = {
    accountId,
    taskNickName,
    sensorAssociationDetails
  };
  const results  = await client.post(endpoint, JSON.stringify(payload));
  return results?.data.response;
};

/*
 * Fetch Vehicle Info By the given VIN
 *
 * ```typescript
 * import {getVehicleInfoByVin} from '@ion/core/src/services/Connect';
 *
 * const result = await getVehicleInfoByVin(1234567890);
 *
 * ```
 *
 * @param vinValue - the numeric VIN value.
 * @returns      - a JSON object containing message data for the requested rule.
 */
export const getVehicleInfoByVin = async(vinValue) => {
  const response = await client({
    url     : url(`/vehicleInfo/ByVin?vin=${vinValue}&debug=true`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/*
 * With the given YMMEF data, retrieve vehicle match object
 *
 * ```typescript
 * import {getVehicleProfileMatch} from '@ion/core/src/services/Connect';
 *
 * const result = await getVehicleProfileMatch(ymmefData);
 *
 * ```
 *
 * @param ymmefData - a JSNO object with
 *      Year, Make, Model, Engine, FuelType data
 * @returns      - a JSON object containing message data for the requested rule.
 */
export const getVehicleProfileMatch = async(ymmefData: VehicleMatchParams) => {
  const response = await client({
    url     : url('/vehicleprofiles/profiles/vehiclematch?v=2', Service.VehicleServiceUrl),
    method  : 'POST',
    data    : JSON.stringify(ymmefData),
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/*
 * Vehicle Info Enum Table helps in retrieving
 * Year, Make, Model, Engine, FuleTypes from respective API's
 * on adding / creating a new Vehicle Profile
 *
 * ```typescript
 * import {getVehicleInfoEnumTable} from '@ion/core/src/services/Connect';
 *
 * const result = await getVehicleInfoEnumTable();
 *
 * ```
 *
 * @param makes     - an Array of JSON objects
 * @param models    - an Array of JSON objects
 * @param engines   - an Array of JSON objects
 * @param fueltypes - an Array of JSON objects
 * @returns         - an Array of JSON object containing data for the requested rule.
 */
export const getVehicleInfoEnumTable = async(appKey?: string) => {
  const urls = [
    vehicleProfileEnumURL('makes'),
    vehicleProfileEnumURL('models'),
    vehicleProfileEnumURL('engines'),
    vehicleProfileEnumURL('fueltypes')
  ];

  const options = {
    headers : {
      Authorization         : `Bearer ${getSessionToken()}`,
      'calamp-services-app' : resolveAppKey(appKey)
    },
    method : 'GET'
  };

  const fetchJson = url => fetch(url, options).then(res => res.json());

  return Promise.all(urls.map(fetchJson)).then(res => res);
};

/*
 * Retrieves a single Vehicle Info enum table, for callers which need one of them
 * rather than all four. A response which is not ok, or whose body is not a list, is
 * raised as an error rather than handed back as data.
 *
 * ```typescript
 * import {getVehicleInfoEnumTableByName} from '@ion/core/src/services/Connect';
 *
 * const makes = await getVehicleInfoEnumTableByName('makes');
 *
 * ```
 *
 * @param table  - the enum table to read, such as `makes` or `models`.
 * @param appKey - the application the table is read for.
 * @returns      - an Array of JSON objects holding the requested table.
 */
export const getVehicleInfoEnumTableByName = async(table: string, appKey?: string) => {
  const response = await fetch(vehicleProfileEnumURL(table), {
    headers : {
      Authorization         : `Bearer ${getSessionToken()}`,
      'calamp-services-app' : resolveAppKey(appKey)
    },
    method : 'GET'
  });

  if (!response.ok) {
    throw new Error(`Failed to load the ${table} vehicle info enum table: ${response.status}`);
  }

  const rows = await response.json();

  if (!Array.isArray(rows)) {
    throw new Error(`The ${table} vehicle info enum table did not answer with a list`);
  }

  return rows;
};

/**
 * Associates existing bus profiles (PIDs) with a vehicle profile.
 *
 * @param data - {
 *   year: number;
 *   make: number;
 *   model: number;
 *   engine?: number;
 *   fuel?: number;
 *   profileIds: number[];
 * }
 *
 * @returns Promise resolving to server response with queryTime,
 *          totalCount, errors, and results (success/failure).
 */
export const addExistingPid = async(data: AddExistingPidRequest) => {
  const response = await client({
    url     : url('/vehicleprofiles/profiles/associate?v=2', Service.VehicleServiceUrl),
    method  : 'POST',
    data    : JSON.stringify(data),
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response;
};

/**
 * Creates a new vehicle profile with the provided details. This function
 * sends a POST request to store the group data in the system.
 *
 * ```typescript
 * import {createVehicleProfile} from '@ion/core/src/services/Connect';
 *
 * ```
 * @param  payload - An object containing details for the new vehicle profile.
 * @returns        - A promise resolving to the server's response after
 *                   creating the vehicle profile.
 */
export const createVehicleProfile = async(data) => {
  const response = await client({
    url     : url('/vehicleprofiles/profiles?v=2', Service.VehicleServiceUrl),
    method  : 'POST',
    data    : JSON.stringify(data),
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Updates a vehicle profile with the provided details. This function
 * sends a request with the updated data to store in the system.
 *
 * ```typescript
 * import {updateVehicleProfile} from '@ion/core/src/services/Connect';
 *
 * ```
 * @param  payload - An object containing details for the existing vehicle profile.
 * @returns        - A promise resolving to the server's response after
 *                   updating the vehicle profile.
 */
export const updateVehicleProfile = async(updatedProfile) => {
  const response = await client({
    url     : url(`/vehicleprofiles/profiles/${updatedProfile?.busProfileId}?v=2`, Service.VehicleServiceUrl),
    method  : 'PUT',
    data    : {profile: updatedProfile},
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Deletes a vehicle profile with the provided profile ID. 
 *
 * ```typescript
 * import {deleteVehicleProfile} from '@ion/core/src/services/Connect';
 *
 * ```
 * @param queryParams - A profile ID to delete specific profile.
 * @returns        - A promise resolving to the server's response after
 *                   deleting a profile.
 */
export const deleteVehicleProfile = async(profileId) => {
  const response = await client({
    url     : url(`/vehicleprofiles/profiles/${profileId}`, Service.VehicleServiceUrl),
    method  : 'DELETE',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Fetches profile details for the given profileId
 *
 * ```typescript
 * import {getVehicleProfile} from '@ion/core/src/services/Connect';
 *
 * ```
 * @param  payload - An object containing details for the new vehicle profile.
 * @returns        - A promise resolving to the server's response after
 *                   creating the vehicle profile.
 */
export const getVehicleProfile = async(profileId) => {
  const response = await client({
    url     : url(`/vehicleprofiles/profiles/${profileId}?v=2`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response;
};

/**
 * Fetches metadata for a specific vehicle profile category (e.g., bustype, busspeed, etc.)
 *
 * @param entity - must be one of the values from VehicleProfileEntities
 */
export const getVehicleProfileMetadata = async(entity: VehicleProfileEntity) => {
  const response = await client({
    url     : url(`/vehicleprofiles/profiles/${entity}`, Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response;
};

/**
 * Remove association between a profile and PIDs
 *
 * @param data - Request payload containing vehicle info and profile IDs
 * 
 * @returns API response with disassociation results
 */
export const removeBusProfile = async(data: RemoveBusProfileRequest) => {
  const response = await client({
    url     : url('/vehicleprofiles/profiles/disassociate', Service.VehicleServiceUrl),
    method  : 'POST',
    data,
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response;
};

/**
 * Search for existing bus profiles (PIDs) in the busprofiletest table.
 *
 * POST /vehicleprofiles/busprofiles/search
 * 
 */
export const loadBusProfiles = async({
  sortOn,
  pageId = 1,
  pageSize = 20,
  searchTerms = {}
}: LoadBusProfilesParams): Promise<any> => {
  const uri  = url('/vehicleprofiles/busprofiles/search', Service.VehicleServiceUrl);
  const response = await client.post(uri, JSON.stringify({
    search : {
      sort   : sortOn || '+busProfileId',
      searchTerms,
      pgsize : pageSize,
      pg     : pageId
    }
  }),
  {
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  }
  );
  const {
    results = [],
    totalCount = 0
  } = response?.data?.response || {};
  return {
    items : results,
    totalCount
  };
};

/**
 * Provides a CTC Event Result Services which supports hierarchical support.
 *
 * ```typescript
 *
 *    import {loadSentinelInfo} from '@ion/core/src/services/Connect';
 *
 *    const, {info, totalCount} = await loadSentinelInfo({
 *      deviceId : 321
 *    });
 *
 * ```
 *
 * @param   {number} deviceId The id of the device from which to retrieve Event History.
 * @returns Promise<LoadEventsResult>
 */
export const loadSentinelInfo = async({
  deviceId
}: LoadEventsParams): Promise<LoadEventsResult> => {
  const uri      = '/events/search?v=2.0';
  const endpoint = url(setHierLevel(uri, false), Service.Results);

  const response: LoadEventsResponse = await client.post(endpoint, JSON.stringify({
    search : {
      searchTerms : {
        deviceEsn : deviceId
      },
      maxResults : 999,
      hierLevel  : HierLevel.ALL
    }
  }));

  const {
    results,
    totalElements,
    _links
  } = response.data?.response;

  return {
    events     : results,
    totalCount : totalElements,
    _links
  };
};

/**
 * The loadCarrierPartNumbers function fetches all carrier part numbers within
 * the CTC Platform.
 *
 * ```typescript
 *
 *     import {loadCarrierPartNumbers} from '@ion/core/src/services/Connect';
 *
 *     const fetchPartNumbers = await loadCarrierPartNumbers();
 *
 * ```
 */
export const loadCarrierPartNumbers = async({
  carrierSku,
  carrierName,
  sortOn,
  pageSize,
  pageId = 1
}): Promise<any> => {
  const url = createManufacturingURL(`skumap/search?pg=${pageId}&pgsize=${pageSize}`);
  const searchTerms = {
    carrierSku,
    carrierName
  };
  const response = await client.post(url, safeJSONStringify({
    search : {
      searchTerms : {
        status : `${EntityStatus.Enabled}`,
        ...searchTerms
      },
      sort : sortOn
    }
  }));

  const {results, totalCount} = response.data?.response;
  return {
    skuMap : results?.map(({skuMap}) => skuMap),
    totalCount
  };
};

/**
 * Fetches carrier part number for the given part number id
 *
 * ```typescript
 * import {getCarrierPartNumber} from '@ion/core/src/services/Connect';
 *
 * ```
 * @param  payload - An object containing details for the new vehicle profile.
 * @returns        - A promise resolving to the server's response after
 *                   creating the vehicle profile.
 */
export const getCarrierPartNumber = async(partNumberId): Promise<CarrierPartNumber> => {
  const results = await client.get(createManufacturingURL(`skumap/${partNumberId}`));

  return parse(results, 'carrierPartNumber') as CarrierPartNumber;
};

/**
 * The createCarrierPartNumber function creates a carrier part number 
 * with the given 
 * calamp_sku,
 * carrier_sku &
 * carrier_name
 *
 * ```typescript
 *
 *     import {createCarrierPartNumber} from '@ion/core/src/services/Connect';
 *
 *     const created = await createCarrierPartNumber();
 *
 * ```
 */
export const createCarrierPartNumber = async(skuMap): Promise<CarrierPartNumber> => {
  const url = createManufacturingURL('skumap');
  const results = await client.post(url, safeJSONStringify(skuMap));

  return parse(results, 'skuMap') as CarrierPartNumber;
};

/**
 * The updateCarrierPartNumber function updates a carrier part number 
 * with the given 
 * calamp_sku,
 * carrier_sku &
 * carrier_name
 *
 * ```typescript
 *
 *     import {updateCarrierPartNumber} from '@ion/core/src/services/Connect';
 *
 *     const updated = await updateCarrierPartNumber();
 *
 * ```
 */
export const updateCarrierPartNumber = async(skuMap): Promise<CarrierPartNumber> => {
  const url = createManufacturingURL(`skumap/${skuMap.id}`);
  const results = await client.put(url, safeJSONStringify({skuMap}));

  return parse(results) as CarrierPartNumber;
};

/**
 * The deleteCarrierPartNumber function deletes a carrier part number 
 * with the given 
 * calamp_sku,
 * carrier_sku &
 * carrier_name
 *
 * ```typescript
 *
 *     import {deleteCarrierPartNumber} from '@ion/core/src/services/Connect';
 *
 *     const deleted = await deleteCarrierPartNumber();
 *
 * ```
 */
export const deleteCarrierPartNumber = async(partNumberId): Promise<CarrierPartNumber> => {
  const results = await client.delete(createManufacturingURL(`skumap/${partNumberId}`));

  return parse(results, 'carrierPartNumber') as CarrierPartNumber;
};

/**
 *
 * The getVehicleProfileCompatibility function fethes the s3DownloadUrl and
 * downloads the vehicle profile compatibility report.
 *
 * ```typescript
 *
 *     import {getVehicleProfileCompatibility} from '@ion/core/src/services/Connect';
 *
 *     return await getVehicleProfileCompatibility();
 *
 * ```
 */
export const getVehicleProfileCompatibility = async() => {
  const response = await client({
    url     : url('/vehicleprofiles/compatibilityreport', Service.VehicleServiceUrl),
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });

  return response?.data?.response?.results;
};

export const runVehicleValidation = async({vin, deviceIdentifier}) => {
  const response = await client({
    url  : url('/vehicleprofiles/profiles/validate', Service.VehicleServiceUrl),
    data : {
      vin,
      esn : deviceIdentifier
    },
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response?.data?.response?.results;
};

export const getEmissionTester = async(id: number): Promise<EmissionTester> => {
  const results = await client.get(url(`/carbs/v1/accounts/${id}/emission-tester`, Service.ApiBaseUrl));
  return results?.data as EmissionTester;
};

export const updateEmissionTester = async(params): Promise<EmissionTester> => {
  const {id: accountId, ...payload} = params?.[0] || {};
  const results = await client.put(url(`/carbs/v1/accounts/${accountId}/emission-tester`, Service.ApiBaseUrl), payload);
  return results?.data as EmissionTester;
};

export const createEmissionTester = async(params): Promise<EmissionTester> => {
  const accountId = params?.[0]?.id;
  delete params?.[0]?.id;
  const results = await client.post(url(`/carbs/v1/accounts/${accountId}/emission-tester`, Service.ApiBaseUrl), params?.[0]);
  return results?.data as EmissionTester;
};

export const importCarbData = async(params) => {
  try {
    const results = await client.post(url('/carb/entities/import', Service.ApiBaseUrl), params);
    return results;
  } catch (err) {
    return err;
  }
};

export const deleteEmissionTester = async({accountId}): Promise<EmissionTester> => {
  const results = await client.delete(url(`/carbs/v1/accounts/${accountId}/emission-tester`, Service.ApiBaseUrl));
  return results?.data as EmissionTester;
};

/**
 * Requests device session cleanup for the given ESN via the Scout offline mode
 * service endpoint.
 *
 * The clean session operation terminates active MQTT sessions, cancels pending
 * CAN requests, reinitializes MQTT session state, and queues any required
 * follow-up mode transition work for the device.
 *
 * ```typescript
 * import {runVehicleCleanSession} from '@ion/core/src/services/Connect';
 * ...
 *
 * await runVehicleCleanSession({
 *   deviceIdentifier : '3000202810'
 * });
 * ```
 *
 * @param   deviceIdentifier The device ESN for which session cleanup is to be
 *          requested.
 * @returns A Promise containing the clean session processor results payload.
 */
export const runVehicleCleanSession = async({deviceIdentifier}) => {
  const uri = '/ve-scout/clean/session';
  const response = await client({
    url     : url(uri, Service.PulsBaseUrl),
    data    : {esn: deviceIdentifier},
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response?.data?.response?.results;
};

/**
 * Requests that the given device check back in with the MQTT broker via the
 * Scout offline mode service's check-in scheduling endpoint.
 *
 * This action does not tear down or reinitialize any existing session state
 * — unlike a clean session, it simply asks a device that dropped its MQTT
 * connection (e.g. due to poor signal quality and an LWT disconnect) to
 * re-establish communication with the broker.
 *
 * ```typescript
 * import {runVehicleRequestCheckin} from '@ion/core/src/services/Connect';
 * ...
 *
 * await runVehicleRequestCheckin({
 *   deviceIdentifier : '3000202810'
 * });
 * ```
 *
 * @param   deviceIdentifier The device ESN to request a check-in for.
 * @returns A Promise containing the schedule check-in processor results
 *          payload.
 */
export const runVehicleRequestCheckin = async({deviceIdentifier}) => {
  const uri = '/ve-scout/schedule/checkin';
  const response = await client({
    url     : url(uri, Service.PulsBaseUrl),
    data    : {esn: deviceIdentifier},
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response?.data?.response?.results;
};

export const getAccountUsers = async(groupId) => {
  const url = `/accounts/${groupId}/users`;

  const usersResult = await client.get(url);

  return usersResult;
};

/**
 * The loadPeg2DeviceModels function fethes the list of supported device types
 *
 * ```typescript
 *
 *     import {loadPeg2DeviceModels} from '@ion/core/src/services/Connect';
 *
 *     return await loadPeg2DeviceModels();
 *
 * ```
 */
export const loadPeg2DeviceModels = async(): Promise<string[]> => {
  const response = await client.get(url('/peg2/deviceModel', Service.PulsBaseUrl));
  return parseCollection(response, 'name') ?? [];
};

/**
 * The loadPeg2VehicleTypes function fethes the  list of supported vehicle types.
 * 
 * ```typescript
 *
 *     import {loadPeg2VehicleTypes} from '@ion/core/src/services/Connect';
 *
 *     return await loadPeg2VehicleTypes();
 *
 * ```
 */
export const loadPeg2VehicleTypes = async(): Promise<string[]> => {
  const response = await client.get(url('/peg2/vehicleTypes', Service.PulsBaseUrl));
  return parseCollection(response, 'name') ?? [];
};

/**
 * The loadPeg2VehicleTypes function retrieving Module Profile definitions
 * for a given device type and vehicle type pair. 
 * 
 * The includeModules parameter will return the profile plus the supportedModule definitions
 * for each module. This will allow the UI to make one call to based on `deviceModel` and `vehicleType`,
 * and will be defined in the pegWizardsModules property.
 * 
 * The `uom` parameter will tell DM what units to return to the UI, and also that should be part
 * of script assembly so DM can convert the UI units to LMU units.
 */
export const loadPeg2ModuleProfile = async({
  deviceModel,
  vehicleType,
  uom,
  isAllResults = false
}: Peg2ModuleProfileParams): Promise<Peg2ModuleProfile | Peg2ModuleProfile[] | undefined> => {
  const response = await client.post(
    url(`/peg2/moduleprofiles/search?pg=1&pgsize=1&includeModules=true&uom=${uom}`, Service.PulsBaseUrl),
    JSON.stringify({
      search : {
        ...(!isAllResults && {maxResults: 1}),
        sort        : ['+deviceModel'],
        searchTerms : {
          ...(deviceModel && {deviceModel}),
          vehicleType
        }
      }
    })
  );
  if (isAllResults) {
    return parseCollection(response, 'moduleProfile') as Peg2ModuleProfile[] | undefined;
  }
  return parse(response, 'moduleProfile') as Peg2ModuleProfile | undefined;
};

/**
 * The checkScriptVersionTaken function is based on the existing `files/search` endpoint
 * to determine / validate the uniqueness of a given user provided version based on the
 * `filterOn` constraints: `name` set to the entered version string.
 * Matching against existing device file `names` and `validationMetaData`.
 * If totalCount is greater than zero, the version is already in use.
 */
export const checkScriptVersionTaken = async(
  version: string,
  accountId: number
): Promise<boolean> => {
  const result = await loadDeviceFiles({
    accountId,
    filterOn : {
      validationMetaData : `{\"fields\":{\"version\":\"${version}\"}}`
    }
  });
  return (result.totalCount ?? 0) > 0;
};

/**
 * Matching against existing device file `names`.
 * If totalCount is greater than zero, the name is already in use.
 */
export const checkScriptNameTaken = async(
  name: string,
  accountId: number
): Promise<boolean> => {
  const result = await loadDeviceFiles({
    accountId,
    filterOn : {name}
  });
  return (result.totalCount ?? 0) > 0;
};

/**
 * Metadata endpoint returns PEG Wizard files parameterValues in nested-object form,
 * flatten to the store's dot-notation-keyed scalar maps.
 */
export const getPegWizardMetadata = async(
  fileId: number,
  uom: DmUnit
): Promise<PegWizardMetadata> => {
  const response = await client.get(url(`/files/${fileId}?includePegWizard=${true}&uom=${uom}`, Service.PulsBaseUrl));
  const data            = response.data?.response?.results[0]?.filemeta || {};
  const selectedModules = data?.peg2Assembly?.moduleSelections || {};

  return {
    ...data,
    core         : fromNestedParameterValues(selectedModules.Core ?? {}),
    moduleValues : Object.fromEntries(
      Object.entries(selectedModules).map(function([name, values]) {
        return [name, fromNestedParameterValues(values)];
      })
    )
  } as PegWizardMetadata;
};

/**
 * @function assembleScript
 *
 * The assembleScript function assembles a new PEG Wizard script from the
 * given request, by issuing a POST request to
 * '/device-services/peg2/scripts/assemble'. The resulting assembly is not
 * yet published to a device file; see `publishScript`.
 *
 * ```typescript
 *  import {assembleScript} from '@ion/core/src/services/Connect';
 *  ...
 *
 *  const script = await assembleScript(request);
 * ```
 *
 * @param request the PEG Wizard values from which the script is to be
 *                assembled
 * @returns       the assembled `PegWizardScript`
 */
export const assembleScript = async(request: PegWizardAssemblyRequest): Promise<PegWizardScript> => {
  const response = await client.post(
    url('/peg2/scripts/assemble', Service.PulsBaseUrl),
    JSON.stringify({peg2Assembly: request})
  );
  return parse(response, 'peg2Assembly') as PegWizardScript;
};

/**
 * @function updateScript
 *
 * The updateScript function updates an existing PEG Wizard script assembly,
 * by issuing a PUT request to '/device-services/peg2/assemble/{id}' using
 * the `id` of the given request.
 *
 * ```typescript
 *  import {updateScript} from '@ion/core/src/services/Connect';
 *  ...
 *
 *  const script = await updateScript(request);
 * ```
 *
 * @param request the PEG Wizard values, including the `id` of the assembly
 *                to be updated
 * @returns       the updated `PegWizardScript`
 */
export const updateScript = async(request: PegWizardAssemblyRequest): Promise<PegWizardScript> => {
  const response = await client.put(
    url(`/peg2/assemble/${request.id}`, Service.PulsBaseUrl),
    JSON.stringify({peg2Assembly: request})
  );
  return parse(response, 'peg2Assembly') as PegWizardScript;
};

/**
 * @function publishScript
 *
 * The publishScript function publishes an assembled PEG Wizard script as a
 * device file, by issuing a POST request to '/device-services/files'. The
 * `scriptToken` is passed as the 'X-Wizard-Key' header to authorize the
 * publish against the script assembly from which the request was built.
 *
 * ```typescript
 *  import {publishScript} from '@ion/core/src/services/Connect';
 *  ...
 *
 *  const file = await publishScript(request, scriptToken);
 * ```
 *
 * @param request     the assembled script values from which the device
 *                    file is to be published
 * @param scriptToken the wizard key authorizing the publish
 * @returns           the newly published `DeviceFile`
 */
export const publishScript = async(
  request: PegWizardPublishRequest,
  scriptToken: string
): Promise<DeviceFile> => {
  const response = await client.post(
    url('/files', Service.PulsBaseUrl),
    JSON.stringify(request),
    {headers: {'X-Wizard-Key': scriptToken}}
  );
  return parse(response, 'filemeta') as DeviceFile;
};

/**
 * @function updatePublishedScript
 *
 * The updatePublishedScript function updates the file metadata of a PEG
 * Wizard script that has already been published, by issuing a PUT request
 * to '/device-services/files/{id}'. The `scriptToken` is passed as the
 * 'X-Wizard-Key' header to authorize the update against the script
 * assembly from which the file was originally published.
 *
 * ```typescript
 *  import {updatePublishedScript} from '@ion/core/src/services/Connect';
 *  ...
 *
 *  const file = await updatePublishedScript(request, scriptToken);
 * ```
 *
 * @param request     the device file fields to update on the published
 *                    script
 * @param scriptToken the wizard key authorizing the update
 * @returns           the updated `DeviceFile` metadata
 */
export const updatePublishedScript = async(
  request: MaintainDeviceFileRequest,
  scriptToken: string
): Promise<DeviceFile> => {
  const response = await client.put(
    url(`/files/${request.id}`, Service.PulsBaseUrl),
    JSON.stringify({filemeta: request}),
    {headers: {'X-Wizard-Key': scriptToken}}
  );
  return parse(response, 'filemeta') as DeviceFile;
};

/**
 * Searches Vehicle Discovery for the devices matching the supplied search terms,
 * returning one page of discovery records and the total number which matched.
 *
 * ```typescript
 *
 *   import {searchVehicleDiscovery} from '@ion/core/src/services/Connect';
 *   ...
 *
 *   const {records, totalCount} = await searchVehicleDiscovery({
 *     accountId : 8675309,
 *     status    : ['VBUS_ERROR'],
 *     pageSize  : 50,
 *     sortOn    : '+ESN'
 *   });
 *
 * ```
 *
 * @param   accountId        The account to search within.
 * @param   esn              Device ESN search terms.
 * @param   vin              Vehicle VIN search terms.
 * @param   status           Discovery state search terms, matched exactly.
 * @param   make             Vehicle make search terms.
 * @param   model            Vehicle model search terms.
 * @param   pageId           The one-based page to request.
 * @param   pageSize         The number of records per page.
 * @param   sortOn           The attribute to sort on, `+` or `-` prefixed.
 * @param   includeSubGroups Whether the search covers the whole account
 *                           hierarchy rather than the account alone.
 * @returns The matching discovery `records` and the `totalCount` which matched.
 */
export const searchVehicleDiscovery = async({
  accountId,
  esn,
  vin,
  status,
  make,
  model,
  pageId = 1,
  pageSize = 20,
  sortOn,
  includeSubGroups = false
}: VehicleDiscoverySearchParams): Promise<VehicleDiscoverySearchResult> => {
  const uri      = `/vehiclediscovery/search?pg=${pageId}&pgsize=${pageSize}`;
  const endpoint = url(uri, Service.VehicleServiceUrl);
  const search: GenericObject = {
    searchTerms : {
      accountId,
      esn,
      vin,
      status,
      make,
      model
    },
    sort : sortOn
  };
  if (includeSubGroups) {
    search.hierLevel = HierLevel.ALL;
  }
  const response = await client({
    url     : endpoint,
    method  : 'POST',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    },
    data : {search}
  });

  const {
    results = [],
    totalCount = 0
  } = response.data?.response || {};
  
  return {
    records : results,
    totalCount
  };
};

/**
 * Retrieves the Vehicle Discovery aggregation counts for an account, as reported
 * by the endpoint: the account totals alongside the per-state tallies held in the
 * `stateCounts` collection.
 *
 * ```typescript
 *
 *   import {getVehicleDiscoveryAggregations} from '@ion/core/src/services/Connect';
 *   ...
 *
 *   const {totalVehicles, stateCounts} = await getVehicleDiscoveryAggregations('8675309', true);
 *
 * ```
 *
 * @param   accountId        The account the counts are aggregated for.
 * @param   includeSubGroups Whether the counts cover the whole account hierarchy
 *                           rather than the account alone.
 * @returns The account's aggregation response.
 */
export const getVehicleDiscoveryAggregations = async(
  accountId: string,
  includeSubGroups: boolean = false
): Promise<VehicleDiscoveryAggregationsResponse> => {
  const uri      = `/vehiclediscovery/aggregations?accountId=${accountId}`;
  const endpoint = url(setHierLevel(uri, includeSubGroups), Service.VehicleServiceUrl);
  const response = await client({
    url     : endpoint,
    method  : 'GET',
    headers : {
      Authorization : `Bearer ${getSessionToken()}`
    }
  });
  return response.data?.response;
};
